// MAXH_BUNDLER_V1_DEFERRED — preamble for modules that previously
// inlined into the SPA main IIFE. They run after the IIFE has
// exposed helpers via MAXH_BUNDLER_V1_MODULE_CONTEXT in template.html.
// Aliasing window.* to local consts here lets the module sources stay
// unchanged (e.g. esc(...), INDEX_DATA.flightStats, imgUrl(p)).
//
// Note on DATA: modules that need the lazy-loaded data.json should
// read window.DATA at their entry points, since this alias is a
// snapshot at bundle-load time (DATA can be null then).
const INDEX_DATA = window.INDEX_DATA;
const esc = window.esc;
const escAttr = window.escAttr;
const rawHtml = window.rawHtml;
const html = window.maxhHtml;
const imgUrl = window.imgUrl;
const imgPicture = window.imgPicture;
const safeImg = window.safeImg;
const isVideoPath = window.isVideoPath;
const videoPosterPath = window.videoPosterPath;
const videoUrl = window.videoUrl;
const videoTileUrl = window.videoTileUrl;
const galleryItemHtml = window.galleryItemHtml;
// MAXH_BASEMAP_TILES_V1 — place-map-preview's Leaflet tile source.
const basemapLayers = window.maxhBasemapLayers;
const loadData = window.loadData || (() => Promise.resolve(window.DATA));
// MAXH_JSON_URL_FALLBACK_V1 — this bundle self-inits even when the main
// inline IIFE died mid-boot (old browser, injected-script crash). Several
// modules below call window.maxhJsonUrl() unguarded; an unversioned
// pass-through beats a TypeError that would abort every later module in
// this concatenated IIFE.
if (typeof window.maxhJsonUrl !== 'function') {
  window.maxhJsonUrl = function (path) { return path; };
}

;
/* MAXH_BUNDLER_V1_DEFERRED: src/js/spa/newsletter.js */
// ════════════════════════════════════════════════════════════════════
// src/js/spa/newsletter.js
// ────────────────────────────────────────────────────────────────────
// MAXH_NEWSLETTER_V1 — footer mailing-list signup (single opt-in).
//
// Self-initializing IIFE bundled into spa-features.js (DEFERRED_JS_BUNDLE).
// Wires the #newsletterForm in the footer to POST the email to the
// newsletter Worker (workers/newsletter). All UI updates use textContent —
// no innerHTML with user data, so no escaping helper is needed and the
// MAXH_ESCAPE_CONTRACT_V1 gate stays green.
// The form lives inside the postcard card (.footer-signup): success adds
// .is-sent (postmark animation), errors add .fs-shake (card rattle).
// ════════════════════════════════════════════════════════════════════
(function () {
  'use strict';

  var ENDPOINT = 'https://newsletter.maxandhailey.com/subscribe';
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  var form = document.getElementById('newsletterForm');
  if (!form) return;
  var input = document.getElementById('newsletterEmail');
  var statusEl = document.getElementById('newsletterStatus');
  var btn = form.querySelector('.footer-signup-btn');
  var card = form.closest('.footer-signup');

  function shake() {
    if (!card) return;
    card.classList.remove('fs-shake');
    void card.offsetWidth; // restart the animation on repeat errors
    card.classList.add('fs-shake');
  }

  function setStatus(msg, kind) {
    if (!statusEl) return;
    statusEl.textContent = msg || '';
    statusEl.hidden = !msg;
    if (kind) statusEl.setAttribute('data-kind', kind);
    else statusEl.removeAttribute('data-kind');
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = ((input && input.value) || '').trim();
    if (!EMAIL_RE.test(email)) {
      setStatus('Please enter a valid email address.', 'err');
      shake();
      if (input) input.focus();
      return;
    }
    var honeypot = form.querySelector('input[name="company"]');
    setStatus('Subscribing…', '');
    if (btn) btn.disabled = true;

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, company: honeypot ? honeypot.value : '' }),
    })
      .then(function (r) {
        return r
          .json()
          .catch(function () {
            return {};
          })
          .then(function (j) {
            return { ok: r.ok, body: j };
          });
      })
      .then(function (res) {
        if (res.ok && res.body && res.body.ok) {
          form.reset();
          if (input) input.disabled = true;
          if (btn) btn.textContent = 'Sent ✓';
          if (card) card.classList.add('is-sent');
          setStatus('You’re on the list — check your inbox for a hello. ✦', 'ok');
          // MAXH_GA_NEWSLETTER_SIGNUP_V1 — GA4 key event for a *confirmed*
          // subscribe (the auto-collected form_start only proxies form
          // interaction). Same guarded pattern as MAXH_GA_GMAPS_CLICK_V1:
          // analytics must never break the signup flow.
          try {
            if (typeof window.gtag === 'function') {
              window.gtag('event', 'newsletter_signup', { method: 'footer_postcard' });
            }
          } catch (e) {}
        } else {
          setStatus(
            (res.body && res.body.error) || 'Something went wrong — please try again.',
            'err'
          );
          shake();
          if (btn) btn.disabled = false;
        }
      })
      .catch(function () {
        setStatus('Network error — please try again in a moment.', 'err');
        shake();
        if (btn) btn.disabled = false;
      });
  });
})();

;
/* MAXH_BUNDLER_V1_DEFERRED: src/js/spa/features/home-globe.js */
// ════════════════════════════════════════════════════════════════════
// src/js/spa/features/home-globe.js
// ────────────────────────────────────────────────────────────────────
// MAXH_FLIGHT_GLOBE_V1 — replaces the prior canvas globe (globe.js)
// with a globe.gl + three.js implementation that layers:
//   • country dots (status: visited / ondeck / upcoming) — clickable
//   • airport dots (every airport touched by a flight, all-time)
//   • flight arcs since trip start, with thickness by repeat-count
// Modal click target is the existing #globeSelect element (mirrors the
// prior globe). Arcs reuse the same sheet with route-specific content.
//
// Lazy: nothing here loads until IntersectionObserver fires on
// #globeSec (rootMargin 200px). On intersect we inject the vendor
// scripts (~2 MB total) sequentially, fetch /flight_globe_data.json,
// then mount.
//
// IMPORTANT — this file is inlined into template.html via build.py's
// MAXH_INLINE_JS_FEATURES_GLOBE manifest entry. It IS its own IIFE,
// running at top level after first paint. INDEX_DATA / document /
// window / loadRouteCSS are all available.
//
// Header comments avoid the literal close-tag forms of s-c-r-i-p-t /
// s-t-y-l-e wrapped in angle brackets. See CLAUDE.md §15.4.
// ════════════════════════════════════════════════════════════════════
(function initHomeFlightGlobe() {
  const sec = document.getElementById('globeSec');
  if (!sec) return;

  // MAXH_FLIGHT_GLOBE_RECORDS_V1 — populate the overlay's Records panel
  // from the same INDEX_DATA.flightStats aggregate the About-page popup
  // reads. Trip-era only, doesn't change with the year filter (records
  // are records). Runs immediately so the panel is filled before the
  // globe section scrolls into view; silent no-op if flightStats is
  // missing (e.g. Flighty CSV absent in dev).
  (function fillRecords() {
    const fs = (window.INDEX_DATA && window.INDEX_DATA.flightStats) || null;
    if (!fs) return;
    const setRow = (key, route, meta) => {
      const row = sec.querySelector('.fg-record[data-record="' + key + '"]');
      if (!row) return;
      const r = row.querySelector('.fg-record-route');
      const m = row.querySelector('.fg-record-meta');
      if (r) r.textContent = route || '—';
      if (m) m.textContent = meta || '';
    };
    const metaFor = (rec) =>
      [
        rec.miles ? rec.miles.toLocaleString() + ' mi' : '',
        rec.duration,
        rec.carrier ? rec.carrier + (rec.num ? ' ' + rec.num : '') : '',
      ]
        .filter(Boolean)
        .join(' · ');
    if (fs.longest) setRow('longest', fs.longest.route, metaFor(fs.longest));
    if (fs.shortest) setRow('shortest', fs.shortest.route, metaFor(fs.shortest));
    const flightsForAirport = typeof fs.total_flights === 'number' ? fs.total_flights : 0;
    if (flightsForAirport > 0) {
      const airportHours = flightsForAirport * 3;
      const airportDays = Math.round(airportHours / 24);
      setRow(
        'airport-time',
        airportHours.toLocaleString() + 'h',
        airportDays >= 1 ? airportDays + (airportDays === 1 ? ' day' : ' days') : ''
      );
    }
  })();

  const stage = document.getElementById('fgStage');
  const mount = document.getElementById('fgCanvas');
  const sheet = document.getElementById('globeSelect');
  if (!stage || !mount || !sheet) return;

  const nameEl = sheet.querySelector('.globe-select-name');
  const metaEl = sheet.querySelector('.globe-select-meta');
  const statusEl = sheet.querySelector('.globe-select-status');
  const linkEl = sheet.querySelector('.globe-select-link');
  const closeBtn = sheet.querySelector('.globe-select-close');
  const backdrop = document.getElementById('globeBackdrop');

  const dataUrl = window.maxhJsonUrl(sec.dataset.dataUrl || '/flight_globe_data.json');

  let mounted = false;
  let closeGuardUntil = 0;
  // Globe reference captured by mountGlobe; showSheet/closeSheet reach for
  // it so the globe pauses while a modal is open.
  let globe = null;

  // Pause auto-rotate AND user interaction (zoom/drag) so the selected
  // dot stays under the modal. Re-enable on close. This also resets
  // OrbitControls' internal pointer state, which otherwise gets stuck
  // after a tap that opens the modal — the symptom users reported as
  // "pinch zoom stops working after clicking an arc".
  function lockGlobe() {
    if (!globe || !globe.controls) return;
    const c = globe.controls();
    c.autoRotate = false;
    c.enabled = false;
  }
  function unlockGlobe() {
    if (!globe || !globe.controls) return;
    const c = globe.controls();
    c.enabled = true;
    c.autoRotate = true;
  }

  // MAXH_NAV_INP_V1 — exposed to template.html's nav-toggle so the mobile
  // menu can pause the globe while it's open. Auto-rotate generates per-
  // frame work on the main thread (orbit-controls update + three-globe
  // redraw); if that runs concurrently with the menu's position:fixed
  // scroll lock the resulting reflow blows up INP to several seconds.
  // No-op if the globe never mounted (non-home deep link, failed init).
  window.maxhGlobePause = function (pause) {
    if (!globe || !globe.controls) return;
    const c = globe.controls();
    c.autoRotate = !pause;
  };

  function showSheet() {
    sheet.classList.add('mounted');
    void sheet.offsetWidth;
    sheet.classList.add('visible');
    if (backdrop) backdrop.classList.add('visible');
    closeGuardUntil = performance.now() + 350;
    lockGlobe();
  }
  function closeSheet(force) {
    if (!force && performance.now() < closeGuardUntil) return;
    sheet.classList.remove('visible');
    if (backdrop) backdrop.classList.remove('visible');
    unlockGlobe();
  }
  if (closeBtn) closeBtn.addEventListener('click', () => closeSheet(true));
  if (backdrop)
    backdrop.addEventListener('pointerdown', (e) => {
      e.preventDefault();
      closeSheet();
    });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSheet(true);
  });
  // Closing on link tap lets the SPA router handle the country hash.
  if (linkEl) linkEl.addEventListener('click', () => closeSheet(true));
  // The sheet lives in the persistent chrome outside the SPA route
  // containers, so a hashchange (back button, swipe-back, in-app link
  // that bypasses linkEl) would otherwise leave it pinned to the
  // viewport over the next page.
  window.addEventListener('hashchange', () => closeSheet(true));

  function openCountrySheet(p) {
    nameEl.innerHTML = '<span>' + esc(p.flag || '') + '</span>' + esc(p.name);
    const bits = [];
    if (p.continent) bits.push(esc(p.continent));
    if (p.status === 'visited' && p.m) bits.push(esc(p.m));
    if ((p.status === 'ondeck' || p.status === 'upcoming') && p.date) {
      bits.push(esc(String(p.date).slice(0, 10)));
    }
    metaEl.innerHTML = bits.join(' &middot; ');
    statusEl.className = 'globe-select-status status-' + p.status;
    statusEl.textContent =
      p.status === 'visited'
        ? 'Visited'
        : p.status === 'ondeck'
          ? 'On deck · next 6 weeks'
          : 'Upcoming';
    if (p.slug) {
      linkEl.style.display = 'inline-flex';
      linkEl.setAttribute('href', '#country/' + p.slug);
      linkEl.setAttribute('data-slug', p.slug);
      linkEl.setAttribute('data-nav', 'country');
      linkEl.textContent = 'Open country page →';
    } else {
      linkEl.style.display = 'none';
    }
    showSheet();
  }
  function openFlightSheet(f) {
    nameEl.innerHTML =
      '<span style="font-size:0.85em">&#9992;</span> ' + esc(f.from) + ' &rarr; ' + esc(f.to);
    const dt = new Date(f.date + 'T00:00:00Z');
    const dateStr = dt.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC',
    });
    const bits = [dateStr];
    if (f.airline) {
      bits.push(esc(f.airline) + (f.flight ? ' ' + esc(f.flight) : ''));
    }
    bits.push(f.miles.toLocaleString() + ' mi');
    metaEl.innerHTML = bits.join(' &middot; ');
    statusEl.className = 'globe-select-status status-flight';
    statusEl.textContent = f.routeCount > 1 ? 'Flown ' + f.routeCount + '×' : 'One-time route';
    // No country page to open — hide CTA on flight clicks.
    linkEl.style.display = 'none';
    showSheet();
  }

  // Load a script once and resolve when ready. Errors reject so the
  // mount fallback can fail visibly (rather than half-init silently).
  const loaded = new Map();
  function loadScript(url) {
    if (loaded.has(url)) return loaded.get(url);
    const p = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = url;
      s.async = true;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error('Failed to load ' + url));
      document.head.appendChild(s);
    });
    loaded.set(url, p);
    return p;
  }

  // MAXH_FLIGHT_GLOBE_V1_READY_FALLBACK — gate overlay reveal on the
  // canvas actually painting. The loader fills the stage until either
  // markReady or markFallback runs; the CSS hides it the moment either
  // class lands. Both helpers are idempotent so a late success after a
  // fallback paint is fine.
  function ensureLoader() {
    if (stage.querySelector('.fg-loader')) return;
    const loader = document.createElement('div');
    loader.className = 'fg-loader';
    loader.setAttribute('aria-hidden', 'true');
    loader.innerHTML =
      '<div class="fg-loader-ring"></div>' +
      '<div class="fg-loader-label">Loading globe&hellip;</div>';
    stage.insertBefore(loader, stage.firstChild);
    const fallback = document.createElement('div');
    fallback.className = 'fg-fallback-msg';
    fallback.setAttribute('role', 'status');
    fallback.innerHTML =
      '<div class="fg-fallback-h">Globe didn&rsquo;t load</div>' +
      '<div>Refresh the page to try again.</div>';
    stage.insertBefore(fallback, stage.firstChild);
  }
  function markReady() {
    sec.classList.remove('fg-fallback');
    sec.classList.add('fg-ready');
  }
  function markFallback(reason) {
    if (sec.classList.contains('fg-ready')) return;
    sec.classList.add('fg-fallback');
    if (reason) console.warn('[home-globe] fallback:', reason);
  }

  async function mountGlobe() {
    if (mounted) return;
    mounted = true;

    // Inject the loader before anything async so the user sees a spinner
    // instead of an empty stage while vendor scripts / data download.
    ensureLoader();

    // CSS first — the canvas size depends on the chrome being laid out.
    // (template.html's preloadInitialRouteCSS already kicked this off
    // when the initial route was the homepage; this is a no-op in the
    // common case but matters for cross-route navigation back to home.)
    try {
      if (typeof window.loadRouteCSS === 'function') {
        await window.loadRouteCSS('home-globe');
      }
    } catch (_) {
      /* the link tag still injects if loadRouteCSS errors mid-flight */
    }

    // Belt-and-suspenders: if nothing has painted within ~7 s, flip
    // to fallback so the user isn't staring at a blank stage. The
    // poster is already visible behind any in-flight WebGL setup, but
    // the legend / "Static map view" subtitle only appear once we
    // commit to the fallback.
    const fallbackTimer = setTimeout(() => markFallback('init timeout'), 7000);
    const clearFallbackTimer = () => clearTimeout(fallbackTimer);

    // Vendor JS — globe.gl.min.js is the standalone UMD bundle (v2.27.3):
    // it already contains its own Three.js + three-globe, so a separate
    // three.min.js / three-globe.min.js load was pure duplication (~1 MB).
    // It also tripped Three's dedup guard — the bundle's Three saw
    // window.__THREE__ already set by the standalone three.min.js and logged
    // "WARNING: Multiple instances of Three.js being imported." Every
    // globe.gl module falls back to its bundled classes when window.THREE is
    // absent (`window.THREE ? window.THREE : {…}`), so the one file is fully
    // self-contained.
    try {
      await loadScript('/assets/vendor/globe.gl.min.js');
    } catch (e) {
      clearFallbackTimer();
      markFallback('vendor load failed: ' + (e && e.message));
      return;
    }

    let payload;
    try {
      const resp = await fetch(dataUrl, { credentials: 'omit' });
      payload = await resp.json();
    } catch (e) {
      clearFallbackTimer();
      markFallback('data fetch failed: ' + (e && e.message));
      return;
    }

    const flights = payload.flights || [];
    const airports = payload.airports || [];
    const countries = payload.countries || [];
    const stats = payload.stats || {};

    countries.forEach((c) => (c.kind = 'country'));
    airports.forEach((a) => (a.kind = 'airport'));

    // Read site palette so JS-set colors track dark mode.
    function readPalette() {
      const cs = getComputedStyle(document.documentElement);
      return {
        paper: (cs.getPropertyValue('--paper') || '#f4ede1').trim(),
        stamp: (cs.getPropertyValue('--stamp') || '#b2401c').trim(),
        ink: (cs.getPropertyValue('--ink') || '#1a1a1a').trim(),
        faded: (cs.getPropertyValue('--faded') || '#8a7f6e').trim(),
      };
    }
    let palette = readPalette();
    const pointColor = (d) => {
      if (d.kind === 'country') {
        if (d.status === 'visited') return palette.stamp;
        if (d.status === 'ondeck') return palette.stamp;
        return palette.faded;
      }
      // Airport dots: warm cream so they pop against ocean blue AND
      // land brown. Ink/faded got swallowed by the continents.
      return '#fff4d8';
    };
    const arcColor = () => ['rgba(184,70,42,0)', palette.stamp, 'rgba(184,70,42,0)'];

    // NASA Blue Marble texture (self-hosted at /assets/img/) gives the
    // globe instant continent recognition — arcs land in places people
    // can place. MAXH_FLIGHT_GLOBE_V1_MOBILE_TEXTURE — phones render
    // the globe at ~400 px; a 1024×512 webp (~55 KB) is visually
    // indistinguishable there from the 2560×1280 desktop variant
    // (~290 KB), so pick the right one for the viewport. Matches the
    // template.html prefetch script (MAXH_FLIGHT_GLOBE_PREFETCH_V4 —
    // same 720px breakpoint) so the correct file is already in cache
    // by the time mountGlobe fires.
    const isMobileViewport = window.innerWidth <= 720;
    const globeTextureUrl = isMobileViewport
      ? '/assets/img/earth-blue-marble-1024.webp'
      : '/assets/img/earth-blue-marble.webp';
    try {
      globe = window
        .Globe()(mount)
        .backgroundColor(palette.paper)
        .globeImageUrl(globeTextureUrl)
        .showAtmosphere(true)
        .atmosphereColor(palette.stamp)
        .atmosphereAltitude(0.18)
        .pointAltitude((d) => (d.kind === 'country' ? 0.001 : 0.008))
        .pointRadius((d) => {
          if (d.kind === 'country') return d.status === 'visited' ? 0.55 : 0.45;
          return 0.18 + Math.min(0.45, (d.count || 1) / 25);
        })
        .pointColor(pointColor)
        .pointLabel((d) => {
          if (d.kind === 'country') {
            const lbl =
              d.status === 'visited' ? 'Visited' : d.status === 'ondeck' ? 'On deck' : 'Planned';
            return tip(
              `<b>${d.flag || ''} ${esc(d.name)}</b><br/><span style="color:${palette.faded};font-size:11px">${lbl}${d.date ? ' · ' + esc(String(d.date).slice(0, 10)) : ''}</span>`
            );
          }
          return tip(
            `<b>${esc(d.code)}</b><br/><span style="color:${palette.faded};font-size:11px">${d.count} flight${d.count === 1 ? '' : 's'}</span>`
          );
        })
        .arcStartLat('fromLat')
        .arcStartLng('fromLng')
        .arcEndLat('toLat')
        .arcEndLng('toLng')
        .arcColor(arcColor)
        .arcDashLength(0.6)
        .arcDashGap(0.4)
        .arcDashInitialGap(() => Math.random())
        .arcDashAnimateTime((d) => 2000 + (d?.miles || 1000) * 0.4)
        .arcStroke((d) => 0.7 + Math.log2(d?.routeCount || 1) * 0.5)
        .arcAltitudeAutoScale(0.5)
        .arcLabel((d) =>
          tip(
            `<b>${esc(d.from)} &rarr; ${esc(d.to)}</b><br/><span style="color:${palette.faded};font-size:11px">${esc(d.date)} · ${esc(d.airline || '')}${d.flight ? ' ' + esc(d.flight) : ''} · ${d.miles.toLocaleString()} mi${d.routeCount > 1 ? ` · flown ${d.routeCount}×` : ''}</span>`
          )
        )
        .onPointClick((d) => {
          if (d && d.kind === 'country') openCountrySheet(d);
        })
        .onArcClick((d) => {
          if (d) openFlightSheet(d);
        });

      function tip(inner) {
        return `<div style="background:${palette.paper};color:${palette.ink};padding:6px 10px;border-radius:4px;font-family:Georgia,serif;font-size:13px;border:1px solid rgba(0,0,0,0.1)">${inner}</div>`;
      }

      function applyThemePalette() {
        palette = readPalette();
        globe
          .backgroundColor(palette.paper)
          .atmosphereColor(palette.stamp)
          .pointColor(pointColor)
          .arcColor(arcColor);
      }

      const darkModeQuery =
        typeof window.matchMedia === 'function'
          ? window.matchMedia('(prefers-color-scheme: dark)')
          : null;
      if (darkModeQuery) {
        const refreshTheme = () => requestAnimationFrame(applyThemePalette);
        if (typeof darkModeQuery.addEventListener === 'function') {
          darkModeQuery.addEventListener('change', refreshTheme);
        } else if (typeof darkModeQuery.addListener === 'function') {
          darkModeQuery.addListener(refreshTheme);
        }
      }

      const sizeGlobe = () => {
        const r = mount.getBoundingClientRect();
        globe.width(r.width).height(r.height);
      };
      sizeGlobe();
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(sizeGlobe).observe(mount);
      }

      const ctrls = globe.controls();
      ctrls.autoRotate = true;
      ctrls.autoRotateSpeed = 0.25;
      ctrls.rotateSpeed = 0.8;
      // Snappier pinch-zoom on mobile — globe.gl's defaults are tuned
      // for a 4-finger desktop-mouse setup: zoomSpeed=0.33 with a
      // maxDistance of 10000 means a phone user has to pinch-out across
      // most of the screen before the camera moves a noticeable amount.
      // Tighten maxDistance to "just past the default altitude" and
      // bump zoomSpeed; reapply on the next frame so we win the race
      // against globe.gl's internal init.
      const applyZoomTuning = () => {
        ctrls.zoomSpeed = 2.0;
        ctrls.maxDistance = 500;
        ctrls.minDistance = 110;
      };
      applyZoomTuning();
      requestAnimationFrame(applyZoomTuning);
      setTimeout(applyZoomTuning, 800);
      // Start centered on Europe/Mediterranean so the first frame already
      // shows a dense visited region. Pass duration 0 so the camera lands
      // there immediately — the default ~1 s transition produced a jerky
      // "zoom-in" feel on first paint as the texture finished loading.
      // Altitude 2.1 fills the stage with the sphere while leaving room
      // for the flight-arc apexes (which sit ~0.5 globe-radii above the
      // surface at their highest point). 1.8 was too close — the
      // furthest arcs clipped past the viewport edges. On mobile (narrow
      // portrait viewport), the same altitude pushes the sphere edge-to-
      // edge and clips arcs on the sides — lift the camera further so
      // the sphere is ~80% of the viewport width and arcs stay visible.
      const initialAltitude = window.innerWidth <= 720 ? 2.8 : 2.1;
      globe.pointOfView({ lat: 45, lng: 12, altitude: initialAltitude }, 0);

      // ── Scroll-passthrough zones at left/right 20% of the canvas.
      // Create them AFTER globe.gl mounts — three-globe clears the
      // mount element during init, so any zones authored statically in
      // the template HTML get wiped. Inserting them here guarantees
      // they exist AND sit last in #fgCanvas (so they stack above the
      // WebGL canvas and catch edge gestures before OrbitControls).
      for (const side of ['left', 'right']) {
        const zone = document.createElement('div');
        zone.className = 'fg-scroll-zone fg-scroll-zone-' + side;
        zone.setAttribute('aria-hidden', 'true');
        mount.appendChild(zone);
      }

      // ── Year + Upcoming filter pills ─────────────────────────────
      const past = flights.filter((f) => !f.upcoming);
      const future = flights.filter((f) => f.upcoming);
      const years = [...new Set(past.map((f) => f.year))].sort();
      const byYear = years.reduce(
        (acc, y) => ((acc[y] = past.filter((f) => f.year === y)), acc),
        {}
      );

      const filterBar = sec.querySelector('.fg-filters');
      function pill(label, count, value, active, extra) {
        const b = document.createElement('button');
        b.className = 'fg-pill' + (active ? ' active' : '') + (extra ? ' ' + extra : '');
        b.dataset.year = value;
        b.innerHTML = esc(label) + '<span class="ct">' + count + '</span>';
        filterBar.appendChild(b);
        return b;
      }
      pill('All', past.length, 'all', true);
      years.forEach((y) => pill(String(y), byYear[y].length, String(y), false));
      if (future.length) {
        const sep = document.createElement('span');
        sep.className = 'fg-filters-sep';
        filterBar.appendChild(sep);
        pill('✈ Upcoming', future.length, 'upcoming', false, 'fg-pill-upcoming');
      }
      filterBar.addEventListener('click', (e) => {
        const t = e.target.closest('.fg-pill');
        if (!t) return;
        filterBar
          .querySelectorAll('.fg-pill')
          .forEach((p) => p.classList.toggle('active', p === t));
        apply(t.dataset.year);
      });

      const statFlights = sec.querySelector('[data-stat="flights"]');
      const statAirports = sec.querySelector('[data-stat="airports"]');
      const statMiles = sec.querySelector('[data-stat="miles"]');
      const subtitle = sec.querySelector('.fg-subtitle');

      // Extract a 4-digit year from a country's `m` ("Sep 2024") or `date`
      // ("2026-04-25") field. Visited posts populate `m`; ondeck/upcoming
      // populate `date`. Returns null if neither parses.
      function countryYear(c) {
        if (c.status === 'visited' && c.m) {
          const m = c.m.match(/\d{4}/);
          if (m) return parseInt(m[0], 10);
        }
        if (c.date) {
          const y = parseInt(String(c.date).slice(0, 4), 10);
          if (!Number.isNaN(y)) return y;
        }
        return null;
      }

      // MAXH_FLIGHT_GLOBE_V1_PROGRESSIVE_ARCS — first apply() paints
      // arcs in rAF batches so the globe reveals with dots and a few
      // arcs immediately, then layers the rest of the ~400 arcs in
      // under a second. Subsequent apply() calls (filter pill clicks)
      // set arcs synchronously so the user sees the new selection
      // without a building-up animation that reads as lag.
      let firstApply = true;
      let pendingArcRaf = 0;
      function setArcs(arcs) {
        if (pendingArcRaf) {
          cancelAnimationFrame(pendingArcRaf);
          pendingArcRaf = 0;
        }
        if (!firstApply || arcs.length <= 80) {
          firstApply = false;
          globe.arcsData(arcs);
          return;
        }
        firstApply = false;
        const batchSize = 80;
        let i = batchSize;
        globe.arcsData(arcs.slice(0, i));
        function step() {
          pendingArcRaf = 0;
          const end = Math.min(i + batchSize, arcs.length);
          globe.arcsData(arcs.slice(0, end));
          i = end;
          if (i < arcs.length) pendingArcRaf = requestAnimationFrame(step);
        }
        if (i < arcs.length) pendingArcRaf = requestAnimationFrame(step);
      }

      function apply(yearVal) {
        let subset;
        if (yearVal === 'all') subset = past;
        else if (yearVal === 'upcoming') subset = future;
        else subset = byYear[yearVal] || [];

        // Filter airports to only those that appear in the active arc
        // subset, so a year pill doesn't leave pins for routes that
        // don't apply to that year. Country dots filter by visit year
        // (or by ondeck/upcoming status under the Upcoming pill).
        let subsetAirports;
        let subsetCountries;
        if (yearVal === 'all') {
          subsetAirports = airports;
          subsetCountries = countries;
        } else if (yearVal === 'upcoming') {
          const codes = new Set();
          subset.forEach((f) => {
            codes.add(f.from);
            codes.add(f.to);
          });
          subsetAirports = airports.filter((a) => codes.has(a.code));
          subsetCountries = countries.filter(
            (c) => c.status === 'ondeck' || c.status === 'upcoming'
          );
        } else {
          const yearNum = parseInt(yearVal, 10);
          const codes = new Set();
          subset.forEach((f) => {
            codes.add(f.from);
            codes.add(f.to);
          });
          subsetAirports = airports.filter((a) => codes.has(a.code));
          subsetCountries = countries.filter((c) => countryYear(c) === yearNum);
        }

        globe.pointsData([...subsetCountries, ...subsetAirports]);
        setArcs(subset);

        // Headline stats: canonical from /stats.json fields for the "All"
        // view, subset-derived for filtered views.
        if (yearVal === 'all') {
          if (statFlights) statFlights.textContent = (stats.FLIGHTS || 0).toLocaleString();
          if (statAirports)
            statAirports.textContent = (stats.AIRPORTS_VISITED || 0).toLocaleString();
          if (statMiles) statMiles.textContent = stats.MILES_FULL || '0';
        } else {
          if (statFlights) statFlights.textContent = subset.length.toLocaleString();
          const apCodes = new Set();
          subset.forEach((f) => {
            apCodes.add(f.from);
            apCodes.add(f.to);
          });
          if (statAirports) statAirports.textContent = apCodes.size.toLocaleString();
          const miles = subset.reduce((s, f) => s + (f.miles || 0), 0);
          if (statMiles) statMiles.textContent = miles.toLocaleString();
        }

        const blurb =
          (stats.VISITED_COUNT || 0) +
          ' countries visited · ' +
          (stats.PLANNED_COUNT || 0) +
          ' planned';
        if (subtitle) {
          subtitle.textContent =
            yearVal === 'all'
              ? blurb
              : yearVal === 'upcoming'
                ? 'Upcoming flights · ' + blurb
                : yearVal + ' · ' + blurb;
        }
      }

      apply('all');

      // Trap a WebGL context loss — if the browser yanks the context
      // (mobile GPU memory pressure, tab backgrounding etc.), flip to
      // the static-poster fallback so the user doesn't see a frozen
      // last-frame on top of broken legend / filter state.
      const canvas = mount.querySelector('canvas');
      if (canvas) {
        canvas.addEventListener(
          'webglcontextlost',
          function (e) {
            e.preventDefault();
            sec.classList.remove('fg-ready');
            markFallback('webgl context lost');
          },
          { once: true }
        );
      }

      clearFallbackTimer();
      // Two paints to let three-globe's first render commit before we
      // reveal the chrome — avoids a momentary "chrome over poster"
      // flicker on slow mobile GPUs.
      requestAnimationFrame(() => requestAnimationFrame(markReady));

      // Test hook for Playwright + manual inspection — never relied on
      // in production runtime.
      window.__maxhFlightGlobe = {
        openCountrySheet,
        openFlightSheet,
        closeSheet,
        apply,
        payload,
        globe,
        applyThemePalette,
        themePalette: () => ({ ...palette }),
      };

      // MAXH_FLIGHT_GLOBE_RAF_PAUSE_V1 — the auto-rotating globe drives a
      // continuous WebGL render loop, the single most expensive thing on this
      // page. Stop the loop whenever the globe can't actually be seen.
      const isAutomation = typeof navigator !== 'undefined' && navigator.webdriver;
      if (isAutomation) {
        // Software-rendered WebGL on a GPU-less CI runner pegs a core for the
        // whole e2e suite (slow globe specs + a starved, flaky viewport-jump
        // test). Playwright drives the DOM via window.__maxhFlightGlobe, not
        // globe pixels, so freeze the loop once the first frames commit.
        requestAnimationFrame(() =>
          requestAnimationFrame(() => {
            try {
              globe.pauseAnimation();
            } catch (_) {
              /* older globe.gl without pause/resume — leave it running */
            }
          })
        );
      } else if ('IntersectionObserver' in window) {
        // Real users: pause the loop when #globeSec scrolls out of view (the
        // SPA also hides #page-home on a route change, which reads as
        // not-intersecting) and resume when it returns, so a low-end phone
        // isn't burning CPU/battery rendering an unseen globe.
        const visIO = new IntersectionObserver(
          (entries) => {
            const visible = entries.some((e) => e.isIntersecting);
            try {
              if (visible) globe.resumeAnimation();
              else globe.pauseAnimation();
            } catch (_) {
              /* no-op if pause/resume is unavailable */
            }
          },
          { rootMargin: '0px' }
        );
        visIO.observe(sec);
      }
    } catch (e) {
      clearFallbackTimer();
      markFallback('globe init failed: ' + (e && e.message));
    }
  }

  // Render the loader up front so the section never sits as a blank
  // beige rectangle between page load and mountGlobe() firing.
  ensureLoader();

  // MAXH_FLIGHT_GLOBE_EAGER_V2 — for real browsers, start mountGlobe
  // as soon as the home page settles instead of waiting for the user
  // to scroll the section to within 200 px of the viewport. The
  // MAXH_FLIGHT_GLOBE_PREFETCH_V1 link tags in <head> already pull
  // the ~1 MB of vendor scripts + the earth texture into the cache
  // during page idle, so by the time this fires the scripts execute
  // from cache and the globe is drawn before the user gets past the
  // hero. Gated on !navigator.webdriver: Playwright workers stub out
  // requestIdleCallback and run several browser contexts against the
  // same single-threaded dev server, so eager mount × N workers
  // overwhelms the queue with simultaneous globe asset fetches and
  // crashes the mobile-menu test. Automation falls through to the
  // IntersectionObserver below — which fires immediately in CI
  // anyway thanks to the initial-layout race on a y=0 #globeSec.
  // Route gate (2026-07-07 audit): #globeSec lives in the persistent home
  // DOM, so this deferred-features boot runs on EVERY route — the ungated
  // eager mount fetched flight_globe_data.json (+ executed the ~1 MB
  // vendor bundle) on pages that never show a globe. Eager applies only
  // while the session is on home; a one-shot hashchange arm restores the
  // land-elsewhere-then-go-home case, and the IO fallback below still
  // covers everything else (it only fires once the section is visible).
  const onHomeRoute = () => {
    const h = (location.hash || '').replace(/^#\/?/, '').split('?')[0].split('/')[0];
    return h === '' || h === 'home';
  };
  if (typeof navigator !== 'undefined' && !navigator.webdriver) {
    const kickEager = () => {
      try {
        mountGlobe();
      } catch (e) {
        /* IntersectionObserver below still picks it up */
      }
    };
    const scheduleEager = () => {
      if (document.readyState === 'complete') {
        // Defer one frame so we don't compete with the first paint
        // even when the SPA hydrated before this script tag ran.
        requestAnimationFrame(kickEager);
      } else {
        window.addEventListener('load', () => requestAnimationFrame(kickEager), { once: true });
      }
    };
    if (onHomeRoute()) {
      scheduleEager();
    } else {
      const armEager = () => {
        if (!onHomeRoute()) return;
        window.removeEventListener('hashchange', armEager);
        requestAnimationFrame(kickEager);
      };
      window.addEventListener('hashchange', armEager);
    }
  }

  // IntersectionObserver fallback — mount on first visibility for
  // browsers without prefetch support, deep-link-to-other-route
  // sessions, and automation. mountGlobe is idempotent so this is
  // always safe to leave on alongside the eager path above.
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            io.disconnect();
            mountGlobe();
            break;
          }
        }
      },
      { rootMargin: '200px' }
    );
    io.observe(sec);
  } else {
    mountGlobe();
  }
})();

;
/* MAXH_BUNDLER_V1_DEFERRED: src/js/spa/features/stays-hydration.js */
// ════════════════════════════════════════════════════════════════════
// src/js/spa/features/stays-hydration.js
// ────────────────────────────────────────────────────────────────────
// MAXH_REFACTOR_V1 Phase 2 — extracted from template.html.
// Stays page hydration IIFE — STAYS_DATA fetch, mounted hydration.
// Lifecycle: runs on first paint, hydrates /#stays page when navigated to.
//
// IMPORTANT — this file is inlined back into the SAME script
// block in template.html via build.py's inline SPA manifest (NOT
// the SPA main IIFE — these are separate top-level script
// blocks living after the SPA IIFE close). It IS its own IIFE,
// so no shared-closure constraint applies to its internals.
// External refs (INDEX_DATA, document, window, etc.) work
// because the script runs at top level after first paint.
//
// Header comments deliberately avoid the literal close-tag
// forms of s-c-r-i-p-t and s-t-y-l-e wrapped in angle brackets.
// See CLAUDE.md §15.4 gotchas #1 and #5.
// ════════════════════════════════════════════════════════════════════
(function () {
  // MAXH_PERF_V2_LAZY_DATA — DATA used to be read synchronously from
  // window.STAYS_DATA at IIFE entry, with an early `return` if missing.
  // Now STAYS_DATA is null in production (the inline blob was removed —
  // see null token in build.py) and ensureData() fetches it
  // from window.STAYS_DATA_URL on first call. Until ensureData() resolves
  // DATA stays null. The IIFE no longer early-returns — it just defers
  // hydration until the user actually navigates to /#stays. The mobile
  // menu's nights-count badge (was set imperatively from DATA.stats.nights
  // here) is now pre-baked into the 1,645 nights token at build,
  // so it renders correctly with no DATA.
  var DATA = window.STAYS_DATA || null;
  var page = document.getElementById('page-stays');
  if (!page) return;
  var hydrated = false;
  var dataPromise = null;

  function ensureData() {
    if (!DATA && window.STAYS_DATA) DATA = window.STAYS_DATA;
    if (DATA) return Promise.resolve(DATA);
    if (dataPromise) return dataPromise;
    if (!window.STAYS_DATA_URL) {
      return Promise.reject(new Error('STAYS_DATA missing (no inline blob, no URL)'));
    }
    dataPromise = fetch(window.STAYS_DATA_URL, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        if (!r.ok) throw new Error('STAYS_DATA fetch failed: ' + r.status);
        return r.json();
      })
      .then(function (j) {
        DATA = j;
        window.STAYS_DATA = j; // backward-compat for any external lookup
        return j;
      })
      .catch(function (e) {
        // A failure must not latch the rejection: hydrate() resets
        // `hydrated` so the next #stays nav retries, and that retry
        // needs a fresh request, not this memoized rejection.
        dataPromise = null;
        throw e;
      });
    return dataPromise;
  }

  // Helpers
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs)
      for (var k in attrs) {
        if (k === 'class') n.className = attrs[k];
        else if (k === 'html') n.innerHTML = attrs[k];
        else if (k === 'on') for (var ev in attrs.on) n.addEventListener(ev, attrs.on[ev]);
        else if (k === 'data') for (var dk in attrs.data) n.dataset[dk] = attrs.data[dk];
        else n.setAttribute(k, attrs[k]);
      }
    if (kids) {
      if (typeof kids === 'string') n.textContent = kids;
      else if (Array.isArray(kids))
        kids.forEach(function (c) {
          if (c == null) return;
          n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
        });
      else if (kids.nodeType) n.appendChild(kids);
    }
    return n;
  }
  function fmt(n) {
    if (typeof n !== 'number') return n;
    return n.toLocaleString('en-US');
  }
  function clear(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  // Resolve photo URL — handles both fully-qualified URLs and bare keys
  function photoUrl(s) {
    if (!s) return '';
    if (/^https?:\/\//i.test(s) || s.startsWith('/')) return s;
    var prefix = (window.INDEX_DATA && window.INDEX_DATA.prefix) || '';
    return prefix + s;
  }

  // MAXH_STAYS_CIR_V1 — route stays photos through the site-wide Cloudflare
  // Image Resizing helper (window.imgUrl, exposed by the SPA main IIFE) so
  // they get format=auto (AVIF/WebP) + width sizing, exactly like every
  // other route. Replaces the legacy MAXH_STAYS_BV_VARIANTS_V1 ladder, which
  // pointed <img> at pre-generated `-320/-640.jpg` originals straight from
  // R2 and bypassed CIR entirely. See docs/PERF.md §5: one canonical R2
  // source + CIR, no pre-sized variant fan-out. imgUrl resolves both bare
  // R2 keys and fully-qualified images.maxandhailey.com URLs (it strips the
  // prefix) and passes external URLs through untouched. The defensive
  // fall-back to the resolved raw URL only fires if imgUrl is somehow
  // unavailable — it is exposed during the main IIFE, before this one
  // hydrates, so in practice it always exists.
  function cirUrl(s, size) {
    if (!s) return '';
    if (typeof window.imgUrl === 'function') return window.imgUrl(s, size);
    return photoUrl(s);
  }
  function cirSrcset(s, baseSize) {
    if (!s || typeof window.imgUrl !== 'function') return '';
    var b = baseSize || 500;
    return window.imgUrl(s, b) + ' 1x, ' + window.imgUrl(s, b * 2) + ' 2x';
  }

  // ── Hero ───────────────────────────────────────────────────────────
  function hydrateHero() {
    var s = DATA.stats;
    document.getElementById('staysHeadCount').textContent = fmt(s.total);
    // Headline uses the live VISITED_COUNT so it matches the homepage; falls
    // back to the catalog-derived stays-only count when the site doesn't have
    // a baseline set.
    document.getElementById('staysHeadCountries').textContent = fmt(
      s.countriesVisited || s.countriesWithStays
    );
    document.getElementById('staysSideNum').textContent = fmt(s.total);
    document.getElementById('staysSideContinents').textContent = s.continents;
    // Time at home: Miami no-hotel nights logged since trip start.
    var homeEl = document.getElementById('staysFootHome');
    var homeN = Number(s.nightsAtHome) || 0;
    homeEl.textContent = fmt(homeN) + (homeN === 1 ? ' night' : ' nights');
    document.getElementById('staysFootNights').textContent = fmt(s.nights);
    // MAXH_STAYS_MOSTSTAYED_V1 — third tile is the country with the most
    // days on the ground, formatted as "Country · N days". Falls back
    // to a dash when the schedule + trip-stop breakdown is empty.
    // MAXH_V146_MOSTSTAYED_DAYS_UNIT — was previously labelled "N nights"
    // but the count is now inclusive days (matches the country detail
    // page's "Days on the ground" stat) so Italy reads 103 not 92 here
    // and the two stats agree across the site. Reads `msc.days` if the
    // newer build emitted it, falls back to `msc.nights` for legacy
    // payloads still cached on a CDN.
    var msc = s.mostStayedCountry;
    var mscCount = msc ? (msc.days != null ? msc.days : msc.nights) : 0;
    if (msc && msc.name && mscCount > 0) {
      document.getElementById('staysFootTotal').textContent =
        msc.name + ' · ' + fmt(mscCount) + ' days';
    } else {
      document.getElementById('staysFootTotal').textContent = '—';
    }

    // "Just checked out" cell — MAXH_STAYS_JUST_CHECKED_OUT_V1.
    // Future hotels are masked at build time (see build.py
    // mask_future_hotels), so DATA.currently/upcoming are always null.
    // The hero foot now reads off DATA.just_checked_out (most-recent past
    // stay) and falls through to the latest entry in DATA.recent_stays
    // (also past-only post-mask). Old fields kept for back-compat with
    // any cached stays_data.json that might still be on a CDN.
    var fontEl = document.getElementById('staysFootLatest');
    var fontKickerEl = document.querySelector('#page-stays .hero-foot .hf-cell:last-child .hfc-l');
    var jco = DATA.just_checked_out;
    var latest = DATA.recent_stays[0] || {};
    var heroFact, footLabel, footValue;
    if (jco && jco.hotel) {
      footLabel = 'Just checked out';
      footValue = jco.hotel + (jco.location ? ' · ' + jco.location : '');
      heroFact = { l: 'JUST CHECKED OUT', v: footValue };
    } else if (latest.hotel) {
      footLabel = 'Just checked out';
      footValue = latest.hotel + (latest.location ? ' · ' + latest.location : '');
      heroFact = { l: 'JUST CHECKED OUT', v: footValue };
    } else {
      footLabel = 'Just checked out';
      footValue = '—';
      heroFact = { l: 'JUST CHECKED OUT', v: '—' };
    }
    fontEl.textContent = footValue;
    if (fontKickerEl) fontKickerEl.textContent = footLabel;

    // Rotating "now" facts
    var facts = [heroFact];
    // brand stats
    var brands = DATA.groups || {};
    var topBrand = Object.values(brands).sort(function (a, b) {
      return b.count - a.count;
    })[0];
    if (topBrand && topBrand.count)
      facts.push({
        l: 'DEEPEST PORTFOLIO',
        v: topBrand.name + ' · ' + topBrand.count + ' of ' + topBrand.total,
      });
    var featured = DATA.featured;
    if (featured)
      facts.push({
        l: 'ROOM WE’D MOVE INTO',
        v: featured.name + (featured.country ? ' · ' + featured.country : ''),
      });
    if (DATA.top20.length) {
      var t1 = DATA.top20[0];
      facts.push({ l: 'NUMBER ONE', v: t1.name + ' · ' + (t1.country || '—') });
    }
    var lists = DATA.lists || {};
    Object.keys(lists).forEach(function (lid) {
      var L = lists[lid];
      facts.push({ l: 'LIST PROGRESS', v: L.label + ' · ' + L.visited + ' / ' + L.total });
    });

    var nowEl = document.getElementById('staysHeroNow');
    var dotsHtml = facts
      .map(function () {
        return '<i></i>';
      })
      .join('');
    nowEl.querySelector('.hn-dots').innerHTML = dotsHtml;
    var idx = 0;
    function paint() {
      var f = facts[idx];
      nowEl.querySelector('.hn-l').textContent = f.l;
      nowEl.querySelector('.hn-v').textContent = f.v;
      var dots = nowEl.querySelectorAll('.hn-dots i');
      dots.forEach(function (d, i) {
        d.classList.toggle('on', i === idx);
      });
      idx = (idx + 1) % facts.length;
    }
    paint();
    // MAXH_PERF_V1_TICKER_GATE — was: setInterval(paint, 3400) running
    // forever, even when the user is on /#home or /#wonders. Wrap in
    // IntersectionObserver + visibilitychange so the timer is only alive
    // while the hero is on-screen AND the tab is foregrounded. Same
    // pattern as the canvas globe at template.html§16953.
    var tickerInt = null,
      onScreen = !('IntersectionObserver' in window);
    function tickerUpdate() {
      var shouldRun = onScreen && document.visibilityState !== 'hidden';
      if (shouldRun && !tickerInt) tickerInt = setInterval(paint, 3400);
      else if (!shouldRun && tickerInt) {
        clearInterval(tickerInt);
        tickerInt = null;
      }
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          onScreen = entries[entries.length - 1].isIntersecting;
          tickerUpdate();
        },
        { threshold: 0 }
      );
      io.observe(nowEl);
    }
    document.addEventListener('visibilitychange', tickerUpdate);
    tickerUpdate();
  }

  // ── Featured ───────────────────────────────────────────────────────
  function hydrateFeatured() {
    var f = DATA.featured;
    var section = document.getElementById('staysFeatured');
    if (!f) {
      section.hidden = true;
      return;
    }
    section.hidden = false;

    // MAXH_STAYS_CIR_V1 — featured banner served through CIR (was a raw
    // 1920×1080 original). 1280 base src + 900/1800 density srcset feeds the
    // 4:3 .fv2-hero cover crop on standard and retina screens.
    var heroImg = cirUrl(f.photo, 1280);
    var heroSrcset = cirSrcset(f.photo, 900);
    // Prefer the admin's own review; fall back to the catalog's default
    // description (scraped from each property's og:description).
    var blurb = (f.review || f.description || '').trim();
    var firstSent = blurb.split(/(?<=[.!?])\s+/)[0] || blurb;
    var rest = blurb.slice(firstSent.length).trim();

    // Resolve a list/group id to its display label. Lists use their .label;
    // brands fall back to the group's .name (already title-cased) or, last
    // resort, a cleaned-up id.
    function listLabel(lid) {
      if (DATA.lists && DATA.lists[lid] && DATA.lists[lid].label) return DATA.lists[lid].label;
      if (DATA.groups && DATA.groups[lid] && DATA.groups[lid].name) return DATA.groups[lid].name;
      // MAXH_STAYS_FEATURED_TOP20_V1 — synthetic id emitted by
      // stays_page_data.py when the featured property is in our Top 20.
      if (lid === 'max_hailey_top20') return 'Max & Hailey · Top 20';
      // Title-case fallback for unknown ids
      return lid
        .replace(/^brand_/, '')
        .split('_')
        .map(function (w) {
          return w.charAt(0).toUpperCase() + w.slice(1);
        })
        .join(' ');
    }
    var listChips =
      (f.lists || [])
        .map(function (l) {
          return listLabel(l.id) + (l.rank ? ' #' + l.rank : '');
        })
        .join(' · ') || 'On our list';

    section.innerHTML =
      '' +
      '<div class="stays-section-head">' +
      '<h2>Currently <em>charmed</em>.</h2>' +
      '<div class="right">A room we left and have not stopped talking about. Rotates as new favorites take its place.</div>' +
      '</div>' +
      '<div class="fv2-frame">' +
      '<div class="fv2-bignum" aria-hidden="true">N°<span>01</span></div>' +
      '<div class="fv2-strip">' +
      '<span style="display:inline-block;width:7px;height:7px;border-radius:50%;background:var(--stamp);"></span>' +
      'FEATURED · EDITION OF ONE' +
      '<span class="fv2-strip-sep">/</span>' +
      '<span>filed from ' +
      esc((f.country || '').toUpperCase()) +
      ' ' +
      esc(f.flag || '') +
      '</span>' +
      '<span class="fv2-strip-sep ml-auto">/</span>' +
      '<span class="fv2-strip-end">N · ' +
      (f.continent || '').toUpperCase() +
      '</span>' +
      '</div>' +
      '<div class="fv2-grid">' +
      '<div class="fv2-hero">' +
      (heroImg
        ? '<img src="' +
          heroImg +
          '"' +
          (heroSrcset ? ' srcset="' + heroSrcset + '"' : '') +
          ' alt="' +
          escAttr(f.name) +
          '" loading="lazy" decoding="async"/>'
        : '') +
      '<div class="fv2-hero-tl">FEATURED PROPERTY</div>' +
      '<div class="fv2-hero-br">' +
      esc((f.country || '').toUpperCase()) +
      ' ' +
      esc(f.flag || '') +
      '</div>' +
      '</div>' +
      '<div class="fv2-body">' +
      '<div class="fv2-kicker">— Featured property —</div>' +
      '<h3 class="fv2-title"' +
      (DATA.place_ids && DATA.place_ids[f.id]
        ? ' data-tb-id="' +
          escAttr(DATA.place_ids[f.id]) +
          '" data-tb-name="' +
          escAttr(f.name || '') +
          '"'
        : '') +
      '>' +
      esc(f.name) +
      '</h3>' +
      '<div class="fv2-loc">' +
      (f.city ? '<span>' + esc(f.city) + '</span><span class="dotsep">·</span>' : '') +
      '<span>' +
      esc(f.country || '') +
      '</span>' +
      (f.continent ? '<span class="dotsep">·</span><span>' + esc(f.continent) + '</span>' : '') +
      '</div>' +
      (firstSent
        ? '<div class="fv2-pull"><span class="fv2-quote-mark">“</span><p>' +
          esc(firstSent) +
          '</p></div>'
        : '<div class="fv2-pull"><span class="fv2-quote-mark">“</span><p style="color:rgba(var(--paper-rgb),0.5);font-style:italic;">Review coming soon.</p></div>') +
      (rest ? '<p class="fv2-rest">' + esc(rest) + '</p>' : '') +
      '<div class="fv2-dossier">' +
      '<div class="fv2-dossier-head">— The dossier —</div>' +
      '<div class="fv2-dossier-rows">' +
      '<div><span class="dl">Lists</span><span class="dv">' +
      esc(listChips) +
      '</span></div>' +
      '</div>' +
      '</div>' +
      (f.country_slug
        ? '<a href="#country/' +
          f.country_slug +
          '" data-nav="country" data-slug="' +
          f.country_slug +
          '" style="margin-top:8px;font-family:var(--mono);font-size:10px;letter-spacing:0.2em;text-transform:uppercase;color:var(--stamp);">Country page →</a>'
        : '') +
      '</div>' +
      '</div>' +
      '</div>';

    // MAXH_STAYS_DOSSIER_EVERYWHERE_V1 — the featured photo opens the
    // shared dossier too, so the interaction is uniform across the page.
    // `stayed` defaults to true for cached payloads that predate the
    // field (the featured pick is by definition a room we stayed in).
    var heroEl = section.querySelector('.fv2-hero');
    if (heroEl) {
      wireDossier(
        heroEl,
        {
          name: f.name,
          city: f.city,
          country: f.country,
          continent: f.continent,
          photo: f.photo,
          review: f.review,
          description: f.description,
          country_slug: f.country_slug,
          stayed: f.stayed == null ? true : !!f.stayed,
        },
        {
          tag: 'M&H · FEATURED',
          kicker: '★ · FEATURED PROPERTY · EDITION OF ONE',
          category: 'Featured property',
          entry: '—',
        }
      );
    }
  }

  // ── Top 20 ─────────────────────────────────────────────────────────
  // MAXH_STAYS_TOP20_DETAIL_V1 — clicking a row opens a centered modal
  // styled after the Food & Drink page's `card-pop` (paper card with
  // stamp-orange corner brackets, dark mono header, serif name).
  // Replaces the previous inline `top30-expand` accordion. The modal
  // is rendered once per page-hydrate and reused — only its content
  // changes between clicks.
  // MAXH_T20_STAR_MARK_V1 — same inline star as the food-drink Top-list
  // headers: a text "★" falls back to a system font (the webfonts lack
  // U+2605) and drifts off-center per device; the SVG centers cleanly.
  function staysT20Star() {
    return (
      '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
      '<path d="M12 2.95 L14.47 9.55 L21.51 9.86 L16 14.25 L17.88 21.04 L12 17.15 L6.12 21.04 L8 14.25 L2.49 9.86 L9.53 9.55 Z"/>' +
      '</svg>'
    );
  }
  function hydrateTop20() {
    var section = document.getElementById('staysTop20');
    // MAXH_STAYS_TOP20_BARSPARITY_V1 — header now mirrors the food-drink
    // Top 20 Bars header exactly: italic star "mark" with dashed frame,
    // MAX & HAILEY badge above the headline, blurb on the right. Same
    // structure on mobile, where it stacks single-column.
    var emptyHead =
      '' +
      '<header class="stays-top20-head">' +
      '<div class="t20s-left">' +
      '<div class="t20s-mark">' +
      staysT20Star() +
      '</div>' +
      '<div>' +
      '<div class="t20s-badge">MAX & HAILEY</div>' +
      '<h2><em>Top 20</em> <i>hotels</i>.</h2>' +
      '</div>' +
      '</div>' +
      '<div class="t20s-meta">Pick 20 favorites in admin to populate this list.</div>' +
      '</header>';
    if (!DATA.top20.length) {
      section.innerHTML = emptyHead;
      return;
    }
    var head =
      '' +
      '<header class="stays-top20-head">' +
      '<div class="t20s-left">' +
      '<div class="t20s-mark">' +
      staysT20Star() +
      '</div>' +
      '<div>' +
      '<div class="t20s-badge">MAX & HAILEY</div>' +
      '<h2><em>Top 20</em> <i>hotels</i>, ranked.</h2>' +
      '</div>' +
      '</div>' +
      '<div class="t20s-meta">The 20 rooms we’d point any traveler to first. Click any line for the dossier.</div>' +
      '</header>';
    // MAXH_STAYS_TOP20_ROW_V4 — bars-parity row layout:
    // [rank/HOTEL eyebrow] [name] [city/country meta] [→ caret].
    var rows = DATA.top20
      .map(function (h, i) {
        var n = String(i + 1).padStart(2, '0');
        var city = h.city ? esc(h.city) : '—';
        var country = h.country ? esc(h.country) : h.continent ? esc(h.continent) : '';
        return (
          '' +
          '<div class="top30-row" data-idx="' +
          i +
          '" role="button" tabindex="0">' +
          '<div class="t30-rank"><b>' +
          n +
          '</b><span>HOTEL</span></div>' +
          '<div class="t30-name"' +
          (DATA.place_ids && DATA.place_ids[h.id]
            ? ' data-tb-id="' +
              escAttr(DATA.place_ids[h.id]) +
              '" data-tb-name="' +
              escAttr(h.name || '') +
              '"'
            : '') +
          '>' +
          esc(h.name) +
          '</div>' +
          '<div class="t30-loc">' +
          '<span class="rl-city">' +
          city +
          '</span>' +
          '<span class="rl-country">' +
          country +
          '</span>' +
          '</div>' +
          '<div class="t30-caret" aria-hidden="true">→</div>' +
          '</div>'
        );
      })
      .join('');
    section.innerHTML = head + '<div class="top30-list">' + rows + '</div>';

    // Wire each row to the shared dossier pair (hover card + modal).
    section.querySelectorAll('.top30-row').forEach(function (row) {
      var idx = parseInt(row.dataset.idx, 10);
      var h = DATA.top20[idx];
      if (!h) return;
      wireDossier(row, h, top20Ctx(idx));
    });
  }

  function top20Ctx(i) {
    var rank = String(i + 1).padStart(2, '0');
    return {
      tag: 'M&H · TOP 20',
      kicker: 'MAX & HAILEY TOP 20 · N°' + rank,
      category: 'Max & Hailey · Top 20',
      entry: '№ ' + rank,
    };
  }

  // ── Property dossier (shared hover card + detail modal) ────────────
  // MAXH_STAYS_DOSSIER_EVERYWHERE_V1 — the Top 20's detail modal
  // (MAXH_STAYS_TOP20_DETAIL_V1) and hover dossier card
  // (MAXH_STAYS_TOP20_HOVERPOP_V1) are shared by every property on the
  // page: Top 20 rows, Big Lists items, brand-group property rows, Best
  // Views windows, and the featured photo. `ctx` carries the
  // section-specific labels:
  //   tag      — modal header strip + hover card kind line
  //   kicker   — modal hero eyebrow above the name
  //   category — CATEGORY cell in the field grid
  //   entry    — REGISTER ENTRY cell + the hover card's RANK line
  var detailModalEl = null;
  function ensureDetailModal() {
    if (detailModalEl) return detailModalEl;
    var modal = document.getElementById('staysDetailModal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'staysDetailModal';
      modal.className = 'stays-detail-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-hidden', 'true');
      // MAXH_STAYS_MODAL_BARSPARITY_V1 — structure mirrors the food/drink
      // DetailDrawer exactly: header strip, hero panel with framed photo
      // tile + serif name + italic sub + sea-green stamp pill, 6-cell
      // grid, and a stamp-orange opening/closing curly-quote narrative.
      modal.innerHTML =
        '<div class="stays-detail-backdrop"></div>' +
        '<aside class="stays-detail-card" role="document">' +
        '<div class="sd-inner">' +
        '<header class="sd-header">' +
        '<div class="sd-h-left">' +
        '<span class="sd-tag">M&H · TOP 20</span>' +
        '<span class="sd-hr"></span>' +
        '<span class="sd-id">№ —</span>' +
        '</div>' +
        '<button type="button" class="stays-detail-close" aria-label="Close">' +
        '<svg viewBox="0 0 24 24" width="20" height="20"><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="1.5"/><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="1.5"/></svg>' +
        '<span>CLOSE<span class="modal-esc-hint"> · ESC</span></span>' +
        '</button>' +
        '</header>' +
        '<section class="sd-hero">' +
        '<div class="sd-hero-graphic">' +
        '<img alt="" loading="lazy"/>' +
        '<div class="sd-hero-empty">No photo yet</div>' +
        '</div>' +
        '<div class="sd-hero-text">' +
        '<div class="sd-kicker"></div>' +
        '<h3 class="sd-name"></h3>' +
        '<div class="sd-sub"></div>' +
        '<div class="sd-stamp"><span class="sd-stamp-dot"></span><span class="sd-stamp-text"></span></div>' +
        '</div>' +
        '</section>' +
        '<section class="sd-grid">' +
        '<div class="sd-field"><div class="sd-f-label">CATEGORY</div><div class="sd-f-value" data-f="category"></div></div>' +
        '<div class="sd-field"><div class="sd-f-label">CITY</div><div class="sd-f-value" data-f="city"></div></div>' +
        '<div class="sd-field"><div class="sd-f-label">COUNTRY</div><div class="sd-f-value" data-f="country"></div></div>' +
        '<div class="sd-field"><div class="sd-f-label">CONTINENT</div><div class="sd-f-value" data-f="continent"></div></div>' +
        '<div class="sd-field"><div class="sd-f-label">STATUS</div><div class="sd-f-value" data-f="status"></div></div>' +
        '<div class="sd-field"><div class="sd-f-label">REGISTER ENTRY</div><div class="sd-f-value sd-mono" data-f="entry"></div></div>' +
        '</section>' +
        '<section class="sd-narrative">' +
        '<blockquote class="sd-n-quote">' +
        '<span class="sd-quote-mark">“</span>' +
        '<span class="sd-quote-text"></span>' +
        '<span class="sd-quote-mark sd-quote-close">”</span>' +
        '</blockquote>' +
        '</section>' +
        // MAXH_STAYS_MODAL_MAPS_V1 — exact-place Google Maps deep link
        // alongside the country-page CTA. Populated in openDetail().
        '<div class="sd-cta-wrap">' +
        '<a class="sd-cta sd-cta-maps" target="_blank" rel="noopener noreferrer" data-sd-maps>Open in Google Maps →</a>' +
        '<a class="sd-cta" href="#" data-nav="country">Country page →</a>' +
        '</div>' +
        '</div>' +
        '</aside>';
      document.body.appendChild(modal);
      function closeModal() {
        modal.classList.remove('open');
        modal.setAttribute('aria-hidden', 'true');
        if (typeof window.maxhUnlockScroll === 'function') window.maxhUnlockScroll();
        else document.body.style.overflow = '';
      }
      modal.querySelector('.stays-detail-close').addEventListener('click', closeModal);
      modal.querySelector('.stays-detail-backdrop').addEventListener('click', closeModal);
      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && modal.classList.contains('open')) closeModal();
      });
      // MAXH_OVERLAY_ROUTE_TEARDOWN_V1 — the modal is a body-level
      // overlay, so a route change (nav link, browser back) must
      // collapse it: left open it keeps covering the next page and its
      // scroll lock never releases.
      window.addEventListener('hashchange', function () {
        if (modal.classList.contains('open')) closeModal();
      });
      // MAXH_STAYS_MODAL_CTA_CLOSE_V1 — clicking "Country page →" must
      // collapse the modal and land the user at the top of the country
      // page. The global [data-nav] handler updates the hash, but when
      // the user is already on that country page the hash is unchanged,
      // no hashchange fires, and showPage()'s scroll-to-top never runs.
      // Close + scroll-to-top here so behavior is consistent regardless
      // of whether the destination is a new page or the current one.
      var ctaEl = modal.querySelector('.sd-cta[data-nav="country"]');
      if (ctaEl) {
        ctaEl.addEventListener('click', function (ev) {
          if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
          if (ev.button !== undefined && ev.button !== 0) return;
          closeModal();
          var targetHash = ctaEl.getAttribute('href') || '';
          if (targetHash && '#' + window.location.hash.replace(/^#/, '') === targetHash) {
            try {
              window.scrollTo(0, 0);
            } catch (_) {}
            if (document.documentElement) document.documentElement.scrollTop = 0;
            if (document.body) document.body.scrollTop = 0;
          }
        });
      }
    }
    detailModalEl = modal;
    return modal;
  }

  var detailPhotoSeq = 0;

  function openDetail(h, ctx) {
    var modal = ensureDetailModal();
    hideHoverPop();
    // MAXH_STAYS_CIR_V1 — modal hero through CIR (was the raw original).
    var photoSrc = cirUrl(h.photo, 1280);
    var imgEl = modal.querySelector('.sd-hero-graphic img');
    var emptyEl = modal.querySelector('.sd-hero-empty');
    var photoToken = String(++detailPhotoSeq);
    modal.dataset.photoToken = photoToken;
    imgEl.onload = null;
    imgEl.onerror = null;
    imgEl.alt = '';
    imgEl.style.display = 'none';
    imgEl.removeAttribute('src');
    imgEl.removeAttribute('srcset');
    emptyEl.textContent = photoSrc ? 'Loading photo' : 'No photo yet';
    emptyEl.style.display = '';
    if (photoSrc) {
      var preload = new Image();
      preload.decoding = 'async';
      preload.onload = function () {
        if (modal.dataset.photoToken !== photoToken) return;
        imgEl.src = photoSrc;
        imgEl.alt = h.name || '';
        imgEl.style.display = '';
        emptyEl.style.display = 'none';
        emptyEl.textContent = 'No photo yet';
      };
      preload.onerror = function () {
        if (modal.dataset.photoToken !== photoToken) return;
        emptyEl.textContent = 'No photo yet';
      };
      preload.src = photoSrc;
    } else {
      emptyEl.textContent = 'No photo yet';
    }
    // Header: short register ID derived from the hotel name
    var idShort =
      (h.name || '')
        .replace(/[^A-Za-z0-9]/g, '')
        .slice(0, 3)
        .toUpperCase() || '—';
    modal.querySelector('.sd-id').textContent = '№ ' + idShort;
    modal.querySelector('.sd-tag').textContent = ctx.tag;
    // Hero text
    modal.querySelector('.sd-kicker').textContent = ctx.kicker;
    var sdName = modal.querySelector('.sd-name');
    sdName.textContent = h.name || ''; // also drops any old .tb-tray-add child
    // MAXH_TB_TRAY_V1 — the dossier modal is a singleton: re-arm the
    // pin hook per fill (same contract as the wonders detail panel).
    var sdPid = DATA.place_ids && h.id ? DATA.place_ids[h.id] : null;
    if (sdPid) {
      sdName.setAttribute('data-tb-id', sdPid);
      sdName.setAttribute('data-tb-name', h.name || '');
    } else {
      sdName.removeAttribute('data-tb-id');
      sdName.removeAttribute('data-tb-name');
    }
    sdName.removeAttribute('data-tb-ready');
    if (window.__maxhTBTray) window.__maxhTBTray.scan();
    var sub = modal.querySelector('.sd-sub');
    var subParts = [];
    if (h.city) subParts.push('<span>' + esc(h.city) + '</span>');
    if (h.country) subParts.push('<span>' + esc(h.country) + '</span>');
    if (h.continent && h.continent !== h.country) {
      subParts.push('<span class="sd-faded">' + esc(h.continent) + '</span>');
    }
    sub.innerHTML = subParts.join('<span class="sd-sep">·</span>');
    // Status pill
    var stamp = modal.querySelector('.sd-stamp');
    stamp.classList.toggle('stayed', !!h.stayed);
    stamp.classList.toggle('queued', !h.stayed);
    modal.querySelector('.sd-stamp-text').textContent = h.stayed
      ? 'STAYED · LOGGED'
      : 'ON QUEUE · TO BOOK';
    // Field grid
    modal.querySelector('[data-f="category"]').textContent = ctx.category;
    modal.querySelector('[data-f="city"]').textContent = h.city || '—';
    modal.querySelector('[data-f="country"]').textContent = h.country || '—';
    modal.querySelector('[data-f="continent"]').textContent = h.continent || '—';
    modal.querySelector('[data-f="status"]').textContent = h.stayed
      ? 'Stayed · checked off'
      : 'Queued · to visit';
    modal.querySelector('[data-f="entry"]').textContent = ctx.entry || '—';
    // Quote narrative — italicized text gets the em treatment
    var quoteText = modal.querySelector('.sd-quote-text');
    if (h.review || h.description) {
      quoteText.innerHTML = '<em>' + esc(h.review || h.description) + '</em>';
    } else {
      quoteText.innerHTML = '<em>Review coming soon.</em>';
    }
    // CTA
    var cta = modal.querySelector('.sd-cta[data-nav="country"]');
    if (h.country_slug) {
      cta.style.display = '';
      cta.href = '#country/' + h.country_slug;
      cta.dataset.slug = h.country_slug;
    } else {
      cta.style.display = 'none';
    }
    // MAXH_STAYS_MODAL_MAPS_V1 — "Open in Google Maps" deep link. Prefer
    // the canonical place-by-id URL (search/?api=1&query=<name>&query_place_id=<id>)
    // using the hotel's Google place_id from STAYS_DATA.place_ids so the
    // link opens the exact property; fall back to a name+city+country
    // search when the id is missing.
    var mapsEl = modal.querySelector('[data-sd-maps]');
    if (mapsEl) {
      var pid = DATA && DATA.place_ids && h.id ? DATA.place_ids[h.id] : '';
      var mapsQuery = [h.name, h.city, h.country].filter(Boolean).join(', ');
      if (pid) {
        mapsEl.href =
          'https://www.google.com/maps/search/?api=1&query=' +
          encodeURIComponent(h.name || mapsQuery) +
          '&query_place_id=' +
          encodeURIComponent(pid);
        mapsEl.style.display = '';
      } else if (mapsQuery) {
        mapsEl.href =
          'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(mapsQuery);
        mapsEl.style.display = '';
      } else {
        mapsEl.removeAttribute('href');
        mapsEl.style.display = 'none';
      }
    }
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    if (typeof window.maxhLockScroll === 'function') window.maxhLockScroll();
    else document.body.style.overflow = 'hidden';
  }

  // MAXH_STAYS_TOP20_HOVERPOP_V1 — lazy-create the floating dossier card
  // (parity with the food/drink CardPop). Reuses one element across all
  // wired properties; mouseenter/mousemove reposition + repopulate,
  // mouseleave hides. Touch devices skip this: the @media (hover: hover)
  // CSS gate keeps the card invisible even if mouseenter fires briefly
  // on tap.
  // MAXH_CARDPOP_PERF_V1 — child refs are resolved once at creation and
  // reused, mousemove repositioning is rAF-coalesced against cached
  // viewport dims, and re-entering the same property skips the refill.
  // Keeps hover-while-scrolling off the layout hot path.
  var hoverPopEl = null;
  var hoverPopRefs = null;
  var hoverPopItem = null;
  function ensureHoverPop() {
    if (hoverPopEl) return hoverPopEl;
    var pop = document.getElementById('staysHoverPop');
    if (!pop) {
      pop = document.createElement('div');
      pop.id = 'staysHoverPop';
      pop.className = 'card-pop';
      pop.innerHTML =
        '<div class="cp-head"><span class="cp-kind"></span><b class="cp-status"></b></div>' +
        '<div class="cp-body">' +
        '<div class="cp-thumb"><img alt="" decoding="async"></div>' +
        '<div class="cp-name"></div>' +
        '<div class="cp-loc"></div>' +
        '<div class="cp-lines">' +
        '<span>RANK <b class="cp-rank"></b></span>' +
        '<span>CONTINENT <b class="cp-continent"></b></span>' +
        '<span>STATE <b class="cp-state"></b></span>' +
        '</div>' +
        /* MAXH_STAYS_DOSSIER_CTA_REMOVED_V146_2 — "OPEN COUNTRY
             DOSSIER →" row removed from the stays hover popup per
             user request. .cp-cta CSS at line ~9914 left as harmless
             dead style. The fillPop() toggle that referenced
             .cp-cta is now a no-op (guarded). */
        '</div>';
      document.getElementById('page-stays').appendChild(pop);
    }
    hoverPopEl = pop;
    hoverPopRefs = {
      kind: pop.querySelector('.cp-kind'),
      status: pop.querySelector('.cp-status'),
      name: pop.querySelector('.cp-name'),
      loc: pop.querySelector('.cp-loc'),
      rank: pop.querySelector('.cp-rank'),
      continent: pop.querySelector('.cp-continent'),
      state: pop.querySelector('.cp-state'),
      thumbImg: pop.querySelector('.cp-thumb img'),
    };
    return pop;
  }
  var popX = 0;
  var popY = 0;
  var popRaf = 0;
  var popVw = window.innerWidth;
  var popVh = window.innerHeight;
  window.addEventListener('resize', function () {
    popVw = window.innerWidth;
    popVh = window.innerHeight;
  });
  function applyPopPos() {
    popRaf = 0;
    var pop = ensureHoverPop();
    pop.style.left = Math.min(popX + 20, popVw - 360) + 'px';
    pop.style.top = Math.min(popY + 20, popVh - 280) + 'px';
  }
  function positionPop(e) {
    popX = e.clientX;
    popY = e.clientY;
    if (!popRaf) popRaf = requestAnimationFrame(applyPopPos);
  }
  function hideHoverPop() {
    hoverPopItem = null;
    if (hoverPopEl) hoverPopEl.classList.remove('open');
  }
  function fillPop(h, ctx) {
    var pop = ensureHoverPop();
    if (hoverPopItem === h) return;
    hoverPopItem = h;
    var refs = hoverPopRefs;
    var stayed = !!h.stayed;
    refs.kind.textContent = '★ · ' + ctx.tag;
    refs.status.textContent = stayed ? '● STAYED' : '◌ QUEUED';
    refs.name.textContent = h.name || '';
    var locParts = [];
    if (h.city) locParts.push(h.city);
    if (h.country) locParts.push(h.country);
    refs.loc.textContent = locParts.join(' · ') || '—';
    refs.rank.textContent = ctx.entry || '—';
    refs.continent.textContent = h.continent || '—';
    refs.state.textContent = stayed ? 'STAYED' : 'QUEUED';
    // Thumbnail — tiny CIR variant (72px square @2x). Hidden via the
    // has-thumb class when the property has no photo; src only swaps
    // when it actually changes so re-hover never re-decodes.
    var thumbSrc = h.photo ? cirUrl(h.photo, 160) : '';
    if (thumbSrc) {
      if (refs.thumbImg.getAttribute('src') !== thumbSrc) refs.thumbImg.src = thumbSrc;
      pop.classList.add('has-thumb');
    } else {
      pop.classList.remove('has-thumb');
    }
  }

  // One wiring helper for every property element on the page: click (or
  // Enter/Space on focusable rows) opens the detail modal, hover shows
  // the floating dossier card.
  function wireDossier(el, h, ctx) {
    el.addEventListener('mousedown', function (ev) {
      // Pointer clicks must not focus the row (role=button, tabindex=0):
      // a focused row lights up with the :focus-visible ring on the next
      // keypress — pressing Escape to close the modal left the clicked
      // tile highlighted. Tab/Enter keyboard flow is unaffected.
      ev.preventDefault();
    });
    el.addEventListener('click', function (ev) {
      // Brand-group rows live inside a card whose own click handler
      // toggles the property list open/closed — opening the dossier
      // must not also collapse the card.
      ev.stopPropagation();
      openDetail(h, ctx);
    });
    el.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Enter' && ev.key !== ' ') return;
      ev.preventDefault();
      openDetail(h, ctx);
    });
    el.addEventListener('mouseenter', function (e) {
      fillPop(h, ctx);
      positionPop(e);
      ensureHoverPop().classList.add('open');
    });
    el.addEventListener('mousemove', positionPop);
    el.addEventListener('mouseleave', hideHoverPop);
  }

  // ── Big Lists tabs ─────────────────────────────────────────────────
  var listsState = { active: 'michelin_keys_3_2026', expanded: false };
  function hydrateLists() {
    var section = document.getElementById('staysLists');
    var lists = DATA.lists;
    var ids = Object.keys(lists);
    if (!ids.length) {
      section.innerHTML = '';
      return;
    }
    if (!lists[listsState.active]) listsState.active = ids[0];
    section.innerHTML =
      '' +
      '<div class="stays-section-head">' +
      '<h2>The big <em>lists</em>.</h2>' +
      '<div class="right">Three rosters we measure ourselves against. Visited rooms light up; the rest are queued.</div>' +
      '</div>' +
      '<div class="lists-tabs">' +
      ids
        .map(function (lid) {
          var L = lists[lid];
          var pct = L.total ? Math.round((L.visited / L.total) * 100) : 0;
          return (
            '<button class="lists-tab' +
            (lid === listsState.active ? ' active' : '') +
            '" data-lid="' +
            lid +
            '">' +
            '<div class="lt-ix">' +
            L.ix +
            ' · List</div>' +
            '<div class="lt-name">' +
            esc(L.label) +
            '</div>' +
            '<div class="lt-prog"><span><b>' +
            L.visited +
            '</b> / ' +
            L.total +
            '</span><span>' +
            pct +
            '%</span></div>' +
            '<div class="lt-bar"><i style="width:' +
            pct +
            '%"></i></div>' +
            '</button>'
          );
        })
        .join('') +
      '</div>' +
      '<div class="lists-pane" id="staysListsPane"></div>';

    section.querySelectorAll('.lists-tab').forEach(function (b) {
      b.addEventListener('click', function () {
        listsState.active = b.dataset.lid;
        listsState.expanded = false;
        // Move the .active class to the clicked button so the highlight tracks selection
        section.querySelectorAll('.lists-tab').forEach(function (other) {
          other.classList.toggle('active', other === b);
        });
        renderListPane();
      });
    });
    renderListPane();
  }

  function renderListPane() {
    var pane = document.getElementById('staysListsPane');
    if (!pane) return;
    var L = DATA.lists[listsState.active];
    if (!L) {
      pane.innerHTML = '';
      return;
    }
    // 52 fills the last 4-column row on wide viewports (13 full rows);
    // 51 left the grid's final cell empty.
    var VISIBLE = 52;
    var shown = listsState.expanded ? L.items : L.items.slice(0, VISIBLE);
    var moreOurs = Math.max(0, L.items.length - VISIBLE);
    var beyondOurs = Math.max(0, L.total - L.items.length);

    var grid = shown
      .map(function (it, i) {
        return (
          '<div class="lists-item ' +
          (it.stayed ? 'visited' : 'notv') +
          '" data-idx="' +
          i +
          '" role="button" tabindex="0">' +
          '<div class="lit-num">' +
          String(it.rank || i + 1).padStart(2, '0') +
          '</div>' +
          '<div>' +
          '<div class="lit-name">' +
          esc(it.name) +
          '</div>' +
          '<div class="lit-loc">' +
          esc([it.city, it.country].filter(Boolean).join(', ')) +
          '</div>' +
          '</div>' +
          '<div class="lit-mark">' +
          (it.stayed ? '✓ STAYED' : '— QUEUED') +
          '</div>' +
          '</div>'
        );
      })
      .join('');
    var pct = L.total ? Math.round((L.visited / L.total) * 100) : 0;
    pane.innerHTML =
      '' +
      '<div class="lists-pane-head">' +
      '<div><h3>' +
      // Registry year makes the edition explicit ("· 2026") — awards
      // lists refresh annually and the pane should say which one this is.
      esc(L.label + (L.year ? ' · ' + L.year : '')) +
      '</h3><p class="blurb">' +
      esc(L.blurb || '') +
      '</p></div>' +
      '<div class="meta">VISITED <b>' +
      L.visited +
      '</b> / ' +
      L.total +
      ' · ' +
      pct +
      '%</div>' +
      '</div>' +
      '<div class="lists-grid">' +
      grid +
      '</div>' +
      (moreOurs > 0 || beyondOurs > 0
        ? '<div class="lists-more">' +
          (moreOurs > 0
            ? '<button class="lists-more-btn" data-toggle="more">' +
              (listsState.expanded ? '— Collapse' : '+ Show ' + moreOurs + ' more on our list') +
              '</button>'
            : '') +
          (beyondOurs > 0
            ? '<div class="lists-more-note"><span style="color:var(--stamp);margin-right:6px;">·</span>' +
              beyondOurs +
              ' more properties carry this rating worldwide (' +
              L.total +
              ' total).</div>'
            : '') +
          '</div>'
        : '');
    var btn = pane.querySelector('[data-toggle="more"]');
    if (btn)
      btn.addEventListener('click', function () {
        listsState.expanded = !listsState.expanded;
        renderListPane();
      });

    // MAXH_STAYS_DOSSIER_EVERYWHERE_V1 — every list entry opens the
    // shared dossier (hover card + detail modal), same as a Top 20 row.
    pane.querySelectorAll('.lists-item[data-idx]').forEach(function (item) {
      var it = shown[parseInt(item.dataset.idx, 10)];
      if (!it) return;
      var rank = it.rank ? String(it.rank).padStart(2, '0') : '';
      wireDossier(item, it, {
        tag: L.label,
        kicker: '★ · ' + (L.label || '').toUpperCase() + (rank ? ' · N°' + rank : ''),
        category: L.label,
        entry: rank ? '№ ' + rank : '—',
      });
    });
  }

  // ── Brand groups ───────────────────────────────────────────────────
  var groupsState = {};
  function hydrateGroups() {
    var section = document.getElementById('staysGroups');
    var groups = DATA.groups;
    var ids = Object.keys(groups);
    if (!ids.length) {
      section.innerHTML = '';
      return;
    }
    var brandLogos = {
      brand_aman:
        '<svg viewBox="0 0 280 40" preserveAspectRatio="xMinYMid meet"><text x="0" y="29" font-family="\'Helvetica Neue\', Arial, sans-serif" font-weight="300" font-size="28" letter-spacing="12" fill="currentColor">AMAN</text></svg>',
      brand_four_seasons:
        '<svg viewBox="0 0 280 40" preserveAspectRatio="xMinYMid meet"><text x="0" y="27" font-family="\'Times New Roman\', Times, serif" font-weight="400" font-size="15" letter-spacing="5" fill="currentColor">FOUR SEASONS</text></svg>',
      brand_belmond:
        '<svg viewBox="0 0 280 40" preserveAspectRatio="xMinYMid meet"><text x="0" y="30" font-family="\'Didot\', \'Bodoni 72\', \'Times New Roman\', serif" font-style="italic" font-weight="400" font-size="34" fill="currentColor">Belmond</text></svg>',
      brand_capella:
        '<svg viewBox="0 0 280 40" preserveAspectRatio="xMinYMid meet"><text x="0" y="28" font-family="\'Didot\', \'Bodoni 72\', \'Times New Roman\', serif" font-weight="400" font-size="22" letter-spacing="7" fill="currentColor">CAPELLA</text></svg>',
      brand_cheval_blanc:
        '<svg viewBox="0 0 280 40" preserveAspectRatio="xMinYMid meet"><text x="0" y="26" font-family="\'Helvetica Neue\', Arial, sans-serif" font-weight="300" font-size="13" letter-spacing="6" fill="currentColor">CHEVAL</text><text x="78" y="32" font-family="\'Snell Roundhand\', \'Apple Chancery\', \'Brush Script MT\', cursive" font-style="italic" font-weight="400" font-size="34" fill="currentColor">Blanc</text></svg>',
      brand_preferred:
        '<svg viewBox="0 0 280 40" preserveAspectRatio="xMinYMid meet"><text x="0" y="18" font-family="\'Times New Roman\', Times, serif" font-style="italic" font-weight="400" font-size="17" fill="currentColor">Preferred</text><text x="0" y="33" font-family="\'Helvetica Neue\', Arial, sans-serif" font-weight="500" font-size="8" letter-spacing="3" fill="currentColor">HOTELS &amp; RESORTS</text></svg>',
    };
    section.innerHTML =
      '' +
      '<div class="stays-section-head">' +
      '<h2>The <em>luxury groups</em>.</h2>' +
      '<div class="right">How deep into each house\'s collection we\'ve actually gotten. Click a card to see which properties.</div>' +
      '</div>' +
      '<div class="groups-grid">' +
      ids
        .map(function (gid, i) {
          var g = groups[gid];
          var pct = g.total ? Math.round((g.count / g.total) * 100) : 0;
          var stays = g.stays
            .map(function (h, si) {
              return (
                '<li data-idx="' +
                si +
                '"><span>' +
                esc(h.name) +
                '</span><span class="gl-loc">' +
                (h.flag || '') +
                ' ' +
                esc(h.country || '') +
                '</span></li>'
              );
            })
            .join('');
          if (!stays)
            stays =
              '<li><span style="color:var(--faded);font-style:italic;">None yet — queued.</span><span></span></li>';
          return (
            '<div class="group-card" data-gid="' +
            gid +
            '" data-open="false">' +
            '<div class="gc-head">' +
            '<div>' +
            '<div class="gc-logo">' +
            (brandLogos[gid] || g.name) +
            '</div>' +
            '<div class="gc-since">' +
            esc(g.since) +
            ' · ' +
            esc(g.tag) +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div class="gc-stat">' +
            '<span class="v">' +
            g.count +
            '</span>' +
            '<span class="of"> / <i>' +
            g.total +
            '</i></span>' +
            '<span class="pct"><b>' +
            pct +
            '%</b> visited</span>' +
            '</div>' +
            '<div class="gc-bar"><i style="width:' +
            pct +
            '%"></i></div>' +
            '<p class="gc-blurb">' +
            esc(g.blurb) +
            '</p>' +
            '<div class="gc-toggle">' +
            (g.count ? 'Show ' + g.count + ' stay' + (g.count === 1 ? '' : 's') : 'No stays yet') +
            '</div>' +
            '<div class="gc-list">' +
            '<div class="gc-list-inner">' +
            '<div class="gc-list-head">Properties · ' +
            g.count +
            '</div>' +
            '<ul>' +
            stays +
            '</ul>' +
            '</div>' +
            '</div>' +
            '</div>'
          );
        })
        .join('') +
      '</div>';

    section.querySelectorAll('.group-card').forEach(function (card) {
      card.addEventListener('click', function () {
        var open = card.dataset.open === 'true';
        card.dataset.open = open ? 'false' : 'true';
        var t = card.querySelector('.gc-toggle');
        if (t) {
          var g = DATA.groups[card.dataset.gid];
          if (g.count)
            t.firstChild.nodeValue =
              (open ? 'Show ' : 'Hide ') + g.count + ' stay' + (g.count === 1 ? '' : 's');
        }
      });
      // MAXH_STAYS_DOSSIER_EVERYWHERE_V1 — each property row inside the
      // card opens the shared dossier. wireDossier stops propagation so
      // the card's own toggle handler doesn't collapse the list.
      var g = DATA.groups[card.dataset.gid];
      card.querySelectorAll('.gc-list li[data-idx]').forEach(function (li) {
        var s = g && g.stays[parseInt(li.dataset.idx, 10)];
        if (!s) return;
        wireDossier(li, s, {
          tag: g.name,
          kicker: '★ · ' + (g.name || '').toUpperCase() + ' · PORTFOLIO',
          category: g.name,
          entry: '—',
        });
      });
    });
  }

  // ── Best Views marquee ────────────────────────────────────────────
  function hydrateBestViews() {
    var section = document.getElementById('staysBestViews');
    var picks = DATA.view_from_rooms || [];
    if (!picks.length) {
      // MAXH_STAYS_BV_EMPTY_COPY_V1 — soft-coming-soon copy for when the
      // VFR gallery hasn't been populated yet. The hydrate runs on every
      // page render and reads DATA.view_from_rooms fresh, so as soon as
      // a photo is added in the admin and a publish goes out, the
      // marquee swaps in automatically.
      section.innerHTML =
        '' +
        '<div class="bv-head">' +
        '<div class="bv-head-l"><h2>Rooms with the <em>best view</em>.</h2></div>' +
        '</div>' +
        '<div class="bv-empty">— Updating soon —</div>';
      return;
    }
    var n = picks.length;
    var winHtml = function (p, i, copy) {
      // bv-window is 240px wide × 300px tall (4/5 aspect). 320 base + 640 2x
      // covers retina without overshooting on hover scale-up. CIR
      // (MAXH_STAYS_CIR_V1) returns format=auto so these serve AVIF/WebP.
      var src = cirUrl(p.photo, 320);
      var srcset = cirSrcset(p.photo, 320);
      // Prefer the catalog hotel_name (canonical, populated by
      // stays_page_data.py from the hotel_id link); fall back to the
      // legacy caption field for any rows that haven't been re-saved.
      var label = p.hotel_name || p.caption || '';
      var imgTag = src
        ? '<img src="' +
          src +
          '"' +
          (srcset ? ' srcset="' + srcset + '"' : '') +
          ' alt="' +
          escAttr(label) +
          '" loading="lazy" decoding="async"/>'
        : '';
      var labelTag = label ? '<div class="bv-label">' + esc(label) + '</div>' : '';
      return (
        '<div class="bv-window" data-idx="' +
        i +
        '" aria-hidden="' +
        (copy === 1 ? 'true' : 'false') +
        '">' +
        '<div class="bv-photo">' +
        imgTag +
        '</div>' +
        labelTag +
        '</div>'
      );
    };
    var track =
      picks
        .map(function (p, i) {
          return winHtml(p, i, 0);
        })
        .join('') +
      picks
        .map(function (p, i) {
          return winHtml(p, i, 1);
        })
        .join('');
    section.innerHTML =
      '' +
      '<div class="bv-head">' +
      '<div class="bv-head-l">' +
      '<h2>Rooms with the <em>best view</em>.</h2>' +
      '</div>' +
      '</div>' +
      '<div class="bv-stage" id="bvStage"><div class="bv-marquee" id="bvMarquee"><div class="bv-track" id="bvTrack">' +
      track +
      '</div></div></div>';

    var trackEl = document.getElementById('bvTrack');
    var stageEl = document.getElementById('bvStage');

    // MAXH_STAYS_DOSSIER_EVERYWHERE_V1 — each window (both marquee
    // copies) opens the shared dossier for its linked hotel. The hotel
    // record is assembled from the vfr row's hotel_* fields; the view
    // photo doubles as the modal hero.
    section.querySelectorAll('.bv-window').forEach(function (w) {
      var p = picks[parseInt(w.dataset.idx, 10)];
      if (!p) return;
      var h = {
        // MAXH_TB_BV_DOSSIER_PIN_V1 — carry the hotel id so the dossier
        // opened from a Best Views window resolves DATA.place_ids and
        // grows the trip-tray "+" like every other dossier entry.
        id: p.hotel_id || '',
        name: p.hotel_name || p.caption || '',
        city: p.hotel_city || '',
        country: p.hotel_country || '',
        continent: p.hotel_continent || '',
        photo: p.photo || '',
        review: p.hotel_review || '',
        description: p.hotel_description || '',
        country_slug: p.hotel_country_slug || '',
        stayed: true,
      };
      wireDossier(w, h, {
        tag: 'M&H · BEST VIEWS',
        kicker: '★ · ROOMS WITH THE BEST VIEW',
        category: 'Rooms with the best view',
        entry: '—',
      });
    });
    // MAXH_PERF_V1_TICKER_GATE — IO + visibilitychange gate so the rAF
    // marquee loop stops scheduling frames while off-screen. The 3.5s
    // setInterval that drove the old "Now viewing" panel was retired
    // along with the panel itself (bv-counter + bv-now removed v15x).
    var bvOnScreen = !('IntersectionObserver' in window);
    var bvRafActive = false;
    function bvTickerUpdate() {
      var shouldRun = bvOnScreen && document.visibilityState !== 'hidden';
      if (shouldRun && !bvRafActive) {
        bvRafActive = true;
        last = performance.now();
        requestAnimationFrame(tick);
      }
    }
    if ('IntersectionObserver' in window) {
      var bvIo = new IntersectionObserver(
        function (entries) {
          bvOnScreen = entries[entries.length - 1].isIntersecting;
          bvTickerUpdate();
        },
        { threshold: 0 }
      );
      bvIo.observe(stageEl);
    }
    document.addEventListener('visibilitychange', bvTickerUpdate);

    // rAF marquee — gated by bvRafActive so the loop self-terminates
    // when off-screen and re-arms on next intersection.
    var x = 0,
      last = performance.now(),
      DURATION = 90000;
    function tick(now) {
      var dt = now - last;
      last = now;
      var halfWidth = trackEl.scrollWidth / 2;
      if (halfWidth > 0) {
        x -= dt * (halfWidth / DURATION);
        if (x <= -halfWidth) x += halfWidth;
        trackEl.style.transform = 'translate3d(' + x + 'px, 0, 0)';
      }
      if (bvOnScreen && document.visibilityState !== 'hidden') {
        requestAnimationFrame(tick);
      } else {
        bvRafActive = false; // exit loop; bvTickerUpdate restarts when visible
      }
    }
    bvTickerUpdate();
  }

  // ── Globe (canvas — same projection + clip technique as the homepage)
  // Reuses window.MAXH_LAND_DATA; polygons are arrays of [lat, lng] tuples
  // (NOT [lng, lat]). Uses Sutherland-Hodgman clipping at z=0 plus arc
  // insertion along the limb so polygons fill correctly without ghost
  // chords across the sphere.
  function buildGlobe() {
    var host = document.getElementById('staysGlobeBg');
    if (!host) return;
    // Clear any prior render
    while (host.firstChild) host.removeChild(host.firstChild);

    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'width:100%;height:100%;display:block;';
    host.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var dpr = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
    var W = 0,
      H = 0,
      R = 0,
      cx = 0,
      cy = 0;

    var landPolys =
      window.MAXH_LAND_DATA && Array.isArray(window.MAXH_LAND_DATA.polygons)
        ? window.MAXH_LAND_DATA.polygons
        : [];

    function readPalette() {
      var s = getComputedStyle(document.documentElement);
      var g = function (v, fb) {
        return s.getPropertyValue(v).trim() || fb;
      };
      // MAXH_STAYS_GLOBE_PAPER_BLEND_V1 — sphere fill matches page paper
      // (was --paper-deep + dark --rule rim) so the disc no longer reads
      // as a darker circle with a visible edge against the hero. Land,
      // graticule, and stamps keep the globe shape legible.
      return {
        sphereNear: g('--paper', '#F1EBDD'),
        sphereFar: g('--paper', '#F1EBDD'),
        sphereStroke: 'transparent',
        graticule: g('--rule-soft', 'rgba(28,24,20,0.08)'),
        land: g('--faded', '#8a7d69'),
        stamp: g('--stamp', '#9c3224'),
      };
    }
    var palette = readPalette();

    // MAXH_STAYS_GLOBE_RESIZE_V2 — earlier we relied on the host's CSS
    // (`width: 60%; aspect-ratio: 1/1; max-height: 95%`) to drive the
    // globe size and just measured what the browser computed. Chrome
    // and Safari interpreted the interaction between those three rules
    // differently — Chrome was producing a host ~50% wider than Safari,
    // which made the globe spill over the hero stage. Switching to a
    // JS-computed square size keyed to the parent's actual rect:
    //     size = min(parentWidth * 0.6, parentHeight * 0.95)
    // gives identical results in every engine and survives any future
    // CSS tweak. Inline width/height/aspect-ratio override the CSS so
    // the box is guaranteed square.
    function resize() {
      var stage = host.parentElement;
      var stageRect = stage ? stage.getBoundingClientRect() : null;
      var stageW = stageRect ? stageRect.width : 0;
      var stageH = stageRect ? stageRect.height : 0;
      if (!stageW || !stageH) return;
      // MAXH_STAYS_GLOBE_LARGER_V2 — multipliers bumped ~45% (0.6 → 0.87,
      // 0.95 → 1.40) so the sphere reads as the dominant background it
      // was always meant to be on both mobile and desktop.
      // MAXH_STAYS_GLOBE_MOBILE_V3 — phones get a width-driven size so
      // the centered medallion almost fills the stage instead of sitting
      // off-canvas-right as a faint half-circle. Desktop keeps the
      // height-bounded min() for layout stability.
      var size;
      if (window.innerWidth <= 900) {
        size = Math.max(160, stageW * 1.05);
      } else {
        size = Math.max(120, Math.min(stageW * 0.87, stageH * 1.4));
      }
      host.style.width = size + 'px';
      host.style.height = size + 'px';
      host.style.aspectRatio = 'auto'; // we're sizing both axes explicitly
      W = size;
      H = size;
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      cx = W / 2;
      cy = H / 2;
      R = W / 2 - 12;
    }
    resize();
    // MAXH_PERF_V1_RESIZE_DEDUPE — was: window.addEventListener('resize', resize)
    // unconditionally, plus a ResizeObserver below. Both fired on every
    // window resize → resize() ran twice per event. ResizeObserver is the
    // modern path (covers parent-element changes, not just window), so
    // prefer it and only fall back to the window listener when RO is
    // unavailable. Keeps fallback semantics intact for older browsers.
    var roOk = false;
    if (typeof ResizeObserver !== 'undefined') {
      try {
        var ro = new ResizeObserver(function () {
          resize();
        });
        if (host.parentElement) ro.observe(host.parentElement);
        else ro.observe(host);
        roOk = true;
      } catch (_e) {
        /* fallback path picks it up below */
      }
    }
    if (!roOk) {
      window.addEventListener('resize', resize);
    }

    var yaw = 0,
      pitch = (18 * Math.PI) / 180;
    function project(lat, lng) {
      var latR = (lat * Math.PI) / 180,
        lngR = (lng * Math.PI) / 180;
      var cL = Math.cos(latR),
        sL = Math.sin(latR);
      var cG = Math.cos(lngR),
        sG = Math.sin(lngR);
      var x = cL * sG,
        y = sL,
        z = cL * cG;
      var cy0 = Math.cos(yaw),
        sy0 = Math.sin(yaw);
      var x1 = x * cy0 - z * sy0;
      var z1 = x * sy0 + z * cy0;
      var cp0 = Math.cos(pitch),
        sp0 = Math.sin(pitch);
      var y2 = y * cp0 - z1 * sp0;
      var z2 = y * sp0 + z1 * cp0;
      return { x: cx + x1 * R, y: cy - y2 * R, z: z2 };
    }

    function drawSphere() {
      var grd = ctx.createRadialGradient(cx - R * 0.25, cy - R * 0.3, R * 0.1, cx, cy, R);
      grd.addColorStop(0, palette.sphereNear);
      grd.addColorStop(1, palette.sphereFar);
      ctx.fillStyle = grd;
      ctx.beginPath();
      ctx.arc(cx, cy, R, 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = palette.sphereStroke;
      ctx.lineWidth = 1;
      ctx.stroke();
    }

    function drawGraticule() {
      ctx.strokeStyle = palette.graticule;
      ctx.lineWidth = 1;
      for (var lng = -180; lng < 180; lng += 30) {
        ctx.beginPath();
        var started = false;
        for (var lat = -90; lat <= 90; lat += 4) {
          var p = project(lat, lng);
          if (p.z > 0) {
            if (!started) {
              ctx.moveTo(p.x, p.y);
              started = true;
            } else ctx.lineTo(p.x, p.y);
          } else started = false;
        }
        ctx.stroke();
      }
      for (var lat2 = -60; lat2 <= 60; lat2 += 30) {
        ctx.beginPath();
        var started2 = false;
        for (var lng2 = -180; lng2 <= 180; lng2 += 4) {
          var p2 = project(lat2, lng2);
          if (p2.z > 0) {
            if (!started2) {
              ctx.moveTo(p2.x, p2.y);
              started2 = true;
            } else ctx.lineTo(p2.x, p2.y);
          } else started2 = false;
        }
        ctx.stroke();
      }
    }

    // MAXH_STAYS_GLOBE_LIMB_ARC_V1 — Sutherland-Hodgman clip with arc-
    // along-limb fill. Earlier this used straight chords between two
    // limb-crossing points, which sliced the sphere interior and left
    // weird sliver shapes when a country straddled the visible/back-side
    // horizon (e.g. Antarctica peeking up from the bottom). Each clipped
    // vertex is now flagged `h: true` if it sits on the limb; the fill
    // walker uses `ctx.arc` to trace the sphere edge between consecutive
    // limb points instead of a straight line.
    function projectClipped(poly) {
      var n = poly.length;
      var projs = new Array(n);
      for (var i = 0; i < n; i++) projs[i] = project(poly[i][0], poly[i][1]);
      var out = [];
      for (var j = 0; j < n; j++) {
        var cur = projs[j];
        var nxt = projs[(j + 1) % n];
        var curFront = cur.z > 0;
        var nxtFront = nxt.z > 0;
        if (curFront) out.push({ x: cur.x, y: cur.y, h: false });
        if (curFront !== nxtFront) {
          // Linearly interpolate to the z=0 boundary, then snap to the sphere
          // edge so the inserted point lies exactly on the limb.
          var t = cur.z / (cur.z - nxt.z);
          var bx = cur.x + (nxt.x - cur.x) * t;
          var by = cur.y + (nxt.y - cur.y) * t;
          var dx = bx - cx,
            dy = by - cy;
          var d = Math.hypot(dx, dy) || 1;
          out.push({ x: cx + (dx * R) / d, y: cy + (dy * R) / d, h: true });
        }
      }
      return out;
    }

    function drawLand() {
      if (!landPolys.length) return;
      ctx.save();

      // ── Pass 1: FILLS ── arc-along-limb between consecutive horizon points
      ctx.fillStyle = palette.land;
      ctx.globalAlpha = 0.28;
      for (var pi = 0; pi < landPolys.length; pi++) {
        var poly = landPolys[pi];
        if (!poly || poly.length < 3) continue;
        var clipped = projectClipped(poly);
        if (clipped.length < 3) continue;
        ctx.beginPath();
        ctx.moveTo(clipped[0].x, clipped[0].y);
        var m = clipped.length;
        for (var k = 0; k < m; k++) {
          var cur = clipped[k];
          var nxt = clipped[(k + 1) % m];
          if (cur.h && nxt.h) {
            // Both points are on the limb — trace the sphere edge between
            // them so the polygon's boundary follows the visible silhouette
            // instead of cutting across with a straight chord.
            var a1 = Math.atan2(cur.y - cy, cur.x - cx);
            var a2 = Math.atan2(nxt.y - cy, nxt.x - cx);
            var delta = a2 - a1;
            while (delta > Math.PI) delta -= 2 * Math.PI;
            while (delta <= -Math.PI) delta += 2 * Math.PI;
            ctx.arc(cx, cy, R, a1, a1 + delta, delta < 0);
          } else {
            ctx.lineTo(nxt.x, nxt.y);
          }
        }
        ctx.closePath();
        ctx.fill();
      }

      // ── Pass 2: STROKES ── per-edge back-face culling, so coastline
      // strokes break cleanly at the horizon rather than wrapping behind.
      ctx.strokeStyle = palette.land;
      ctx.globalAlpha = 0.55;
      ctx.lineWidth = 0.6;
      ctx.lineJoin = 'round';
      ctx.lineCap = 'round';
      for (var si = 0; si < landPolys.length; si++) {
        var spoly = landPolys[si];
        if (!spoly || spoly.length < 2) continue;
        ctx.beginPath();
        var started = false;
        for (var v = 0; v < spoly.length; v++) {
          var pt = project(spoly[v][0], spoly[v][1]);
          if (pt.z > 0) {
            if (!started) {
              ctx.moveTo(pt.x, pt.y);
              started = true;
            } else {
              ctx.lineTo(pt.x, pt.y);
            }
          } else {
            started = false;
          }
        }
        ctx.stroke();
      }
      ctx.globalAlpha = 1;
      ctx.restore();
    }

    function drawDots() {
      var pts = DATA.globe_points || [];
      if (!pts.length) return;
      ctx.save();
      pts.forEach(function (pt) {
        var p = project(pt.lat, pt.lng);
        if (p.z <= 0) return;
        var r = pt.recent ? 3.4 : pt.stayed ? 2.4 : 1.6;
        ctx.beginPath();
        ctx.arc(p.x, p.y, r, 0, Math.PI * 2);
        ctx.fillStyle = pt.recent ? palette.stamp : pt.stayed ? palette.stamp : palette.land;
        ctx.globalAlpha = pt.recent ? 1 : pt.stayed ? 0.85 : 0.35;
        ctx.fill();
      });
      ctx.globalAlpha = 1;
      ctx.restore();
    }

    function draw() {
      if (!W || !H) return;
      ctx.clearRect(0, 0, W, H);
      drawSphere();
      drawGraticule();
      drawLand();
      drawDots();
    }

    // Auto-rotate
    var raf;
    function tick() {
      yaw += 0.0015;
      draw();
      raf = requestAnimationFrame(tick);
    }
    draw();
    raf = requestAnimationFrame(tick);
  }

  // ── Public API ─────────────────────────────────────────────────────
  // MAXH_PERF_V2_LAZY_DATA — was synchronous. Now awaits ensureData() so
  // we don't try to read DATA.stats before the lazy fetch resolves. If
  // the fetch fails, hydrated is reset so a subsequent #stays nav can
  // retry (covers e.g. transient network errors on mobile).
  // MAXH_REFACTOR_V1_PAGE_HYDRATING — add .is-hydrating before awaiting
  // the fetch so the static "—" placeholders stay invisible until real
  // values land (see template.html for the visibility rule).
  function hydrate() {
    if (hydrated) return;
    hydrated = true;
    if (!DATA && page) page.classList.add('is-hydrating');
    ensureData()
      .then(function () {
        try {
          hydrateHero();
        } catch (e) {
          console.warn('[stays] hero', e);
        }
        try {
          hydrateFeatured();
        } catch (e) {
          console.warn('[stays] featured', e);
        }
        try {
          hydrateTop20();
        } catch (e) {
          console.warn('[stays] top20', e);
        }
        try {
          hydrateLists();
        } catch (e) {
          console.warn('[stays] lists', e);
        }
        try {
          hydrateGroups();
        } catch (e) {
          console.warn('[stays] groups', e);
        }
        try {
          hydrateBestViews();
        } catch (e) {
          console.warn('[stays] bv', e);
        }
        try {
          buildGlobe();
        } catch (e) {
          console.warn('[stays] globe', e);
        }
        if (page) page.classList.remove('is-hydrating');
      })
      .catch(function (e) {
        console.error('[stays] data load failed:', e);
        hydrated = false;
        if (page) page.classList.remove('is-hydrating');
      });
  }

  // Hydrate when the user navigates to #stays. The rest of the site uses
  // hash-based routing — we listen for hashchange and visibility.
  function maybeHydrate() {
    if (
      location.hash === '#stays' ||
      document.getElementById('page-stays').classList.contains('active')
    ) {
      hydrate();
    }
  }
  window.addEventListener('hashchange', maybeHydrate);
  // Hydrate on first paint regardless so the page is ready for the router.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeHydrate);
  } else {
    maybeHydrate();
  }
})();

;
/* MAXH_BUNDLER_V1_DEFERRED: src/js/spa/renderers/lightbox.js */
// ════════════════════════════════════════════════════════════════════
// src/js/spa/renderers/lightbox.js
// ────────────────────────────────────────────────────────────────────
// MAXH_REFACTOR_V1 Phase 2 — extracted from template.html (was the
// final ~85 lines of the SPA's main IIFE: gallery lightbox feature
// with renderLightbox / openLightbox / closeLightbox / lbNav and
// the global click/keyboard event handlers).
//
// IMPORTANT — this file is inlined back into the SPA's main IIFE at
// build time through build.py's INLINE_JS_BUNDLES manifest. The code
// RELIES on the surrounding closure for:
//   - DATA (the lazy-loaded data.json)
//   - INDEX_DATA (the inline JSON)
//   - isVideoPath / videoPosterPath / videoUrl / videoLightboxUrl / imgUrl (helpers
//     defined earlier in the SPA IIFE)
//   - loadData (the data.json fetcher)
// It is NOT a standalone module — loading it on its own would error
// on those undefined references.
//
// To edit: change the code below and rebuild. The build parses and
// minifies it through esbuild before token insertion. The regression
// suite verifies:
//   - this file exists and is well-formed
//   - the function names (renderLightbox, openLightbox) appear
//     exactly once in the assembled output (no double-inclusion)
//   - the assembled output's IIFE closer is still in place
//
// NOTE: this comment deliberately avoids the literal substring
// s-c-r-i-p-t wrapped in angle brackets, because that string in
// the assembled HTML would end the surrounding script block
// prematurely. Same class of gotcha as the LAZY_CSS bootstrap
// comment in template.html — see CLAUDE.md §15.4.
//
// See docs/REFACTOR.md (Phase 2) and docs/ARCHITECTURE.md.
// ════════════════════════════════════════════════════════════════════
// Lightbox
const lb = document.getElementById('lightbox');
const lbImg = document.getElementById('lbImg');
const lbVideo = document.getElementById('lbVideo');
const lbClose = document.getElementById('lbClose');
const lbPrev = document.getElementById('lbPrev');
const lbNext = document.getElementById('lbNext');
const lbCount = document.getElementById('lbCount');
const lbCaption = document.getElementById('lbCaption');
let lbImages = [],
  lbIndex = 0;

// MAXH_LB_IDLE_FADE_V1 — desktop video viewing: once the cursor sits
// still over a playing video, fade the lightbox chrome (close, arrows,
// count, caption) AND drop the native <video> control bar so nothing
// covers the footage. The next pointer move / key press brings it all
// straight back and re-arms the countdown. Mirrors the shot lightbox's
// MAXH_MEDIALB_IDLE_FADE_V1. Gated two ways so prior behavior is intact
// where the auto-hide doesn't belong:
//   - hover-capable + fine pointer only (a real mouse) — touch devices
//     keep always-on controls + swipe nav.
//   - video items only — photo browsing keeps its persistent chrome.
const LB_IDLE_ENABLED =
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(hover: hover) and (pointer: fine)').matches;
const LB_IDLE_MS = 2500;
let lbIdleTimer = null;
let lbCurrentIsVideo = false;

// MAXH_LB_VIDEO_UPGRADE_V1 — tile-first progressive open, the gallery
// twin of the media lightbox's MAXH_LIGHTBOX_VIDEO_UPGRADE_V1. A video
// item starts on #lbVideo with the SAME small tile rendition its grid
// tile plays (already in the tile blob LRU or the HTTP cache when the
// tile was on screen; a few hundred KB otherwise) so playback begins
// near-instantly, then the surface's selected full-quality stream loads
// in a detached element and swaps in at the same timestamp once it can
// play through. Any upgrade failure just leaves the tile stream playing.
// While either element still has unbuffered bytes, the clip scheduler
// yields the whole pipe (MAXH_LB_PIPE_EXCLUSIVE_V1) via the
// window.maxhVideoPipe bridge — this module is packaged in the deferred
// bundle, so every bridge read is guarded and the lightbox degrades to
// its old single-stream behavior when the bridge is absent.
let lbHiVideo = null; // the committed full-quality element (post-swap stage)
let lbUpSeq = 0;
let lbUpSync = null; // MAXH_LB_STREAM_UPGRADE_V1 handle
let lbLowBlobUrl = ''; // blob-LRU starter for the cold-open low stream
function lbPipe() {
  const p = window.maxhVideoPipe;
  return p && typeof p.hold === 'function' ? p : null;
}
function lbShownVideo() {
  return lbHiVideo || lbVideo;
}
function lbRevokeLowBlob() {
  if (lbLowBlobUrl) {
    try {
      URL.revokeObjectURL(lbLowBlobUrl);
    } catch (_) {
      /* ignore */
    }
    lbLowBlobUrl = '';
  }
}
function lbDropVideoEl(v) {
  try {
    v.pause();
  } catch (_) {
    /* ignore */
  }
  v.removeAttribute('src');
  try {
    v.load();
  } catch (_) {
    /* ignore */
  }
  if (v.parentNode) v.parentNode.removeChild(v);
}
// Tear down every upgrade artifact: the in-flight streaming element
// (the helper's cancel clears its src and detaches it), a committed
// full-quality element, the starter blob URL, and the pipe holds. Runs
// on every render (nav re-uses the singleton #lbVideo) and on close.
function lbResetVideoUpgrade() {
  lbUpSeq += 1; // invalidates any in-flight upgrade callbacks
  if (lbUpSync) {
    lbUpSync.cancel(); // MAXH_LB_STREAM_UPGRADE_V1 — stop the stream
    lbUpSync = null;
  }
  const pipe = lbPipe();
  if (pipe) pipe.releaseAll();
  if (lbHiVideo) {
    lbDropVideoEl(lbHiVideo);
    lbHiVideo = null;
  }
  lbRevokeLowBlob();
}
// MAXH_LB_STREAM_UPGRADE_V1 — streaming quality switch, the gallery
// twin of the media lightbox's (template.html). The switch itself is
// the shared lib module (src/js/spa/lib/video-sync.js, unit-tested in
// tests/js/video-sync.test.js), reached through the
// window.maxhLbStreamUpgrade alias the SPA IIFE exposes (__maxhLib
// itself is IIFE-scoped, not a window property) — this file rides the
// deferred bundle, and the alias exists long before a lightbox click
// can happen. The read is guarded like the pipe bridge: an unexposed
// helper degrades to the tile stream, which is already on stage either
// way.
function lbStartUpgrade(upgradeSrc) {
  const seq = ++lbUpSeq;
  const swapper = window.maxhLbStreamUpgrade;
  if (typeof swapper !== 'function') return;
  const stillCurrent = () => seq === lbUpSeq && lbCurrentIsVideo && lb.classList.contains('active');
  lbUpSync = swapper(lbVideo, upgradeSrc, {
    isCurrent: stillCurrent,
    // The full stream buffers with the pipe to itself, same as the
    // stage element (MAXH_LB_PIPE_EXCLUSIVE_V1, bridge-guarded).
    hold: (up) => {
      const pipe = lbPipe();
      if (pipe) pipe.hold(up);
    },
    // Paint proof: mount ABSOLUTE-OVER #lbVideo (same height-driven
    // box) — an unpainted video is transparent, so the tile stream
    // shows through until the first full-quality frame presents.
    mount: (up) => {
      up.style.cssText =
        'position:absolute;inset:0;margin:auto;z-index:2;pointer-events:none;' +
        'height:calc(var(--maxh-vvh, 100vh) * 0.9);width:auto;max-width:90vw;';
      lb.insertBefore(up, lbVideo);
    },
    // Hand-off (first frame proven painting): promote in place of
    // #lbVideo and retire the tile stream in the same task.
    commit: (up) => {
      up.style.cssText =
        'display:block;height:calc(var(--maxh-vvh, 100vh) * 0.9);width:auto;max-width:90vw;';
      if (lbVideo.hasAttribute('controls')) up.setAttribute('controls', '');
      lbVideo.pause();
      lbVideo.style.display = 'none';
      lbVideo.removeAttribute('src');
      try {
        lbVideo.load();
      } catch (_) {
        /* ignore */
      }
      lbRevokeLowBlob();
      lbHiVideo = up; // controls/idle-fade follow lbShownVideo()
    },
    onDone: () => {
      if (seq === lbUpSeq) lbUpSync = null;
    },
  });
}

function lbShowControls() {
  lb.classList.remove('lb-idle');
  // Chrome fades via CSS; the native control bar can't be dimmed from
  // CSS, so re-attach the attribute in lockstep. Guard on hasAttribute
  // so a busy stream of pointermove events doesn't thrash setAttribute.
  // MAXH_LB_VIDEO_UPGRADE_V1 — controls follow whichever element is on
  // stage (the tile starter or the swapped-in full stream).
  const v = lbShownVideo();
  if (lbCurrentIsVideo && !v.hasAttribute('controls')) {
    v.setAttribute('controls', '');
  }
}
function lbHideControls() {
  lb.classList.add('lb-idle');
  if (lbCurrentIsVideo) lbShownVideo().removeAttribute('controls');
}
function lbArmIdle() {
  lbShowControls();
  if (lbIdleTimer) {
    clearTimeout(lbIdleTimer);
    lbIdleTimer = null;
  }
  if (!LB_IDLE_ENABLED || !lbCurrentIsVideo) return;
  lbIdleTimer = setTimeout(() => {
    lbIdleTimer = null;
    if (lb.classList.contains('active') && lbCurrentIsVideo) lbHideControls();
  }, LB_IDLE_MS);
}
function lbClearIdle() {
  if (lbIdleTimer) {
    clearTimeout(lbIdleTimer);
    lbIdleTimer = null;
  }
  lbShowControls();
}

function openLightbox(slug, type, index) {
  // MAXH_BUNDLER_V1_DEFERRED — read DATA off window each call so this
  // works whether the module is inlined in the SPA IIFE (closure-
  // scoped DATA shadowed by window.DATA) or loaded via the deferred
  // bundle (no closure access; window.DATA is the only source).
  const DATA = window.DATA;
  if (!DATA) {
    // Try to load, then open
    loadData().then((d) => {
      if (d) openLightbox(slug, type, index);
    });
    return;
  }
  // MAXH_PERF_V4_LAZY_COUNTRY_DATA — country galleries (entry.i) ship in
  // country_data.json, fetched separately. If that bundle hasn't merged
  // onto DATA.countries[slug] yet, wait for COUNTRY_DATA_PROMISE before
  // reading entry.i. Cities/stories ship in data.json so they're already
  // populated by the time DATA is non-null.
  if (type === 'country' && window.COUNTRY_DATA_LOADED !== true && window.COUNTRY_DATA_PROMISE) {
    window.COUNTRY_DATA_PROMISE.then(function () {
      openLightbox(slug, type, index);
    });
    return;
  }
  // MAXH_PHASE4A_LB_CITIES — cities have their own DATA bucket
  const entry =
    type === 'country'
      ? DATA.countries[slug]
      : type === 'city'
        ? DATA.cities && DATA.cities[slug]
        : DATA.stories[slug];
  if (!entry) return;
  lbImages = entry.i;
  lbIndex = index;
  renderLightbox();
  lb.classList.add('active');
  document.body.classList.add('ts-no-scroll');
  document.documentElement.classList.add('ts-no-scroll');
  if (typeof window.maxhLockScroll === 'function') window.maxhLockScroll();
}
function renderLightbox() {
  if (!lbImages.length) return;
  const item = lbImages[lbIndex];
  const caps = INDEX_DATA.imageCaption || {};
  const alts = INDEX_DATA.imageAlt || {};
  // MAXH_LB_VIDEO_UPGRADE_V1 — every render starts from the singleton
  // #lbVideo: clear the previous item's upgrade artifacts first.
  lbResetVideoUpgrade();
  // MAXH_LB_LOADER_V1 — show spinner until the new asset's bytes arrive.
  // The class is toggled off in the load / canplay / error handlers below.
  lb.classList.add('is-loading');
  // MAXH_VIDEO_UPLOAD_V1 — videos play in <video>, photos render in <img>
  if (isVideoPath(item)) {
    lbCurrentIsVideo = true;
    lbImg.style.display = 'none';
    lbImg.src = '';
    const poster = videoPosterPath(item, INDEX_DATA.videoPosters);
    const primarySrc =
      typeof videoLightboxUrl === 'function' ? videoLightboxUrl(item) : videoUrl(item);
    const fallbackSrc =
      typeof videoLightboxFallbackUrl === 'function' ? videoLightboxFallbackUrl(item) : '';
    // MAXH_LB_VIDEO_UPGRADE_V1 — start LOW: the grid tile's rendition
    // (videoTileUrl is what galleryItemHtml bakes into the tile), from
    // the tile blob LRU when a scroll already banked it. Only ladder up
    // when the surface's selected stream is actually different (desktop
    // full vs tile; touch surfaces already select the tile and keep
    // today's single-stream open).
    const tileSrc = typeof videoTileUrl === 'function' ? videoTileUrl(item) : '';
    const pipe = lbPipe();
    let startSrc = primarySrc;
    let upgradeSrc = '';
    if (tileSrc && tileSrc !== primarySrc) {
      startSrc = tileSrc;
      upgradeSrc = primarySrc;
      const lowBlob =
        pipe && typeof pipe.cachedBlob === 'function' ? pipe.cachedBlob(tileSrc) : null;
      if (lowBlob) {
        lbLowBlobUrl = URL.createObjectURL(lowBlob);
        startSrc = lbLowBlobUrl;
      }
    }
    lbVideo.poster = poster ? imgUrl(poster, 2000) : '';
    lbVideo.dataset.fallbackSrc = fallbackSrc || '';
    delete lbVideo.dataset.fallbackTried;
    lbVideo.src = startSrc;
    lbVideo.muted = true;
    lbVideo.playsInline = true;
    lbVideo.setAttribute('playsinline', '');
    lbVideo.setAttribute('webkit-playsinline', '');
    lbVideo.style.display = 'block';
    lbVideo.play().catch(() => {}); // autoplay attempt; ignore browser blocks
    if (pipe) pipe.hold(lbVideo); // MAXH_LB_PIPE_EXCLUSIVE_V1 — starter owns the pipe
    if (upgradeSrc) lbStartUpgrade(upgradeSrc);
    lbArmIdle(); // MAXH_LB_IDLE_FADE_V1 — start the idle countdown
  } else {
    lbCurrentIsVideo = false;
    lbClearIdle(); // MAXH_LB_IDLE_FADE_V1 — photos keep persistent chrome
    lbVideo.pause();
    // Drop the fallback chain BEFORE the src so the (async) error event
    // an emptied element can fire never re-attaches a stale fallback;
    // removeAttribute (vs src='') keeps the teardown from erroring at all.
    delete lbVideo.dataset.fallbackSrc;
    delete lbVideo.dataset.fallbackTried;
    lbVideo.removeAttribute('src');
    try {
      lbVideo.load();
    } catch (_) {
      /* ignore */
    }
    lbVideo.style.display = 'none';
    lbImg.src = imgUrl(item, 2000);
    lbImg.alt = alts[item] || '';
    lbImg.style.display = 'block';
    // If the swap is served from cache, `complete` is already true and no
    // load event will fire — hide the spinner immediately to avoid a flash.
    if (lbImg.complete && lbImg.naturalWidth > 0) lb.classList.remove('is-loading');
  }
  lbCount.textContent = lbIndex + 1 + ' / ' + lbImages.length;
  lbCaption.textContent = caps[item] || '';
  lbCaption.style.display = caps[item] ? 'block' : 'none';
  preloadLbNeighbors();
}
// MAXH_LB_LOADER_V1 — clear the spinner as soon as the media is ready.
// `canplay` fires earlier than `loadeddata` for video; `error` keeps the
// spinner from getting stuck on a broken asset (user can hit prev/next).
lbImg.addEventListener('load', () => lb.classList.remove('is-loading'));
lbImg.addEventListener('error', () => lb.classList.remove('is-loading'));
lbVideo.addEventListener('canplay', () => lb.classList.remove('is-loading'));
lbVideo.addEventListener('error', () => {
  const fallback = lbVideo.dataset && lbVideo.dataset.fallbackSrc;
  if (
    fallback &&
    !lbVideo.dataset.fallbackTried &&
    lbVideo.getAttribute('src') !== fallback &&
    lbVideo.currentSrc !== fallback
  ) {
    lbVideo.dataset.fallbackTried = '1';
    // MAXH_LB_VIDEO_UPGRADE_V1 — the fallback is the full original; a
    // pending background upgrade would just re-deliver it. Reset also
    // revokes a dead starter blob URL; re-hold the element for the
    // retry (MAXH_LB_PIPE_EXCLUSIVE_V1).
    lbResetVideoUpgrade();
    const pipe = lbPipe();
    if (pipe) pipe.hold(lbVideo);
    lbVideo.src = fallback;
    try {
      lbVideo.load();
    } catch (_) {
      /* ignore */
    }
    try {
      const p = lbVideo.play();
      if (p && p.catch) p.catch(() => {});
    } catch (_) {
      /* ignore */
    }
    return;
  }
  lb.classList.remove('is-loading');
});
// MAXH_LB_PRELOAD_V1 — without this, clicking Next swaps the count and
// caption immediately but the <img> keeps painting the previous frame
// until the new bytes arrive, so it looks like the nav button is stuck.
// Eagerly fetching the neighbours at 2000w (same size renderLightbox
// requests) means the browser usually has the next frame decoded by
// the time the user taps, and the swap is instant.
function preloadLbNeighbors() {
  if (lbImages.length <= 1) return;
  // MAXH_LB_PIPE_EXCLUSIVE_V1 — while a video item is on stage its
  // stream owns the pipe; don't race it with 2000px neighbor fetches.
  // Photo items keep the eager neighbor warm (the nav-feels-stuck fix).
  if (lbCurrentIsVideo) return;
  for (const d of [-1, 1]) {
    const i = (lbIndex + d + lbImages.length) % lbImages.length;
    const item = lbImages[i];
    if (!item || isVideoPath(item)) continue;
    const pre = new Image();
    pre.decoding = 'async';
    pre.src = imgUrl(item, 2000);
  }
}
function closeLightbox() {
  lb.classList.remove('active');
  lb.classList.remove('is-loading');
  lbCurrentIsVideo = false;
  lbClearIdle(); // MAXH_LB_IDLE_FADE_V1 — kill timer + clear idle class
  // MAXH_LB_VIDEO_UPGRADE_V1 — drop upgrade artifacts + pipe holds with
  // the view; same fallback-before-src teardown order as the photo
  // branch so the emptied element can't resurrect a fallback stream.
  lbResetVideoUpgrade();
  lbImg.src = '';
  lbVideo.pause();
  delete lbVideo.dataset.fallbackSrc;
  delete lbVideo.dataset.fallbackTried;
  lbVideo.removeAttribute('src');
  try {
    lbVideo.load();
  } catch (_) {
    /* ignore */
  }
  document.body.classList.remove('ts-no-scroll');
  document.documentElement.classList.remove('ts-no-scroll');
  if (typeof window.maxhUnlockScroll === 'function') window.maxhUnlockScroll();
}
function lbNav(dir) {
  lbIndex = (lbIndex + dir + lbImages.length) % lbImages.length;
  renderLightbox();
}

document.addEventListener('click', (e) => {
  const gal = e.target.closest('.gal-item');
  if (!gal) return;
  // MAXH_COUNTRY_MAPS_TILE_V1 — non-photo CTA tiles (e.g. the Google
  // Maps list link on country pages) share .gal-item for grid sizing
  // but carry no lb index; let their own navigation run.
  if (!gal.hasAttribute('data-lb-index')) return;
  e.preventDefault();
  openLightbox(gal.dataset.slug, gal.dataset.type, parseInt(gal.dataset.lbIndex, 10) || 0);
});
lbClose.addEventListener('click', closeLightbox);
lbPrev.addEventListener('click', () => lbNav(-1));
lbNext.addEventListener('click', () => lbNav(1));
lb.addEventListener('click', (e) => {
  if (e.target === lb) closeLightbox();
});
// MAXH_OVERLAY_ROUTE_TEARDOWN_V1 — the lightbox is a global overlay: a
// route change (nav link, browser back) must collapse it, or it keeps
// covering the next page and its scroll lock never releases.
window.addEventListener('hashchange', () => {
  if (lb.classList.contains('active')) closeLightbox();
});
// MAXH_LB_IDLE_FADE_V1 — any cursor movement / press over the lightbox
// wakes the chrome + video controls and restarts the idle countdown.
// lbArmIdle no-ops cheaply on touch devices and while viewing a photo.
lb.addEventListener('pointermove', lbArmIdle);
lb.addEventListener('pointerdown', lbArmIdle);
document.addEventListener('keydown', (e) => {
  if (!lb.classList.contains('active')) return;
  lbArmIdle(); // MAXH_LB_IDLE_FADE_V1 — keyboard activity wakes controls
  if (e.key === 'Escape') closeLightbox();
  else if (e.key === 'ArrowLeft') lbNav(-1);
  else if (e.key === 'ArrowRight') lbNav(1);
});

// MAXH_LB_SWIPE_V1 — mobile gesture nav. Horizontal travel must beat
// SWIPE_MIN_PX and dominate vertical travel; vertical-leaning drags
// fall through so a future swipe-to-dismiss could layer on without
// fighting this handler. Multi-touch (pinch, two-finger pans) is
// ignored so the gesture never fires during zoom.
const SWIPE_MIN_PX = 40;
let lbTouchStartX = null;
let lbTouchStartY = null;
lb.addEventListener(
  'touchstart',
  (e) => {
    if (e.touches.length !== 1) {
      lbTouchStartX = lbTouchStartY = null;
      return;
    }
    lbTouchStartX = e.touches[0].clientX;
    lbTouchStartY = e.touches[0].clientY;
  },
  { passive: true }
);
lb.addEventListener(
  'touchend',
  (e) => {
    if (lbTouchStartX === null) return;
    const t = e.changedTouches && e.changedTouches[0];
    if (!t) {
      lbTouchStartX = lbTouchStartY = null;
      return;
    }
    const dx = t.clientX - lbTouchStartX;
    const dy = t.clientY - lbTouchStartY;
    lbTouchStartX = lbTouchStartY = null;
    if (Math.abs(dx) < SWIPE_MIN_PX || Math.abs(dx) <= Math.abs(dy)) return;
    lbNav(dx < 0 ? 1 : -1);
  },
  { passive: true }
);

// MAXH_LIGHTBOX_WHEEL_NAV_V1 — wheel/trackpad paging. Mirrors the keyboard
// and swipe handlers above so a mouse wheel or trackpad scroll pages photos
// instead of leaving the image frozen. createWheelStepper collapses a
// trackpad flick's momentum tail into a single step (a raw delta>0 test
// would jump a dozen photos per gesture). Body scroll is already locked
// while the lightbox is active, so preventDefault here only stops the
// rubber-band overscroll on the overlay itself.
const lbWheelStep = createWheelStepper();
lb.addEventListener(
  'wheel',
  (e) => {
    if (!lb.classList.contains('active')) return;
    const d = normalizeWheelDelta(e, 16, window.innerHeight || 800);
    if (!d) return;
    e.preventDefault();
    lbArmIdle(); // MAXH_LB_IDLE_FADE_V1 — wheel activity wakes the chrome
    const dir = lbWheelStep(d, e.timeStamp);
    if (dir) lbNav(dir);
  },
  { passive: false }
);

// ── MAXH_EBC_FILM_V1 — load-on-play film lightbox ───────────────────
// A standalone overlay (#filmLb) for a story's featured film. Kept
// separate from the gallery lightbox above so its autoplay-muted-loop
// video path stays untouched. openFilmLb() shows the poster only: the
// <video> keeps preload="none" and is never auto-played, so no media
// bytes are fetched until the viewer presses the native play control.
// closeFilmLb() pauses and drops the src so a half-watched stream stops
// buffering and the connection is released.
const filmLb = document.getElementById('filmLb');
const filmLbVideo = document.getElementById('filmLbVideo');
const filmLbClose = document.getElementById('filmLbClose');
function openFilmLb(src, poster) {
  if (!filmLb || !filmLbVideo || !src) return;
  filmLbVideo.setAttribute('preload', 'none'); // belt-and-suspenders: no preload
  filmLbVideo.poster = poster || '';
  filmLbVideo.src = src; // no play() + preload=none => nothing downloads yet
  filmLb.classList.add('active');
  filmLb.setAttribute('aria-hidden', 'false');
  document.body.classList.add('ts-no-scroll');
  document.documentElement.classList.add('ts-no-scroll');
  if (typeof window.maxhLockScroll === 'function') window.maxhLockScroll();
}
function closeFilmLb() {
  if (!filmLb) return;
  filmLb.classList.remove('active');
  filmLb.setAttribute('aria-hidden', 'true');
  try {
    filmLbVideo.pause();
  } catch (_) {
    /* ignore */
  }
  filmLbVideo.removeAttribute('src'); // stop buffering / release the stream
  filmLbVideo.load();
  document.body.classList.remove('ts-no-scroll');
  document.documentElement.classList.remove('ts-no-scroll');
  if (typeof window.maxhUnlockScroll === 'function') window.maxhUnlockScroll();
}
if (filmLb && filmLbVideo) {
  if (filmLbClose) filmLbClose.addEventListener('click', closeFilmLb);
  filmLb.addEventListener('click', (e) => {
    if (e.target === filmLb) closeFilmLb();
  });
  document.addEventListener('keydown', (e) => {
    if (filmLb.classList.contains('active') && e.key === 'Escape') closeFilmLb();
  });
  // Delegated trigger: .story-film-trigger is rendered per route by
  // renderStoryFilm() (story.js), so the listener lives on document.
  document.addEventListener('click', (e) => {
    const trig = e.target.closest('.story-film-trigger');
    if (!trig) return;
    e.preventDefault();
    openFilmLb(trig.getAttribute('data-film-src'), trig.getAttribute('data-film-poster'));
  });
}

;
/* MAXH_BUNDLER_V1_DEFERRED: src/js/spa/renderers/popup-utils.js */
// ════════════════════════════════════════════════════════════════════
// src/js/spa/renderers/popup-utils.js
// ────────────────────────────────────────────────────────────────────
// MAXH_POPUP_UTILS_V1 — shared helpers for the flight, scuba, and
// health stat popups. Each popup file is its own IIFE inlined into the
// SPA main IIFE; the functions below sit at the SPA-IIFE top level
// (no wrapper) so the popup IIFEs that follow this token in
// template.html can reference them through lexical scope.
//
// Inlined back into the SPA main IIFE through build.py's
// INLINE_JS_BUNDLES manifest. NOT a standalone module.
//
// Header comments deliberately avoid the literal close-tag forms
// of s-c-r-i-p-t and s-t-y-l-e wrapped in angle brackets.
// See CLAUDE.md §15.4 gotchas #1 and #5.
// ════════════════════════════════════════════════════════════════════

const MAXH_POPUP_MONTHS_SHORT = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

function maxhPopupFmt(n) {
  if (typeof n !== 'number' || !isFinite(n)) return '';
  return n.toLocaleString();
}

function maxhPopupSetText(el, v) {
  if (!el) return;
  el.textContent = v == null || v === '' ? '' : v;
}

// "2024-01" → "Jan 2024"; with withDay=true, "2024-01-27" → "Jan 27, 2024".
function maxhPopupPrettyDate(iso, withDay) {
  if (!iso || iso.length < 7) return '';
  const y = iso.slice(0, 4);
  const m = parseInt(iso.slice(5, 7), 10);
  if (!m || m < 1 || m > 12) return y;
  if (!withDay || iso.length < 10) return MAXH_POPUP_MONTHS_SHORT[m - 1] + ' ' + y;
  const d = parseInt(iso.slice(8, 10), 10);
  if (!d) return iso;
  return MAXH_POPUP_MONTHS_SHORT[m - 1] + ' ' + d + ', ' + y;
}

// Wire the common open/close + click delegation + keyboard pattern.
// opts = {
//   triggerAttr,    // e.g. 'data-flight-stats' — opens on click/Enter/Space
//   closeEl,        // optional explicit close button
//   scrollEl,       // optional scrollable element to reset on open
//   onBeforeOpen,   // optional callback fired right before showing
//   exposeAs,       // optional name → window.open<Name>Popup / close<Name>Popup
// }
// Returns { open, close } for callers that need to drive the popup directly.
function maxhPopupSetup(POP, opts) {
  if (!POP) return null;
  const triggerAttr = opts.triggerAttr;
  const triggerSel = '[' + triggerAttr + ']';
  let lastTrigger = null;
  let previousFocus = null;

  function visibleFocusable() {
    return Array.prototype.filter.call(
      POP.querySelectorAll(
        'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
      ),
      function (el) {
        const style = window.getComputedStyle(el);
        const box = el.getBoundingClientRect();
        return (
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          box.width > 0 &&
          box.height > 0
        );
      }
    );
  }

  function focusPopup() {
    const focusables = visibleFocusable();
    const target = opts.closeEl || focusables[0] || POP;
    if (target === POP && !POP.hasAttribute('tabindex')) POP.setAttribute('tabindex', '-1');
    try {
      target.focus({ preventScroll: true });
    } catch (_) {
      target.focus();
    }
  }

  function open() {
    previousFocus =
      document.activeElement && document.activeElement !== document.body
        ? document.activeElement
        : null;
    if (opts.onBeforeOpen) opts.onBeforeOpen();
    POP.classList.add('is-open');
    POP.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ts-no-scroll');
    if (typeof window.maxhLockScroll === 'function') window.maxhLockScroll();
    if (opts.scrollEl) opts.scrollEl.scrollTop = 0;
    focusPopup();
  }

  function close() {
    const restoreTarget = lastTrigger || previousFocus;
    POP.classList.remove('is-open');
    POP.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ts-no-scroll');
    if (typeof window.maxhUnlockScroll === 'function') window.maxhUnlockScroll();
    if (restoreTarget && restoreTarget.isConnected && typeof restoreTarget.focus === 'function') {
      try {
        restoreTarget.focus({ preventScroll: true });
      } catch (_) {
        restoreTarget.focus();
      }
    }
    lastTrigger = null;
    previousFocus = null;
  }

  // MAXH_OVERLAY_ROUTE_TEARDOWN_V1 — a route change (nav link, browser
  // back) with the popup open would strand its scroll lock on the next
  // page; collapse it like Escape does.
  window.addEventListener('hashchange', function () {
    if (POP.classList.contains('is-open')) close();
  });

  document.addEventListener(
    'click',
    function (e) {
      if (!e || !e.target || !e.target.closest) return;
      const trigger = e.target.closest(triggerSel);
      if (trigger) {
        e.preventDefault();
        lastTrigger = trigger;
        open();
      }
    },
    false
  );

  document.addEventListener('keydown', function (e) {
    if (!e) return;
    if (POP.classList.contains('is-open') && e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }
    if (POP.classList.contains('is-open') && e.key === 'Tab') {
      const focusables = visibleFocusable();
      if (!focusables.length) {
        e.preventDefault();
        focusPopup();
        return;
      }
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      const active = document.activeElement;
      if (e.shiftKey && (active === first || !POP.contains(active))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (active === last || !POP.contains(active))) {
        e.preventDefault();
        first.focus();
      }
      return;
    }
    const t = e.target;
    if (t && t.closest && t.closest(triggerSel)) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        lastTrigger = t.closest(triggerSel);
        open();
      }
    }
  });

  // Read-only modal: any click inside the popup shell closes it.
  POP.addEventListener('click', close);
  if (opts.closeEl) {
    opts.closeEl.addEventListener('click', function (e) {
      e.stopPropagation();
      close();
    });
  }

  if (opts.exposeAs) {
    window['open' + opts.exposeAs + 'Popup'] = open;
    window['close' + opts.exposeAs + 'Popup'] = close;
  }

  return { open: open, close: close };
}

;
/* MAXH_BUNDLER_V1_DEFERRED: src/js/spa/renderers/flight-popup.js */
// ════════════════════════════════════════════════════════════════════
// src/js/spa/renderers/flight-popup.js
// ────────────────────────────────────────────────────────────────────
// MAXH_FLIGHT_POPUP_V1 — aggregate flight-stats popup.
//
// Click any element with [data-flight-stats] (homepage "flights taken"
// block, Where Next miles / airlines cells, About-page journey map +
// "the path" kicker + Aloft rows + miles-flown stat) to open a
// scrollable card showing the user's lifetime flight aggregates:
//   • Total flights, miles, time in air, average duration
//   • Airline / airport / delay pills and Earth / Moon / Sun equivalents
//   • Records: longest + shortest routes (miles, duration, carrier)
//   • Top airlines, routes, airports with horizontal bars
//   • 12-month flights distribution chart
//
// Data source: INDEX_DATA.flightStats, baked at build time by
// flighty_hotels.compute_flight_aggregate_for_popup. See build.py
// (_phase_build_tokens) for the wiring.
//
// IMPORTANT — this file is inlined back into the SPA's main IIFE
// at build time via build.py's inline SPA manifest.
// It relies on the surrounding closure for esc() and on
// maxhPopupFmt / maxhPopupSetText / maxhPopupSetup from popup-utils.js,
// which inlines just before this file. NOT a standalone module.
//
// Header comments deliberately avoid the literal close-tag forms
// of s-c-r-i-p-t and s-t-y-l-e wrapped in angle brackets, because
// those would prematurely end the surrounding inline block once
// the file is inlined. See CLAUDE.md §15.4 gotchas #1 and #5.
// ════════════════════════════════════════════════════════════════════
(function setupFlightPopup() {
  const POP = document.getElementById('flightPop');
  if (!POP) return;

  const elClose = document.getElementById('flightPopClose');
  const elSub = document.getElementById('flightPopSub');
  const elFlights = document.getElementById('flightPopFlights');
  const elFlightsMeta = document.getElementById('flightPopFlightsMeta');
  const elMiles = document.getElementById('flightPopMiles');
  const elMilesSub = document.getElementById('flightPopMilesSub');
  const elHours = document.getElementById('flightPopHours');
  const elHoursSub = document.getElementById('flightPopHoursSub');
  const elAvg = document.getElementById('flightPopAvg');
  const elLongHaul = document.getElementById('flightPopLongHaul');
  const elFactPills = document.getElementById('flightPopFactPills');
  const elOrbits = document.getElementById('flightPopOrbits');
  const elLongestRoute = document.getElementById('flightPopLongestRoute');
  const elLongestMeta = document.getElementById('flightPopLongestMeta');
  const elShortestRoute = document.getElementById('flightPopShortestRoute');
  const elShortestMeta = document.getElementById('flightPopShortestMeta');
  const elAirportTimeVal = document.getElementById('flightPopAirportTimeVal');
  const elAirportTimeMeta = document.getElementById('flightPopAirportTimeMeta');
  const elAirlines = document.getElementById('flightPopAirlines');
  const elAirlinesTotal = document.getElementById('flightPopAirlinesTotal');
  const elRoutes = document.getElementById('flightPopRoutes');
  const elRoutesTotal = document.getElementById('flightPopRoutesTotal');
  const elAirports = document.getElementById('flightPopAirports');
  const elAirportsTotal = document.getElementById('flightPopAirportsTotal');
  const elChart = document.getElementById('flightPopChart');
  const elScroll = POP.querySelector('.flight-pop-scroll');

  let rendered = false;
  const fmt = maxhPopupFmt;
  const setText = maxhPopupSetText;

  // Pretty-print large hour counts: 1770 → "1,770h" with a "73 days" subtitle.
  function hoursMeta(hours) {
    if (!hours) return '';
    const days = Math.round(hours / 24);
    const weeks = Math.round(hours / 168);
    if (days >= 21) return days + ' days · ' + weeks + ' wks aloft';
    return days + ' days aloft';
  }

  function fmtMonths(monthsTotal) {
    if (!monthsTotal) return '';
    return monthsTotal + ' mo aloft';
  }

  function renderBars(parent, entries, keyA, keyB) {
    if (!parent) return;
    parent.innerHTML = '';
    if (!Array.isArray(entries) || !entries.length) {
      const li = document.createElement('li');
      li.className = 'flight-pop-bar flight-pop-bar-empty';
      li.textContent = '—';
      parent.appendChild(li);
      return;
    }
    const max =
      Math.max.apply(
        null,
        entries.map(function (e) {
          return e.count || 0;
        })
      ) || 1;
    entries.forEach(function (e) {
      const li = document.createElement('li');
      li.className = 'flight-pop-bar';
      const labelText = (keyA ? e[keyA] : '') || (keyB ? e[keyB] : '');
      const name = document.createElement('span');
      name.className = 'flight-pop-bar-name';
      name.textContent = labelText || '';
      if (keyA === 'name' && e.code && e.code !== e.name) {
        // tooltip with the IATA/ICAO code for power users
        name.title = e.code;
      }
      const track = document.createElement('span');
      track.className = 'flight-pop-bar-track';
      const fill = document.createElement('span');
      fill.className = 'flight-pop-bar-fill';
      const pct = Math.max(2, Math.round(((e.count || 0) / max) * 100));
      fill.style.width = pct + '%';
      track.appendChild(fill);
      const val = document.createElement('span');
      val.className = 'flight-pop-bar-val';
      val.textContent = fmt(e.count || 0);
      li.appendChild(name);
      li.appendChild(track);
      li.appendChild(val);
      parent.appendChild(li);
    });
  }

  function renderChart(parent, byMonth) {
    if (!parent) return;
    parent.innerHTML = '';
    if (!Array.isArray(byMonth) || !byMonth.length) return;
    const canTrackTooltip =
      !window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const tooltip = document.createElement('div');
    tooltip.className = 'flight-pop-chart-tip';
    tooltip.setAttribute('aria-hidden', 'true');
    parent.appendChild(tooltip);
    let tipVisible = false;
    let tipFrame = 0;
    let tipX = 0;
    let tipY = 0;
    let targetX = 0;
    let targetY = 0;

    function setTooltipTarget(e, immediate) {
      if (!canTrackTooltip || !e) return;
      const rect = parent.getBoundingClientRect();
      const tipW = tooltip.offsetWidth || 86;
      const tipH = tooltip.offsetHeight || 28;
      let x = e.clientX - rect.left + 14;
      let y = e.clientY - rect.top - tipH - 14;
      if (y < 4) y = e.clientY - rect.top + 14;
      targetX = Math.max(4, Math.min(rect.width - tipW - 4, x));
      targetY = Math.max(4, Math.min(rect.height - tipH - 4, y));
      if (immediate) {
        tipX = targetX;
        tipY = targetY;
        tooltip.style.transform = 'translate3d(' + tipX + 'px,' + tipY + 'px,0)';
      }
      if (!tipFrame) tipFrame = window.requestAnimationFrame(tickTooltip);
    }

    function tickTooltip() {
      if (!tipVisible) {
        tipFrame = 0;
        return;
      }
      const dx = targetX - tipX;
      const dy = targetY - tipY;
      tipX += dx * 0.35;
      tipY += dy * 0.35;
      tooltip.style.transform =
        'translate3d(' + tipX.toFixed(1) + 'px,' + tipY.toFixed(1) + 'px,0)';
      if (Math.abs(dx) > 0.25 || Math.abs(dy) > 0.25) {
        tipFrame = window.requestAnimationFrame(tickTooltip);
      } else {
        tipFrame = 0;
      }
    }

    function showTip(e, label) {
      if (!canTrackTooltip) return;
      tooltip.textContent = label;
      tipVisible = true;
      tooltip.classList.add('is-visible');
      setTooltipTarget(e, true);
    }

    function moveTip(e) {
      setTooltipTarget(e, false);
    }

    function hideTip() {
      tipVisible = false;
      tooltip.classList.remove('is-visible');
      if (tipFrame) window.cancelAnimationFrame(tipFrame);
      tipFrame = 0;
    }

    const max =
      Math.max.apply(
        null,
        byMonth.map(function (m) {
          return m.count || 0;
        })
      ) || 1;
    byMonth.forEach(function (m) {
      const col = document.createElement('div');
      col.className = 'flight-pop-chart-col';
      const tooltipLabel = m.month + ' · ' + fmt(m.count || 0);
      col.setAttribute('aria-label', tooltipLabel);
      if (canTrackTooltip) {
        col.addEventListener('pointerenter', function (e) {
          showTip(e, tooltipLabel);
        });
        col.addEventListener('pointermove', moveTip);
        col.addEventListener('pointerleave', hideTip);
      }
      const count = document.createElement('div');
      count.className = 'flight-pop-chart-count';
      count.textContent = fmt(m.count || 0);
      const slot = document.createElement('div');
      slot.className = 'flight-pop-chart-slot';
      const bar = document.createElement('div');
      bar.className = 'flight-pop-chart-bar';
      const h = Math.max(2, Math.round(((m.count || 0) / max) * 100));
      col.style.setProperty('--flight-pop-chart-height', h + '%');
      bar.style.height = h + '%';
      const lab = document.createElement('div');
      lab.className = 'flight-pop-chart-lab';
      lab.textContent = m.month;
      slot.appendChild(count);
      slot.appendChild(bar);
      col.appendChild(slot);
      col.appendChild(lab);
      parent.appendChild(col);
    });
  }

  const PILL_ICONS = {
    plane:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12.5 21 4l-6.8 16-3.2-6.8L3 12.5Z"/><path d="m11 13.2 10-9.2"/></svg>',
    airport:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s6-5.5 6-11a6 6 0 1 0-12 0c0 5.5 6 11 6 11Z"/><circle cx="12" cy="10" r="2"/></svg>',
    delay:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5v5l3.2 2"/></svg>',
    earth:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h17"/><path d="M12 3.5c2.3 2.4 3.4 5.2 3.4 8.5s-1.1 6.1-3.4 8.5"/><path d="M12 3.5c-2.3 2.4-3.4 5.2-3.4 8.5s1.1 6.1 3.4 8.5"/></svg>',
    moon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round"><path d="M17.8 15.8A7.5 7.5 0 0 1 8.2 6.2a8.2 8.2 0 1 0 9.6 9.6Z"/></svg>',
    sun: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3.4"/><path d="M12 3v2M12 19v2M4.8 4.8l1.4 1.4M17.8 17.8l1.4 1.4M3 12h2M19 12h2M4.8 19.2l1.4-1.4M17.8 6.2l1.4-1.4"/></svg>',
  };

  function setPillIcon(icon, iconName) {
    icon.setAttribute('aria-hidden', 'true');
    icon.dataset.icon = iconName;
    icon.innerHTML = PILL_ICONS[iconName] || '';
  }

  function appendPill(parent, iconName, valueText, labelText) {
    const wrap = document.createElement('div');
    wrap.className = 'flight-pop-orbit';
    const icon = document.createElement('span');
    icon.className = 'flight-pop-orbit-icon';
    setPillIcon(icon, iconName);
    const body = document.createElement('div');
    const val = document.createElement('div');
    val.className = 'flight-pop-orbit-val';
    val.textContent = valueText;
    const lab = document.createElement('div');
    lab.className = 'flight-pop-orbit-lab';
    lab.textContent = labelText;
    body.appendChild(val);
    body.appendChild(lab);
    wrap.appendChild(icon);
    wrap.appendChild(body);
    parent.appendChild(wrap);
  }

  function renderFactPills(parent, fs) {
    if (!parent) return;
    parent.innerHTML = '';
    const facts = [
      {
        icon: 'plane',
        val: fs.airlines_total,
        lab: 'Different airlines flown',
        format: function (v) {
          return fmt(v);
        },
      },
      {
        icon: 'airport',
        val: fs.airports_total,
        lab: 'Total airports visited',
        format: function (v) {
          return fmt(v);
        },
      },
      {
        icon: 'delay',
        val: fs.delay_hours,
        lab: 'Hours lost from delays',
        allowZero: true,
        format: function (v) {
          return fmt(v) + 'h';
        },
      },
    ];
    facts.forEach(function (p) {
      if (typeof p.val !== 'number' || (!p.allowZero && p.val <= 0)) return;
      appendPill(parent, p.icon, p.format(p.val), p.lab);
    });
  }

  function renderOrbits(parent, fs) {
    if (!parent) return;
    parent.innerHTML = '';
    const orbits = [
      { icon: 'earth', val: fs.earth_trips, lab: 'Around earth' },
      { icon: 'moon', val: fs.moon_trips, lab: 'To the moon' },
      { icon: 'sun', val: fs.sun_trips, lab: 'Around the sun' },
    ];
    orbits.forEach(function (o) {
      if (typeof o.val !== 'number' || o.val <= 0) return;
      appendPill(parent, o.icon, o.val.toFixed(1) + '×', o.lab);
    });
  }

  function getStats() {
    return (window.INDEX_DATA && INDEX_DATA.flightStats) || null;
  }

  function render() {
    const fs = getStats();
    if (!fs) {
      setText(elSub, 'Flight data is unavailable right now.');
      return;
    }

    setText(elFlights, fmt(fs.total_flights));
    // Both eyebrow + hero meta say "since <month> <year>" — every number in
    // the popup is filtered to the same trip-start cutoff as the homepage
    // qs-item, About-page Aloft rows, and Where-Next stats strip, so all
    // surfaces advance in lockstep when a new flight is logged.
    const MONTHS = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    const startMo = MONTHS[(fs.trip_start_month || 1) - 1] || '';
    const startYr = fs.trip_start_year || '';
    const sinceLabel = startMo && startYr ? 'since ' + startMo + ' ' + startYr : '';
    setText(elFlightsMeta, sinceLabel);
    setText(elSub, sinceLabel ? 'Every flight ' + sinceLabel : '');

    setText(elMiles, fmt(fs.total_miles));
    setText(elMilesSub, 'miles');
    setText(elHours, fmt(fs.total_hours) + 'h');
    setText(elHoursSub, hoursMeta(fs.total_hours));
    if (fs.avg_min) {
      const h = Math.floor(fs.avg_min / 60);
      const m = fs.avg_min % 60;
      setText(elAvg, h ? h + 'h ' + m + 'm' : m + 'm');
    } else {
      setText(elAvg, '—');
    }
    setText(elLongHaul, fs.long_haul ? fs.long_haul + ' long-haul' : '');

    renderFactPills(elFactPills, fs);
    renderOrbits(elOrbits, fs);

    const lg = fs.longest || null;
    if (lg) {
      setText(elLongestRoute, lg.route);
      setText(
        elLongestMeta,
        [
          lg.miles ? lg.miles.toLocaleString() + ' mi' : '',
          lg.duration,
          lg.carrier ? lg.carrier + (lg.num ? ' ' + lg.num : '') : '',
        ]
          .filter(Boolean)
          .join(' · ')
      );
    } else {
      setText(elLongestRoute, '—');
      setText(elLongestMeta, '');
    }
    const sh = fs.shortest || null;
    if (sh) {
      setText(elShortestRoute, sh.route);
      setText(
        elShortestMeta,
        [
          sh.miles ? sh.miles.toLocaleString() + ' mi' : '',
          sh.duration,
          sh.carrier ? sh.carrier + (sh.num ? ' ' + sh.num : '') : '',
        ]
          .filter(Boolean)
          .join(' · ')
      );
    } else {
      setText(elShortestRoute, '—');
      setText(elShortestMeta, '');
    }

    const flightsForAirport = typeof fs.total_flights === 'number' ? fs.total_flights : 0;
    if (flightsForAirport > 0) {
      const airportHours = flightsForAirport * 3;
      const airportDays = Math.round(airportHours / 24);
      setText(elAirportTimeVal, airportHours.toLocaleString() + 'h');
      setText(
        elAirportTimeMeta,
        airportDays >= 1 ? airportDays + (airportDays === 1 ? ' day' : ' days') : ''
      );
    } else {
      setText(elAirportTimeVal, '—');
      setText(elAirportTimeMeta, '');
    }

    renderBars(elAirlines, fs.top_airlines, 'name', 'code');
    setText(elAirlinesTotal, fs.airlines_total ? fs.airlines_total + ' airlines total' : '');

    renderBars(elRoutes, fs.top_routes, 'route');
    setText(
      elRoutesTotal,
      fs.routes_total ? fs.routes_total.toLocaleString() + ' routes total' : ''
    );

    renderBars(elAirports, fs.top_airports, 'iata');
    setText(elAirportsTotal, fs.airports_total ? fs.airports_total + ' airports total' : '');

    renderChart(elChart, fs.by_month);

    rendered = true;
  }

  // MAXH_FLIGHT_POPUP_V1 — click ANYWHERE inside the popup closes it (the
  // scrim already did; the card now does too, because the popup is purely
  // read-only — no interactive elements other than the close button).
  // The shared helper moves focus into the modal, traps Tab, and restores the
  // trigger on close. window.openFlightPopup / window.closeFlightPopup are
  // exposed via opts.exposeAs.
  maxhPopupSetup(POP, {
    triggerAttr: 'data-flight-stats',
    closeEl: elClose,
    scrollEl: elScroll,
    onBeforeOpen: function () {
      if (!rendered) render();
    },
    exposeAs: 'Flight',
  });
})();

;
/* MAXH_BUNDLER_V1_DEFERRED: src/js/spa/renderers/scuba-popup.js */
// ════════════════════════════════════════════════════════════════════
// src/js/spa/renderers/scuba-popup.js
// ────────────────────────────────────────────────────────────────────
// MAXH_SCUBA_POPUP_V1 — sibling of MAXH_FLIGHT_POPUP_V1.
//
// Click any element with [data-scuba-stats] (currently the "scuba
// diving" phrase in the About-page why-prose) to open a scrollable
// card showing aggregated dive-log stats:
//   * Total dives, bottom time, deepest, longest
//   * Equivalents (days submerged, Eiffel Towers descended)
//   * Records (deepest / longest / coldest / warmest dive)
//   * Top destination countries with horizontal bars
//   * Dives-by-year chart
//
// Data source: INDEX_DATA.scubaStats, baked at build time by
// admin/lib/divelog.py::compute_dive_aggregate_for_popup.
//
// IMPORTANT — this file is inlined back into the SPA's main IIFE at
// build time via build.py's inline SPA manifest. Relies on
// maxhPopupFmt / maxhPopupSetText / maxhPopupPrettyDate / maxhPopupSetup
// from popup-utils.js, which inlines just before this file. Header
// comments deliberately avoid the literal close-tag forms of
// s-c-r-i-p-t and s-t-y-l-e wrapped in angle brackets — those would
// prematurely end the surrounding inline block (see CLAUDE.md §15.4).
// ════════════════════════════════════════════════════════════════════
(function setupScubaPopup() {
  const POP = document.getElementById('scubaPop');
  if (!POP) return;

  const elClose = document.getElementById('scubaPopClose');
  const elSub = document.getElementById('scubaPopSub');
  const elDives = document.getElementById('scubaPopDives');
  const elDivesMeta = document.getElementById('scubaPopDivesMeta');
  const elBottom = document.getElementById('scubaPopBottom');
  const elBottomSub = document.getElementById('scubaPopBottomSub');
  const elDeepest = document.getElementById('scubaPopDeepest');
  const elDeepestSub = document.getElementById('scubaPopDeepestSub');
  const elAvgDepth = document.getElementById('scubaPopAvgDepth');
  const elAvgDepthSub = document.getElementById('scubaPopAvgDepthSub');
  const elEquiv = document.getElementById('scubaPopEquiv');
  const elDeepestRoute = document.getElementById('scubaPopDeepestRoute');
  const elDeepestRouteMeta = document.getElementById('scubaPopDeepestRouteMeta');
  const elLongestRoute = document.getElementById('scubaPopLongestRoute');
  const elLongestRouteMeta = document.getElementById('scubaPopLongestRouteMeta');
  const elColdRoute = document.getElementById('scubaPopColdRoute');
  const elColdRouteMeta = document.getElementById('scubaPopColdRouteMeta');
  const elWarmRoute = document.getElementById('scubaPopWarmRoute');
  const elWarmRouteMeta = document.getElementById('scubaPopWarmRouteMeta');
  const elCountries = document.getElementById('scubaPopCountries');
  const elCountriesTotal = document.getElementById('scubaPopCountriesTotal');
  const elChart = document.getElementById('scubaPopChart');
  const elForestSection = document.getElementById('scubaPopForestSection');
  const elForest = document.getElementById('scubaPopForest');
  const elForestAxt = document.getElementById('scubaPopForestAxt');
  const elForestSub = document.getElementById('scubaPopForestSub');
  const elScroll = POP.querySelector('.scuba-pop-scroll');

  let rendered = false;
  const fmt = maxhPopupFmt;
  const setText = maxhPopupSetText;

  function recordMeta(rec) {
    if (!rec) return '';
    const parts = [];
    if (rec.country) parts.push(rec.country);
    if (rec.date) parts.push(maxhPopupPrettyDate(rec.date, false));
    return parts.join(' · ');
  }

  function renderBars(parent, entries, key) {
    if (!parent) return;
    parent.innerHTML = '';
    if (!Array.isArray(entries) || !entries.length) {
      const li = document.createElement('li');
      li.className = 'scuba-pop-bar scuba-pop-bar-empty';
      li.textContent = '—';
      parent.appendChild(li);
      return;
    }
    const max =
      Math.max.apply(
        null,
        entries.map(function (e) {
          return e.count || 0;
        })
      ) || 1;
    entries.forEach(function (e) {
      const li = document.createElement('li');
      li.className = 'scuba-pop-bar';
      const name = document.createElement('span');
      name.className = 'scuba-pop-bar-name';
      name.textContent = (key ? e[key] : '') || '';
      const track = document.createElement('span');
      track.className = 'scuba-pop-bar-track';
      const fill = document.createElement('span');
      fill.className = 'scuba-pop-bar-fill';
      const pct = Math.max(2, Math.round(((e.count || 0) / max) * 100));
      fill.style.width = pct + '%';
      track.appendChild(fill);
      const val = document.createElement('span');
      val.className = 'scuba-pop-bar-val';
      val.textContent = fmt(e.count || 0);
      li.appendChild(name);
      li.appendChild(track);
      li.appendChild(val);
      parent.appendChild(li);
    });
  }

  function renderChart(parent, byYear) {
    if (!parent) return;
    parent.innerHTML = '';
    if (!Array.isArray(byYear) || !byYear.length) return;
    const max =
      Math.max.apply(
        null,
        byYear.map(function (y) {
          return y.count || 0;
        })
      ) || 1;
    byYear.forEach(function (y) {
      const col = document.createElement('div');
      col.className = 'scuba-pop-chart-col';
      const bar = document.createElement('div');
      bar.className = 'scuba-pop-chart-bar';
      const h = Math.max(2, Math.round(((y.count || 0) / max) * 100));
      bar.style.height = h + '%';
      bar.title = y.year + ' · ' + (y.count || 0) + ' dives';
      const lab = document.createElement('div');
      lab.className = 'scuba-pop-chart-lab';
      lab.textContent = y.year;
      const num = document.createElement('div');
      num.className = 'scuba-pop-chart-num';
      num.textContent = y.count || 0;
      col.appendChild(num);
      col.appendChild(bar);
      col.appendChild(lab);
      parent.appendChild(col);
    });
  }

  // MAXH_SCUBA_FOREST_V1 — "forest of descents". Overlays every logged
  // dive's normalized depth profile on one shared depth scale, each thread
  // tinted by its mean water temperature, with the average dive drawn on
  // top. Reads INDEX_DATA.scubaStats.forest (built by admin/lib/divelog.py).
  // The colour-ramp endpoints come from the --scuba-forest-cold/-warm CSS
  // vars so the site theme (light/dark) drives them; we read + interpolate.
  function parseRGB(str) {
    str = (str || '').trim();
    if (str.charAt(0) === '#') {
      let h = str.slice(1);
      if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      if (h.length >= 6) {
        return [
          parseInt(h.slice(0, 2), 16),
          parseInt(h.slice(2, 4), 16),
          parseInt(h.slice(4, 6), 16),
        ];
      }
    }
    const m = str.match(/[\d.]+/g);
    if (m && m.length >= 3) return [+m[0], +m[1], +m[2]];
    return [60, 130, 140];
  }

  function renderForest(forest) {
    if (!elForest || !elForestSection) return;
    const dives = forest && Array.isArray(forest.dives) ? forest.dives : [];
    const maxM = forest && forest.max_m;
    if (!dives.length || !maxM) {
      elForestSection.hidden = true;
      return;
    }
    elForestSection.hidden = false;

    const W = 1000;
    const H = 520;
    const padTop = 18;
    const padBot = 20;
    const yOf = function (m) {
      return padTop + (m / maxM) * (H - padBot - padTop);
    };
    const xOf = function (i, n) {
      return n <= 1 ? 0 : (i / (n - 1)) * W;
    };
    const pathFor = function (d) {
      let s = '';
      for (let i = 0; i < d.length; i++) {
        s += (i ? ' L' : 'M') + xOf(i, d.length).toFixed(1) + ' ' + yOf(d[i]).toFixed(1);
      }
      return s;
    };

    // Temperature ramp — endpoints read from CSS (theme-aware).
    const cs = getComputedStyle(elForestSection);
    const cold = parseRGB(cs.getPropertyValue('--scuba-forest-cold'));
    const warm = parseRGB(cs.getPropertyValue('--scuba-forest-warm'));
    const tmin = typeof forest.tmin === 'number' ? forest.tmin : 0;
    const tmax = typeof forest.tmax === 'number' ? forest.tmax : 1;
    const tspan = tmax - tmin || 1;
    const rampK = function (k) {
      const ch = function (i) {
        return Math.round(cold[i] + (warm[i] - cold[i]) * k);
      };
      return 'rgb(' + ch(0) + ',' + ch(1) + ',' + ch(2) + ')';
    };

    // Threads — bucket every dive by temperature so the whole forest is a
    // handful of <path>s (one stroke pass per colour band) rather than 91.
    // 91 individual paths — with non-scaling-stroke + a drop-shadow filter
    // under the non-uniform stretch — hung the renderer for seconds and
    // choked modal scroll; ~7 plain bucketed paths paint instantly.
    const NB = 7;
    const buckets = [];
    let len = 0;
    dives.forEach(function (dv) {
      if (!dv || !Array.isArray(dv.d) || dv.d.length < 2) return;
      len = Math.max(len, dv.d.length);
      const k = dv.t == null ? 0.5 : Math.max(0, Math.min(1, (dv.t - tmin) / tspan));
      const bi = Math.round(k * (NB - 1));
      buckets[bi] = (buckets[bi] || '') + pathFor(dv.d) + ' ';
    });
    let threads = '';
    for (let bi = 0; bi < NB; bi++) {
      if (!buckets[bi]) continue;
      threads +=
        '<path d="' + buckets[bi].trim() + '" style="stroke:' + rampK(bi / (NB - 1)) + '"/>';
    }
    if (!threads) {
      elForestSection.hidden = true;
      return;
    }

    // Average dive — mean depth per normalized index across all threads.
    const mean = [];
    for (let i = 0; i < len; i++) {
      let sum = 0;
      let cnt = 0;
      dives.forEach(function (dv) {
        if (dv && Array.isArray(dv.d) && i < dv.d.length) {
          sum += dv.d[i];
          cnt++;
        }
      });
      mean.push(cnt ? sum / cnt : 0);
    }

    // Depth axis — ft gridlines (the popup reports ft alongside metres).
    const M2FT = 3.28084;
    const maxFt = maxM * M2FT;
    const ticks = [0, 25, 50, 75, 100].filter(function (t) {
      return t <= maxFt + 6;
    });
    let axis = '';
    let labels = '';
    ticks.forEach(function (t) {
      const y = yOf(t / M2FT);
      axis +=
        '<line class="scuba-pop-forest-axis" x1="0" y1="' +
        y.toFixed(1) +
        '" x2="' +
        W +
        '" y2="' +
        y.toFixed(1) +
        '"/>';
      labels += '<span style="top:' + ((y / H) * 100).toFixed(1) + '%">' + t + ' ft</span>';
    });

    elForest.innerHTML =
      axis +
      '<g id="scubaPopForestThreads">' +
      threads +
      '</g>' +
      '<path class="scuba-pop-forest-mean" d="' +
      pathFor(mean) +
      '"/>';
    if (elForestAxt) elForestAxt.innerHTML = labels;
    if (elForestSub) setText(elForestSub, fmt(dives.length) + ' dives');
  }

  const EQUIV_ICONS = {
    water:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12c2-2 4-2 6 0s4 2 6 0 4-2 6 0"/><path d="M3 17c2-2 4-2 6 0s4 2 6 0 4-2 6 0"/></svg>',
    tower:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3 6.5 21h11L12 3Z"/><path d="M8.5 13h7M9.8 9h4.4"/><path d="M7.5 21 12 14l4.5 7"/></svg>',
    globe:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h17"/><path d="M12 3.5c2.3 2.4 3.4 5.2 3.4 8.5s-1.1 6.1-3.4 8.5"/><path d="M12 3.5c-2.3 2.4-3.4 5.2-3.4 8.5s1.1 6.1 3.4 8.5"/></svg>',
  };

  function setEquivIcon(icon, iconName) {
    icon.setAttribute('aria-hidden', 'true');
    icon.dataset.icon = iconName;
    icon.innerHTML = EQUIV_ICONS[iconName] || '';
  }

  function renderEquivalents(parent, ds) {
    if (!parent) return;
    parent.innerHTML = '';
    const items = [];
    if (ds.total_hours) {
      const days = ds.total_hours / 24;
      items.push({
        icon: 'water',
        val: days >= 10 ? days.toFixed(0) : days.toFixed(1),
        lab: 'Days underwater',
      });
    }
    if (ds.cumulative_descent_m) {
      // Eiffel Tower = 330 m. Cumulative descent ≈ N tower-heights.
      const towers = ds.cumulative_descent_m / 330;
      if (towers >= 1) {
        items.push({
          icon: 'tower',
          val: towers >= 10 ? towers.toFixed(0) + '×' : towers.toFixed(1) + '×',
          lab: 'Eiffel Towers descended',
        });
      }
    }
    if (ds.num_countries) {
      items.push({
        icon: 'globe',
        val: String(ds.num_countries),
        lab: 'Countries dived',
      });
    }
    items.forEach(function (it) {
      const wrap = document.createElement('div');
      wrap.className = 'scuba-pop-equiv-pill';
      const icon = document.createElement('span');
      icon.className = 'scuba-pop-equiv-icon';
      setEquivIcon(icon, it.icon);
      const body = document.createElement('div');
      const val = document.createElement('div');
      val.className = 'scuba-pop-equiv-val';
      val.textContent = it.val;
      const lab = document.createElement('div');
      lab.className = 'scuba-pop-equiv-lab';
      lab.textContent = it.lab;
      body.appendChild(val);
      body.appendChild(lab);
      wrap.appendChild(icon);
      wrap.appendChild(body);
      parent.appendChild(wrap);
    });
  }

  function getStats() {
    return (window.INDEX_DATA && INDEX_DATA.scubaStats) || null;
  }

  function render() {
    const ds = getStats();
    if (!ds) {
      setText(elSub, 'Dive data is unavailable right now.');
      return;
    }

    // Hero
    setText(elDives, fmt(ds.total_dives));
    const MONTHS = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    const fm =
      ds.first_month && ds.first_month >= 1 && ds.first_month <= 12
        ? MONTHS[ds.first_month - 1]
        : '';
    const fy = ds.first_year || '';
    const since = fm && fy ? 'since ' + fm + ' ' + fy : '';
    setText(elDivesMeta, since);
    setText(elSub, since ? 'Every logged dive ' + since : '');

    // KPI strip
    setText(elBottom, ds.total_hours ? ds.total_hours + 'h' : '—');
    setText(elBottomSub, ds.total_minutes ? fmt(ds.total_minutes) + ' min underwater' : '');

    setText(elDeepest, ds.deepest_m ? Math.round(ds.deepest_m) + ' m' : '—');
    setText(elDeepestSub, ds.deepest_m ? Math.round(ds.deepest_m * 3.281) + ' ft' : '');

    if (ds.avg_depth_m) {
      setText(elAvgDepth, Math.round(ds.avg_depth_m) + ' m');
      setText(
        elAvgDepthSub,
        ds.avg_min
          ? 'avg ' + ds.avg_min + ' min · ' + Math.round(ds.avg_depth_m * 3.281) + ' ft'
          : ''
      );
    } else {
      setText(elAvgDepth, '—');
      setText(elAvgDepthSub, '');
    }

    renderEquivalents(elEquiv, ds);

    renderForest(ds.forest);

    // Records — four cards: deepest, longest, coldest, warmest
    const recs = ds.records || {};
    const deepest = recs.deepest || null;
    if (deepest) {
      setText(elDeepestRoute, deepest.value || '—');
      setText(elDeepestRouteMeta, recordMeta(deepest));
    } else {
      setText(elDeepestRoute, '—');
      setText(elDeepestRouteMeta, '');
    }
    const longest = recs.longest || null;
    if (longest) {
      setText(elLongestRoute, longest.value || '—');
      setText(elLongestRouteMeta, recordMeta(longest));
    } else {
      setText(elLongestRoute, '—');
      setText(elLongestRouteMeta, '');
    }
    const cold = recs.coldest || null;
    if (cold) {
      setText(elColdRoute, cold.value || '—');
      setText(elColdRouteMeta, recordMeta(cold));
    } else {
      setText(elColdRoute, '—');
      setText(elColdRouteMeta, '');
    }
    const warm = recs.warmest || null;
    if (warm) {
      setText(elWarmRoute, warm.value || '—');
      setText(elWarmRouteMeta, recordMeta(warm));
    } else {
      setText(elWarmRoute, '—');
      setText(elWarmRouteMeta, '');
    }

    renderBars(elCountries, ds.top_countries, 'name');
    setText(elCountriesTotal, ds.num_countries ? ds.num_countries + ' countries total' : '');

    renderChart(elChart, ds.by_year);

    rendered = true;
  }

  // Same pattern as flight-popup. Any element with [data-scuba-stats]
  // opens; Escape / clicking the modal shell closes; window.openScubaPopup
  // and window.closeScubaPopup are exposed via opts.exposeAs.
  maxhPopupSetup(POP, {
    triggerAttr: 'data-scuba-stats',
    closeEl: elClose,
    scrollEl: elScroll,
    onBeforeOpen: function () {
      if (!rendered) render();
    },
    exposeAs: 'Scuba',
  });
})();

;
/* MAXH_BUNDLER_V1_DEFERRED: src/js/spa/renderers/health-popup.js */
// ════════════════════════════════════════════════════════════════════
// src/js/spa/renderers/health-popup.js
// ────────────────────────────────────────────────────────────────────
// MAXH_HEALTH_POPUP_V1 — Apple Health aggregate popup.
//
// Click any element with [data-health-stats] to open a scrollable card
// showing overlap-adjusted Health export totals: steps, walk/run miles,
// cycling miles, top days, and yearly step chart.
//
// Data source: INDEX_DATA.healthStats, baked from content/site/health-stats.json.
// This file is inlined into the SPA IIFE through build.py's inline SPA manifest.
// Relies on maxhPopupSetText / maxhPopupPrettyDate / maxhPopupSetup from
// popup-utils.js, which inlines just before this file.
// ════════════════════════════════════════════════════════════════════
(function setupHealthPopup() {
  const POP = document.getElementById('healthPop');
  if (!POP) return;

  const elClose = document.getElementById('healthPopClose');
  const elSub = document.getElementById('healthPopSub');
  const elSteps = document.getElementById('healthPopSteps');
  const elStepsMeta = document.getElementById('healthPopStepsMeta');
  const elAvg = document.getElementById('healthPopAvg');
  const elWalkRun = document.getElementById('healthPopWalkRun');
  const elCycling = document.getElementById('healthPopCycling');
  const elEquiv = document.getElementById('healthPopEquiv');
  const elBestStep = document.getElementById('healthPopBestStep');
  const elBestStepMeta = document.getElementById('healthPopBestStepMeta');
  const elBestWalk = document.getElementById('healthPopBestWalk');
  const elBestWalkMeta = document.getElementById('healthPopBestWalkMeta');
  const elBestRide = document.getElementById('healthPopBestRide');
  const elBestRideMeta = document.getElementById('healthPopBestRideMeta');
  const elChart = document.getElementById('healthPopChart');
  const elScroll = POP.querySelector('.flight-pop-scroll');

  let rendered = false;
  const setText = maxhPopupSetText;

  // Health step counts are floats from Apple Health export — round before
  // formatting, unlike maxhPopupFmt which preserves the raw number.
  function fmt(n) {
    if (typeof n !== 'number' || !isFinite(n)) return '';
    return Math.round(n).toLocaleString();
  }

  function compact(n) {
    if (typeof n !== 'number' || !isFinite(n)) return '';
    const abs = Math.abs(n);
    if (abs >= 1000000) return (n / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    if (abs >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    return String(Math.round(n));
  }

  function miles(n) {
    if (typeof n !== 'number' || !isFinite(n)) return '';
    return n >= 1000 ? Math.round(n).toLocaleString() : Math.round(n).toLocaleString();
  }

  function milesOne(n) {
    if (typeof n !== 'number' || !isFinite(n)) return '';
    return n.toFixed(1).replace(/\.0$/, '');
  }

  function prettyDate(iso) {
    return maxhPopupPrettyDate(iso, true);
  }

  function getStats() {
    return (window.INDEX_DATA && INDEX_DATA.healthStats) || null;
  }

  function hydrateCard(hs) {
    const card = document.querySelector('[data-health-card-steps]');
    if (!card || !hs) return;
    const display = (hs.totals && hs.totals.stepsDisplay) || (hs.headline && hs.headline.value);
    if (display) card.textContent = display;
  }

  function renderEquivalents(parent, hs) {
    if (!parent) return;
    parent.innerHTML = '';
    const totals = hs.totals || {};
    const eq = hs.equivalents || {};
    const items = [
      {
        icon: 'MI',
        val: miles(totals.totalDistanceMilesEstimate) + ' mi',
        lab: 'Walk/run/ride miles',
      },
      {
        icon: '26',
        val: fmt(eq.marathonEquivalentsWalkRun) + '×',
        lab: 'Marathons on foot',
      },
      {
        icon: '%',
        val: milesOne(eq.earthCircumferencePercent) + '%',
        lab: 'Around earth',
      },
    ];
    items.forEach(function (it) {
      if (!it.val || it.val === '×' || it.val === '%') return;
      const wrap = document.createElement('div');
      wrap.className = 'flight-pop-orbit';
      const icon = document.createElement('span');
      icon.className = 'flight-pop-orbit-icon';
      icon.textContent = it.icon;
      const body = document.createElement('div');
      const val = document.createElement('div');
      val.className = 'flight-pop-orbit-val';
      val.textContent = it.val;
      const lab = document.createElement('div');
      lab.className = 'flight-pop-orbit-lab';
      lab.textContent = it.lab;
      body.appendChild(val);
      body.appendChild(lab);
      wrap.appendChild(icon);
      wrap.appendChild(body);
      parent.appendChild(wrap);
    });
  }

  function renderYearChart(parent, entries) {
    if (!parent) return;
    parent.innerHTML = '';
    if (!Array.isArray(entries) || !entries.length) return;
    const max =
      Math.max.apply(
        null,
        entries.map(function (e) {
          return e.value || 0;
        })
      ) || 1;
    entries.forEach(function (e) {
      const col = document.createElement('div');
      col.className = 'flight-pop-chart-col';
      const h = Math.max(2, Math.round(((e.value || 0) / max) * 100));
      col.style.setProperty('--flight-pop-chart-height', h + '%');
      col.setAttribute('aria-label', e.year + ' · ' + fmt(e.value || 0) + ' steps');
      const slot = document.createElement('div');
      slot.className = 'flight-pop-chart-slot';
      const count = document.createElement('div');
      count.className = 'flight-pop-chart-count';
      count.textContent = compact(e.value || 0);
      const bar = document.createElement('div');
      bar.className = 'flight-pop-chart-bar';
      bar.style.height = h + '%';
      const lab = document.createElement('div');
      lab.className = 'flight-pop-chart-lab';
      lab.textContent = String(e.year || '').slice(-2);
      slot.appendChild(count);
      slot.appendChild(bar);
      col.appendChild(slot);
      col.appendChild(lab);
      parent.appendChild(col);
    });
  }

  function renderRecord(valueEl, metaEl, item, formatter, unit) {
    if (!item) {
      setText(valueEl, '—');
      setText(metaEl, '');
      return;
    }
    setText(valueEl, formatter(item.value) + (unit || ''));
    setText(metaEl, prettyDate(item.date));
  }

  function render() {
    const hs = getStats();
    if (!hs) {
      setText(elSub, 'Health data is unavailable right now.');
      return;
    }
    hydrateCard(hs);

    const totals = hs.totals || {};
    const range = hs.range || {};
    const top = hs.topDays || {};

    setText(
      elSteps,
      totals.stepsDisplay || (hs.headline && hs.headline.value) || compact(totals.stepsEstimate)
    );
    setText(elStepsMeta, range.label ? 'best estimate · ' + range.label : 'best estimate');
    setText(elSub, range.days ? fmt(range.days) + ' days of movement data' : '');
    setText(elAvg, fmt(totals.stepsAveragePerDay));
    setText(elWalkRun, miles(totals.walkRunMilesEstimate));
    setText(elCycling, miles(totals.cyclingMilesEstimate));

    renderEquivalents(elEquiv, hs);
    renderRecord(
      elBestStep,
      elBestStepMeta,
      top.steps && top.steps[0],
      function (v) {
        return fmt(v);
      },
      ' steps'
    );
    renderRecord(
      elBestWalk,
      elBestWalkMeta,
      top.walkRunMiles && top.walkRunMiles[0],
      function (v) {
        return milesOne(v);
      },
      ' mi'
    );
    renderRecord(
      elBestRide,
      elBestRideMeta,
      top.cyclingMiles && top.cyclingMiles[0],
      function (v) {
        return milesOne(v);
      },
      ' mi'
    );

    renderYearChart(elChart, hs.byYear && hs.byYear.steps);

    rendered = true;
  }

  // Hydrate the steps card on first paint so the homepage number is
  // ready before the user ever opens the popup.
  const initialStats = getStats();
  if (initialStats) hydrateCard(initialStats);

  // Click anywhere with [data-health-stats] opens; the shared helper
  // also exposes window.openHealthPopup / window.closeHealthPopup via
  // opts.exposeAs.
  maxhPopupSetup(POP, {
    triggerAttr: 'data-health-stats',
    closeEl: elClose,
    scrollEl: elScroll,
    onBeforeOpen: function () {
      if (!rendered) render();
    },
    exposeAs: 'Health',
  });
})();

;
/* MAXH_BUNDLER_V1_DEFERRED: src/js/spa/renderers/packing-popup.js */
// ════════════════════════════════════════════════════════════════════
// src/js/spa/renderers/packing-popup.js
// ────────────────────────────────────────────────────────────────────
// MAXH_PACKING_POPUP_V1 — packing-system summary popup. Sibling of
// MAXH_FLIGHT_POPUP_V1 / MAXH_SCUBA_POPUP_V1 / MAXH_HEALTH_POPUP_V1.
//
// Click any element with [data-packing-stats] (currently the About-page
// "Bags always" stat) to open a condensed read of the Pack Light, Buy
// Local story: the two-carry-on fleet, the fifteen-piece wardrobe math,
// and the "bill we never paid" receipt. The footer CTA links to the
// full story at /#story/pack-light-buy-local-maxandhailey.
//
// No INDEX_DATA payload: every number in the dialog is baked at build
// time. The template markup carries the stat tokens directly, and the
// flight-count literal below is filled by build.py's substitute_tokens
// when the deferred bundle is written — same recipe as the story
// module, so the receipt re-totals itself on every publish. The napkin
// assumptions mirror packing-story.js::pkReceipt exactly: ~15 min at
// the bag-drop queue, ~20 min at the carousel, ~$35 a leg, and the
// industry's ~7 mishandled bags per 1,000 (two travelers, one bag
// each).
//
// IMPORTANT — this file is bundled into the deferred spa-features
// bundle via build.py's DEFERRED_JS_BUNDLE manifest. Relies on
// maxhPopupFmt / maxhPopupSetText / maxhPopupSetup from popup-utils.js,
// which inlines earlier in the same bundle. Header comments
// deliberately avoid the literal close-tag forms of s-c-r-i-p-t and
// s-t-y-l-e wrapped in angle brackets — see CLAUDE.md §15.4.
// ════════════════════════════════════════════════════════════════════
(function setupPackingPopup() {
  const POP = document.getElementById('packingPop');
  if (!POP) return;

  const elClose = document.getElementById('packingPopClose');
  const elQueue = document.getElementById('packingPopQueue');
  const elFees = document.getElementById('packingPopFees');
  const elLost = document.getElementById('packingPopLost');
  const elScroll = POP.querySelector('.flight-pop-scroll');

  let rendered = false;
  const fmt = maxhPopupFmt;
  const setText = maxhPopupSetText;

  const PACKING_FLIGHTS = '452';

  function packingFlightCount() {
    const n = parseInt(String(PACKING_FLIGHTS).replace(/[^0-9]/g, ''), 10);
    return Number.isFinite(n) ? n : 0;
  }

  function render() {
    const flights = packingFlightCount();
    const queueH = Math.round((flights * 15) / 60);
    const beltH = Math.round((flights * 20) / 60);
    const totalH = queueH + beltH;
    const fees = flights * 35;
    const lost = Math.round((flights * 2 * 7) / 1000);
    if (flights > 0) {
      setText(elQueue, '~' + fmt(totalH) + ' h');
      setText(elFees, '$' + fmt(fees));
      setText(elLost, '~' + fmt(lost));
    } else {
      setText(elQueue, '—');
      setText(elFees, '—');
      setText(elLost, '—');
    }
    rendered = true;
  }

  // Same pattern as the sibling popups. Any element with
  // [data-packing-stats] opens; Escape / clicking the shell closes;
  // window.openPackingPopup and window.closePackingPopup are exposed
  // via opts.exposeAs. The CTA anchor needs no special handling — its
  // click bubbles to the shell (closing the dialog) while the hash
  // navigation routes to the full story.
  maxhPopupSetup(POP, {
    triggerAttr: 'data-packing-stats',
    closeEl: elClose,
    scrollEl: elScroll,
    onBeforeOpen: function () {
      if (!rendered) render();
    },
    exposeAs: 'Packing',
  });
})();

;
/* MAXH_BUNDLER_V1_DEFERRED: src/js/spa/features/place-map-preview.js */
// ════════════════════════════════════════════════════════════════════
// src/js/spa/features/place-map-preview.js
// ────────────────────────────────────────────────────────────────────
// MAXH_COUNTRY_MAP_PREVIEW_V1 — shared map preview init.
// Drives the Italy country-page map and the Rome city-page map.
// Lazy-loads Leaflet + markercluster from CDN when a
// map is near the viewport, fetches the configured JSON, reads
// INDEX_DATA.wonders.sites for UNESCO data, and renders an inline map
// into any element with [data-place-map="<key>"].
//
// Ships in the deferred spa-features.js bundle (MAXH_BUNDLER_V1_DEFERRED):
// start() does an initial scan() sweep before installing its
// MutationObserver, so map nodes rendered by the inline IIFE before this
// module executes (e.g. a first-paint deep link to /#city/rome-italy)
// are still picked up. Reads INDEX_DATA + loadData via the deferred
// preamble and window.DATA at entry points.
// ════════════════════════════════════════════════════════════════════
(function installPlaceMapPreview() {
  if (typeof window === 'undefined') return;
  if (window.__placeMapPreviewObserver) return;
  window.__placeMapPreviewObserver = true;

  // MAXH_VENDOR_V1 — Leaflet 1.9.4 + markercluster 1.5.3 self-hosted from
  // /assets/vendor/leaflet (was unpkg.com; same rationale as globe.gl and
  // the React UMDs: no third-party runtime dependency, no SRI-less CDN).
  var LEAFLET_CSS = '/assets/vendor/leaflet/leaflet.css';
  var LEAFLET_JS = '/assets/vendor/leaflet/leaflet.js';
  var CLUSTER_CSS = '/assets/vendor/leaflet/MarkerCluster.css';
  var CLUSTER_JS = '/assets/vendor/leaflet/leaflet.markercluster.js';
  var UNESCO_COLOR = '#c9982b';
  var MAP_ROOT_MARGIN = '600px 0px 600px 0px';
  var mapViewportObserver = null;
  var mapDataScanQueued = false;

  // City-page maps open at this fixed zoom centered on the picks'
  // centroid. fitBounds zooms out too far on wide containers, so a
  // fixed view keeps every city consistent.
  var CITY_ZOOM = 14;
  // UNESCO box for city pages = ±DEG around the city centroid. ~0.25°
  // is roughly 25 km, generous enough to pick up day-trip sites.
  var CITY_UNESCO_DEG = 0.25;

  var KIND_COLOR = {
    restaurant: '#b2331c',
    bar: '#7a4e2e',
    cafe: '#a67b2a',
    hotel: '#2e6f7a',
    sight: '#3f6a2e',
    museum: '#6a4e8a',
    park: '#4f8a4f',
    spa: '#8a6a8a',
    shop: '#8a7a3a',
    food_other: '#a04a2a',
    other: '#666',
  };
  var KIND_LABEL = {
    restaurant: 'Restaurant',
    bar: 'Bar',
    cafe: 'Café',
    hotel: 'Hotel',
    sight: 'Sight',
    museum: 'Museum',
    park: 'Park',
    spa: 'Spa',
    shop: 'Shop',
    food_other: 'Food',
    other: 'Other',
  };
  var KIND_PLURAL = {
    restaurant: 'Restaurants',
    bar: 'Bars',
    cafe: 'Cafés',
    hotel: 'Hotels',
    sight: 'Sights',
    museum: 'Museums',
    park: 'Parks',
    spa: 'Spas',
    shop: 'Shops',
    food_other: 'Food (other)',
    other: 'Other',
  };

  function loadCss(href) {
    if (document.querySelector('link[data-pmp-css="' + href + '"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    l.setAttribute('data-pmp-css', href);
    document.head.appendChild(l);
  }
  function loadScript(src) {
    var existing = document.querySelector('script[data-pmp-js="' + src + '"]');
    if (existing) {
      if (existing.__loaded) return Promise.resolve();
      return new Promise(function (r) {
        existing.addEventListener('load', r);
      });
    }
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.async = false;
      s.setAttribute('data-pmp-js', src);
      s.addEventListener('load', function () {
        s.__loaded = true;
        resolve();
      });
      s.addEventListener('error', reject);
      document.head.appendChild(s);
    });
  }
  function injectStyles() {
    if (document.getElementById('place-map-preview-styles')) return;
    var css =
      '.cty-map-preview{margin:18px auto 32px;max-width:1200px;border:1px solid var(--rule,#d8cfba);border-radius:12px;overflow:hidden;background:var(--paper,#f5efe2);color:var(--ink,#1a1a1a);font:14px/1.4 -apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif}' +
      '.cty-map-loading{padding:40px;text-align:center;color:var(--muted,#6b6157);font-size:13px}' +
      '.cmp-header{padding:10px 16px;border-bottom:1px solid var(--rule,#d8cfba);cursor:pointer;transition:background .1s;display:flex;align-items:baseline;gap:12px;flex-wrap:wrap}' +
      '.cmp-header:hover{background:rgba(178,51,28,.06)}' +
      '.cmp-header h3{margin:0;font-size:16px}' +
      '.cmp-header h3::before{content:"⌖";margin-right:6px;color:var(--muted,#6b6157);font-weight:400;font-size:14px;vertical-align:1px}' +
      '.cmp-sub{font-size:12px;color:var(--muted,#6b6157)}' +
      '.cmp-filters{display:flex;flex-wrap:wrap;gap:6px;padding:8px 12px;border-bottom:1px solid var(--rule,#d8cfba)}' +
      '.cmp-chip{appearance:none;border:1px solid var(--rule,#d8cfba);background:var(--paper,#f5efe2);border-radius:999px;padding:3px 9px 3px 7px;font-size:12px;color:var(--ink,#1a1a1a);cursor:pointer;display:inline-flex;align-items:center;gap:6px;transition:opacity .12s}' +
      '.cmp-chip.off{opacity:.35}' +
      '.cmp-chip .dot{width:9px;height:9px;border-radius:50%;background:var(--c)}' +
      '.cmp-chip .dot.diamond{border-radius:2px;transform:rotate(45deg)}' +
      '.cmp-chip .n{color:var(--muted,#6b6157);font-size:11px}' +
      '.cmp-chip.unesco{border-color:' +
      UNESCO_COLOR +
      '}' +
      '.cmp-body{display:flex;height:520px;position:relative}' +
      '.cmp-sidebar{width:340px;min-width:300px;border-right:1px solid var(--rule,#d8cfba);overflow-y:auto;background:var(--paper,#f5efe2);display:flex;flex-direction:column}' +
      '.cmp-scroll{flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch}' +
      '.cmp-map-shell{flex:1;min-width:0;min-height:0;position:relative;display:flex}' +
      '.cmp-map{flex:1;min-height:0}' +
      '.cmp-list-cta{position:absolute;right:14px;bottom:34px;z-index:650;display:inline-flex;align-items:center;justify-content:center;gap:7px;padding:10px 14px;border:1px solid rgba(255,255,255,.5);border-radius:8px;background:var(--stamp,#b2331c);color:#fff!important;text-decoration:none;font-weight:700;font-size:13px;line-height:1;box-shadow:0 8px 18px rgba(49,39,29,.2);white-space:nowrap}' +
      '.cmp-list-cta:hover{background:#8f2d18}' +
      '.cmp-list-cta::after{content:"↗";font-size:13px;line-height:1;opacity:.9}' +
      '.cty-map-preview .leaflet-bar a,.cty-map-preview .leaflet-bar a:hover{background:var(--paper,#f5efe2);color:var(--ink,#1a1a1a);border-bottom-color:var(--rule,#d8cfba)}' +
      '.cty-map-preview .leaflet-bar a.leaflet-disabled{background:var(--paper-deep,var(--paper,#f5efe2));color:var(--faded,var(--muted,#6b6157))}' +
      '.cmp-group{padding:12px 14px 5px;font-size:11px;text-transform:uppercase;letter-spacing:.08em;color:var(--muted,#6b6157);position:sticky;top:0;background:var(--paper,#f5efe2);border-bottom:1px solid var(--rule,#d8cfba);z-index:1}' +
      '.cmp-group.unesco{color:' +
      UNESCO_COLOR +
      '}' +
      '.cmp-group .n{opacity:.65;margin-left:4px}' +
      '.cmp-item{display:block;position:relative;padding:10px 38px 10px 12px;border-bottom:1px solid var(--rule,#d8cfba);cursor:pointer;text-decoration:none;color:inherit;transition:background .1s}' +
      '.cmp-item:hover,.cmp-item.active{background:rgba(178,51,28,.08)}' +
      '.cmp-item .row1{display:flex;align-items:baseline;gap:8px;justify-content:space-between}' +
      '.cmp-item .name{font-weight:600;font-size:13px}' +
      '.cmp-item .name::before{content:"";display:inline-block;width:8px;height:8px;border-radius:50%;background:var(--c);margin-right:7px;vertical-align:middle}' +
      '.cmp-item.unesco .name::before{border-radius:2px;transform:rotate(45deg);margin-right:9px}' +
      '.cmp-item .rating{font-size:11px;color:var(--muted,#6b6157);white-space:nowrap}' +
      '.cmp-item .addr,.cmp-item .meta{font-size:11px;color:var(--muted,#6b6157);margin:2px 0 0 15px}' +
      '.cmp-item .chips{margin:5px 0 0 15px;display:flex;flex-wrap:wrap;gap:3px}' +
      '.cmp-item .chip{font-size:10px;padding:1px 6px;border-radius:999px;border:1px solid var(--rule,#d8cfba);color:var(--muted,#6b6157);line-height:1.5}' +
      '.cmp-item .chip.visited{border-color:var(--stamp,#b2331c);color:var(--stamp,#b2331c)}' +
      '.cmp-item .chip.wish{border-color:#b8860b;color:#b8860b}' +
      '.cmp-item .go{position:absolute;top:50%;right:8px;transform:translateY(-50%);width:26px;height:26px;border-radius:8px;display:flex;align-items:center;justify-content:center;color:var(--stamp,#b2331c);font-size:14px;font-weight:600;text-decoration:none;border:1px solid var(--rule,#d8cfba);background:var(--paper,#f5efe2)}' +
      '.cmp-item.unesco .go{color:' +
      UNESCO_COLOR +
      '}' +
      '.cmp-pin{width:14px;height:14px;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 2px rgba(0,0,0,.4);transition:transform .12s}' +
      '.cmp-pin.unesco{border-radius:3px;transform:rotate(45deg)}' +
      '.cmp-pin.active{transform:scale(1.7);box-shadow:0 0 0 3px rgba(255,255,255,.65),0 2px 4px rgba(0,0,0,.5);z-index:999}' +
      '.cmp-pin.unesco.active{transform:rotate(45deg) scale(1.7)}' +
      '.cmp-cluster{background:var(--paper,#f5efe2);color:var(--ink,#1a1a1a);border:2px solid var(--stamp,#b2331c);border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:12px;width:34px;height:34px;box-shadow:0 2px 4px rgba(0,0,0,.3)}' +
      '.cmp-cluster.unesco{border-color:' +
      UNESCO_COLOR +
      '}' +
      '.cty-map-preview .leaflet-popup-content-wrapper{background:var(--paper,#f5efe2);color:var(--ink,#1a1a1a);border:1px solid var(--rule,#d8cfba);border-radius:10px}' +
      '.cty-map-preview .leaflet-popup-tip{background:var(--paper,#f5efe2);border:1px solid var(--rule,#d8cfba)}' +
      '.cmp-popup-kind{font-size:11px;color:var(--muted,#6b6157);text-transform:uppercase;letter-spacing:.06em}' +
      '.cmp-popup-kind.unesco{color:' +
      UNESCO_COLOR +
      '}' +
      '.cmp-popup-name{font-weight:600;font-size:14px}' +
      '.cmp-popup-cta{display:inline-block;margin-top:6px;background:var(--stamp,#b2331c);color:#fff!important;text-decoration:none;padding:6px 11px;border-radius:7px;font-weight:600;font-size:12px}' +
      '.cmp-popup-cta.unesco{background:' +
      UNESCO_COLOR +
      '}' +
      '@media (max-width:760px){.cmp-body{flex-direction:column;height:auto}.cmp-sidebar{width:100%;max-height:50vh;border-right:none;border-top:1px solid var(--rule,#d8cfba);order:2}.cmp-map-shell{flex:0 0 auto;height:auto;min-height:0;order:1;flex-direction:column}.cmp-map{height:55vh;min-height:320px;flex:0 0 auto}.cmp-list-cta{position:static;order:-1;margin:10px 12px 8px;padding:11px 12px;font-size:12px;line-height:1.15;white-space:normal;box-shadow:none}.cmp-sub{display:none}.cmp-pin{width:18px;height:18px}}' +
      // MAXH_TRIP_BUILDER_V1 — numbered day pins for the Trip Builder map.
      '.cmp-itin-map{position:absolute;inset:0}' +
      '.cmp-itin-pin{display:flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 3px rgba(0,0,0,.45);color:#fff;font-weight:700;font-size:12px;font-family:ui-monospace,monospace}';
    var s = document.createElement('style');
    s.id = 'place-map-preview-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function decorateUnesco(rows, country) {
    return rows
      .map(function (s) {
        var q = encodeURIComponent((s.name || '') + ' ' + (country || ''));
        return {
          id: 'unesco-' + s.id,
          name: s.name || s.short || 'UNESCO #' + s.id,
          lat: s.lat,
          lng: s.lng,
          year: s.year || null,
          cat: s.cat || 'cultural',
          href: 'https://www.google.com/maps/search/?api=1&query=' + q,
        };
      })
      .sort(function (a, b) {
        return (a.year || 0) - (b.year || 0);
      });
  }

  function collectUnesco(country, box) {
    try {
      var sites =
        (window.INDEX_DATA && window.INDEX_DATA.wonders && window.INDEX_DATA.wonders.sites) || [];
      var filtered = sites.filter(function (s) {
        if (!s || !country || s.country !== country || s.lat == null || s.lng == null) {
          return false;
        }
        if (!box) return true;
        return s.lat >= box[0][0] && s.lat <= box[1][0] && s.lng >= box[0][1] && s.lng <= box[1][1];
      });
      return decorateUnesco(filtered, country);
    } catch (_) {
      return [];
    }
  }

  function centroidOf(items) {
    if (!items || !items.length) return null;
    var slat = 0,
      slng = 0,
      n = 0;
    for (var i = 0; i < items.length; i++) {
      var f = items[i];
      var la = f.la != null ? f.la : f.lat;
      var lo = f.lo != null ? f.lo : f.lng;
      if (la == null || lo == null) continue;
      slat += la;
      slng += lo;
      n++;
    }
    return n ? [slat / n, slng / n] : null;
  }

  function initOne(container) {
    if (container.getAttribute('data-place-map-ready')) return;
    var kind = container.getAttribute('data-place-map'); // 'country' | 'city' | 'itinerary'
    // MAXH_TRIP_BUILDER_V1 — the Trip Builder map: no payload URL, data
    // arrives via window.__MAXH_ITIN_MAP + the maxh:itin-map event.
    if (kind === 'itinerary') {
      container.setAttribute('data-place-map-ready', '1');
      initItinerary(container);
      return;
    }
    var slug = container.getAttribute('data-place-slug') || '';
    if (!kind || !slug) return;
    container.setAttribute('data-place-map-ready', '1');
    // A placeholder may point the map machinery at its own payload via
    // data-place-src; everything else falls back to the default
    // /map-payloads/ path. maxhJsonUrl leaves an already-versioned
    // data-place-src untouched.
    var url = window.maxhJsonUrl(
      container.getAttribute('data-place-src') || '/map-payloads/' + slug + '.json'
    );
    injectStyles();
    loadCss(LEAFLET_CSS);
    loadCss(CLUSTER_CSS);
    Promise.resolve()
      .then(function () {
        return loadScript(LEAFLET_JS);
      })
      .then(function () {
        return loadScript(CLUSTER_JS);
      })
      .then(function () {
        return fetch(url, { credentials: 'same-origin' });
      })
      .then(function (r) {
        return r.ok ? r.json() : Promise.reject(new Error(url + ' HTTP ' + r.status));
      })
      .then(function (payload) {
        renderMap(container, kind, payload);
      })
      .catch(function (err) {
        container.innerHTML =
          '<div class="cty-map-loading">Couldn’t load the map (' +
          esc(err && err.message ? err.message : err) +
          ').</div>';
      });
  }

  // MAXH_TRIP_BUILDER_V1 — Trip Builder day map. Reads
  // window.__MAXH_ITIN_MAP = { stops: [{la, lo, n, k, h, day, idx,
  // color, slot}], center: [lat, lng] } (set by renderers/itinerary.js
  // before the container mounts) and re-renders on the maxh:itin-map
  // event (day filter, swaps, shuffles). Numbered day-colored pins +
  // a dashed walking line per day; same Leaflet/basemap dark-mode stack
  // as the country/city maps.
  function initItinerary(container) {
    injectStyles();
    loadCss(LEAFLET_CSS);
    loadScript(LEAFLET_JS)
      .then(function () {
        var L = window.L;
        if (!L) throw new Error('Leaflet failed to load');
        container.innerHTML = '<div class="cmp-itin-map"></div>';
        var dark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
        var map = L.map(container.querySelector('.cmp-itin-map'), {
          zoomControl: true,
          scrollWheelZoom: false,
        });
        // MAXH_BASEMAP_TILES_V1 — shared tile source, dark-aware.
        basemapLayers({ dark: dark, maxZoom: 19 }).forEach(function (layer) {
          L.tileLayer(layer.url, layer.options).addTo(map);
        });
        var layer = L.layerGroup().addTo(map);

        function draw() {
          var data = window.__MAXH_ITIN_MAP || {};
          var stops = data.stops || [];
          layer.clearLayers();
          var byDay = {};
          stops.forEach(function (s) {
            if (typeof s.la !== 'number' || typeof s.lo !== 'number') return;
            (byDay[s.day] = byDay[s.day] || []).push(s);
            var icon = L.divIcon({
              html:
                '<div class="cmp-itin-pin" style="background:' +
                esc(s.color || '#b2331c') +
                '">' +
                esc(String(s.idx || '')) +
                '</div>',
              className: '',
              iconSize: L.point(26, 26),
              iconAnchor: L.point(13, 13),
            });
            var m = L.marker([s.la, s.lo], { icon: icon, title: s.n || '' }).addTo(layer);
            m.bindPopup(
              '<div class="cmp-popup-kind">Day ' +
                esc(String((s.day || 0) + 1)) +
                (s.slot ? ' · ' + esc(s.slot) : '') +
                '</div><div class="cmp-popup-name">' +
                esc(s.n || '') +
                '</div>' +
                (s.h
                  ? '<a class="cmp-popup-cta" href="' +
                    esc(s.h) +
                    '" target="_blank" rel="noopener noreferrer">Open in Google Maps</a>'
                  : '')
            );
          });
          Object.keys(byDay).forEach(function (dayKey) {
            var pts = byDay[dayKey]
              .slice()
              .sort(function (a, b) {
                return (a.idx || 0) - (b.idx || 0);
              })
              .map(function (s) {
                return [s.la, s.lo];
              });
            if (pts.length > 1) {
              L.polyline(pts, {
                color: (byDay[dayKey][0] && byDay[dayKey][0].color) || '#b2331c',
                weight: 2,
                opacity: 0.65,
                dashArray: '4 7',
              }).addTo(layer);
            }
          });
          var all = stops
            .filter(function (s) {
              return typeof s.la === 'number' && typeof s.lo === 'number';
            })
            .map(function (s) {
              return [s.la, s.lo];
            });
          if (all.length > 1) {
            map.fitBounds(L.latLngBounds(all), { padding: [34, 34], maxZoom: 15 });
          } else if (all.length === 1) {
            map.setView(all[0], 14);
          } else if (data.center) {
            map.setView(data.center, 12);
          }
        }

        draw();
        document.addEventListener('maxh:itin-map', function onItinMap() {
          if (!document.body.contains(container)) {
            document.removeEventListener('maxh:itin-map', onItinMap);
            try {
              map.remove();
            } catch (_e) {
              /* already gone */
            }
            return;
          }
          draw();
        });
      })
      .catch(function (err) {
        container.innerHTML =
          '<div class="cty-map-loading">Couldn’t load the map (' +
          esc(err && err.message ? err.message : err) +
          ').</div>';
      });
  }

  function renderMap(container, kind, payload) {
    var picks = (payload && payload.places) || [];
    var country = (payload && payload.country) || '';
    var cityName = (payload && payload.city) || '';
    var displayName = kind === 'city' ? cityName || payload.slug : country || payload.slug;
    var picksCentroid = centroidOf(picks);
    // UNESCO scope: full country for country pages; box around city
    // centroid for city pages.
    var unescoBox = null;
    if (kind === 'city' && picksCentroid) {
      unescoBox = [
        [picksCentroid[0] - CITY_UNESCO_DEG, picksCentroid[1] - CITY_UNESCO_DEG],
        [picksCentroid[0] + CITY_UNESCO_DEG, picksCentroid[1] + CITY_UNESCO_DEG],
      ];
    }
    // Country pages: prefer the pre-baked list from the payload — it
    // drops transnational sites whose canonical lat/lng falls outside
    // the country bbox (e.g. Beech Forests on Albania). Falls back to
    // the global filter if the payload predates the baked field.
    var unesco;
    if (kind === 'country' && payload && Array.isArray(payload.unesco)) {
      unesco = decorateUnesco(payload.unesco, country);
    } else {
      unesco = collectUnesco(country, unescoBox);
    }
    var L = window.L;
    if (!L) {
      container.innerHTML = '<div class="cty-map-loading">Leaflet failed to load.</div>';
      return;
    }
    var title = displayName + ' — our picks';
    var mapsListUrl = container.getAttribute('data-google-maps-list-url') || '';
    var resetTooltip =
      kind === 'city'
        ? 'Click to zoom back out to ' + displayName
        : 'Click to zoom back out to ' + displayName;

    container.innerHTML =
      '<div class="cmp-header" role="button" tabindex="0" title="' +
      esc(resetTooltip) +
      '">' +
      '<h3>' +
      esc(title) +
      '</h3>' +
      '<span class="cmp-sub">' +
      picks.length +
      ' of our places · ' +
      unesco.length +
      ' UNESCO sites · hover (or tap) a row to preview · click here to zoom out' +
      '</span>' +
      '</div>' +
      '<div class="cmp-filters"></div>' +
      '<div class="cmp-body"><aside class="cmp-sidebar"><div class="cmp-scroll"></div></aside><div class="cmp-map-shell"><div class="cmp-map"></div>' +
      (mapsListUrl
        ? '<a class="cmp-list-cta" href="' +
          esc(mapsListUrl) +
          '" target="_blank" rel="noopener noreferrer" aria-label="Download Google Maps list for ' +
          esc(displayName) +
          '">Download Google Maps List</a>'
        : '') +
      '</div></div>';

    var filtersEl = container.querySelector('.cmp-filters');
    var scrollEl = container.querySelector('.cmp-scroll');
    var mapEl = container.querySelector('.cmp-map');

    var dark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

    var map = L.map(mapEl, { zoomControl: true });
    // MAXH_BASEMAP_TILES_V1 — shared tile source, dark-aware.
    basemapLayers({ dark: dark, maxZoom: 19 }).forEach(function (layer) {
      L.tileLayer(layer.url, layer.options).addTo(map);
    });

    var clusterPicks = L.markerClusterGroup({
      iconCreateFunction: function (c) {
        return L.divIcon({
          html: '<div class="cmp-cluster">' + c.getChildCount() + '</div>',
          className: '',
          iconSize: L.point(34, 34),
        });
      },
      maxClusterRadius: 50,
      showCoverageOnHover: false,
      disableClusteringAtZoom: 17,
    });
    var clusterUnesco = L.markerClusterGroup({
      iconCreateFunction: function (c) {
        return L.divIcon({
          html: '<div class="cmp-cluster unesco">' + c.getChildCount() + '</div>',
          className: '',
          iconSize: L.point(34, 34),
        });
      },
      maxClusterRadius: 50,
      showCoverageOnHover: false,
      disableClusteringAtZoom: 14,
    });

    var markers = {};
    var markersByKind = {};

    function popupPick(f) {
      var label = KIND_LABEL[f.k] || f.k;
      var rating =
        f.r != null
          ? '<div style="font-size:12px;color:var(--muted,#6b6157);margin-bottom:6px">★ ' +
            f.r +
            (f.rc ? ' (' + f.rc + ')' : '') +
            '</div>'
          : '';
      // MAXH_TB_TRAY_V1 — popup names carry the place identity so the
      // trip tray can grow a "+" pin inside the Leaflet popup.
      var tbAttr = f.id
        ? ' data-tb-id="' + escAttr(String(f.id)) + '" data-tb-name="' + escAttr(f.n || '') + '"'
        : '';
      return (
        '<div class="cmp-popup-kind">' +
        esc(label) +
        '</div>' +
        '<div class="cmp-popup-name"' +
        tbAttr +
        '>' +
        esc(f.n) +
        '</div>' +
        '<div style="font-size:12px;color:var(--muted,#6b6157);margin:4px 0 6px">' +
        esc(f.a) +
        '</div>' +
        rating +
        '<a class="cmp-popup-cta" href="' +
        esc(f.h) +
        '" target="_blank" rel="noopener">Open in Google Maps →</a>'
      );
    }
    function popupUnesco(f) {
      return (
        '<div class="cmp-popup-kind unesco">UNESCO · ' +
        esc(f.cat || 'cultural') +
        (f.year ? ' · ' + f.year : '') +
        '</div>' +
        '<div class="cmp-popup-name">' +
        esc(f.name) +
        '</div>' +
        '<a class="cmp-popup-cta unesco" href="' +
        esc(f.href) +
        '" target="_blank" rel="noopener">Open in Google Maps →</a>'
      );
    }

    picks.forEach(function (f) {
      var color = KIND_COLOR[f.k] || '#666';
      var icon = L.divIcon({
        className: '',
        html: '<div class="cmp-pin" style="background:' + color + '"></div>',
        iconSize: [14, 14],
        iconAnchor: [7, 7],
      });
      var m = L.marker([f.la, f.lo], { icon: icon }).bindPopup(popupPick(f), { maxWidth: 260 });
      m._f = f;
      m._kind = f.k;
      m._layer = 'picks';
      clusterPicks.addLayer(m);
      markers[f.id] = m;
      (markersByKind[f.k] = markersByKind[f.k] || []).push(m);
    });
    unesco.forEach(function (f) {
      var icon = L.divIcon({
        className: '',
        html: '<div class="cmp-pin unesco" style="background:' + UNESCO_COLOR + '"></div>',
        iconSize: [14, 14],
        iconAnchor: [7, 7],
      });
      var m = L.marker([f.lat, f.lng], { icon: icon }).bindPopup(popupUnesco(f), { maxWidth: 260 });
      m._f = f;
      m._layer = 'unesco';
      clusterUnesco.addLayer(m);
      markers[f.id] = m;
    });
    map.addLayer(clusterPicks);
    map.addLayer(clusterUnesco);
    // Initial view: city pages → fixed zoom on picks centroid;
    // country pages → fit all picks + UNESCO with breathing room.
    function applyInitialView() {
      if (kind === 'city' && picksCentroid) {
        map.setView(picksCentroid, CITY_ZOOM);
      } else {
        var pts = [];
        picks.forEach(function (f) {
          pts.push([f.la, f.lo]);
        });
        unesco.forEach(function (f) {
          pts.push([f.lat, f.lng]);
        });
        if (pts.length) map.fitBounds(pts, { padding: [20, 20] });
      }
    }
    applyInitialView();

    var kindCounts = {};
    picks.forEach(function (f) {
      kindCounts[f.k] = (kindCounts[f.k] || 0) + 1;
    });
    var kindOrder = Object.keys(KIND_COLOR).filter(function (k) {
      return kindCounts[k];
    });
    kindOrder.forEach(function (k) {
      var b = document.createElement('button');
      b.className = 'cmp-chip';
      b.dataset.layer = 'picks';
      b.dataset.kind = k;
      b.style.setProperty('--c', KIND_COLOR[k]);
      b.innerHTML =
        '<span class="dot"></span>' +
        esc(KIND_PLURAL[k] || k) +
        ' <span class="n">' +
        kindCounts[k] +
        '</span>';
      filtersEl.appendChild(b);
    });
    if (unesco.length) {
      var u = document.createElement('button');
      u.className = 'cmp-chip unesco';
      u.dataset.layer = 'unesco';
      u.style.setProperty('--c', UNESCO_COLOR);
      u.innerHTML =
        '<span class="dot diamond"></span>UNESCO Sites <span class="n">' +
        unesco.length +
        '</span>';
      filtersEl.appendChild(u);
    }

    var grouped = {};
    picks.forEach(function (f) {
      (grouped[f.k] = grouped[f.k] || []).push(f);
    });
    Object.keys(grouped)
      .sort(function (a, b) {
        return (KIND_PLURAL[a] || a).localeCompare(KIND_PLURAL[b] || b);
      })
      .forEach(function (k) {
        var h = document.createElement('div');
        h.className = 'cmp-group';
        h.dataset.kind = k;
        h.dataset.layer = 'picks';
        h.innerHTML =
          esc(KIND_PLURAL[k] || k) + ' <span class="n">' + grouped[k].length + '</span>';
        scrollEl.appendChild(h);
        grouped[k].forEach(function (f) {
          var rating =
            f.r != null
              ? '<span class="rating">★ ' +
                f.r +
                (f.rc ? ' <span style="opacity:.55">(' + f.rc + ')</span>' : '') +
                '</span>'
              : '';
          var chips = (f.t || [])
            .map(function (t) {
              var cls =
                t === 'M&H Visited' ? 'chip visited' : t === 'Wishlist' ? 'chip wish' : 'chip';
              return '<span class="' + cls + '">' + esc(t) + '</span>';
            })
            .join('');
          var d = document.createElement('div');
          d.className = 'cmp-item';
          d.dataset.id = f.id;
          d.dataset.kind = f.k;
          d.dataset.layer = 'picks';
          d.style.setProperty('--c', KIND_COLOR[f.k] || '#666');
          d.innerHTML =
            '<div class="row1"><span class="name">' +
            esc(f.n) +
            '</span>' +
            rating +
            '</div>' +
            '<div class="addr">' +
            esc(f.a) +
            (f.c ? ' · ' + esc(f.c) : '') +
            '</div>' +
            (chips ? '<div class="chips">' + chips + '</div>' : '') +
            '<a class="go" href="' +
            esc(f.h) +
            '" target="_blank" rel="noopener" aria-label="Open in Google Maps">↗</a>';
          scrollEl.appendChild(d);
        });
      });
    if (unesco.length) {
      var uh = document.createElement('div');
      uh.className = 'cmp-group unesco';
      uh.dataset.kind = 'unesco';
      uh.dataset.layer = 'unesco';
      uh.innerHTML = 'UNESCO Sites <span class="n">' + unesco.length + '</span>';
      scrollEl.appendChild(uh);
      unesco.forEach(function (f) {
        var d = document.createElement('div');
        d.className = 'cmp-item unesco';
        d.dataset.id = f.id;
        d.dataset.kind = 'unesco';
        d.dataset.layer = 'unesco';
        d.style.setProperty('--c', UNESCO_COLOR);
        d.innerHTML =
          '<div class="row1"><span class="name">' +
          esc(f.name) +
          '</span></div>' +
          '<div class="meta">' +
          esc(f.cat || 'cultural') +
          (f.year ? ' · ' + f.year : '') +
          '</div>' +
          '<a class="go" href="' +
          esc(f.href) +
          '" target="_blank" rel="noopener" aria-label="Open in Google Maps">↗</a>';
        scrollEl.appendChild(d);
      });
    }

    var activeId = null;
    function preview(id) {
      if (activeId && markers[activeId]) {
        var oldEl = markers[activeId].getElement();
        if (oldEl) {
          var op = oldEl.querySelector('.cmp-pin');
          if (op) op.classList.remove('active');
        }
      }
      activeId = id;
      if (!id || !markers[id]) return;
      var m = markers[id];
      var f = m._f;
      var lat = f.la != null ? f.la : f.lat;
      var lng = f.lo != null ? f.lo : f.lng;
      map.flyTo([lat, lng], 17, { duration: 0.45 });
      map.once('moveend', function () {
        setTimeout(function () {
          m.openPopup();
          var el = m.getElement();
          if (el) {
            var p = el.querySelector('.cmp-pin');
            if (p) p.classList.add('active');
          }
        }, 60);
      });
    }
    var mqTouch = window.matchMedia ? window.matchMedia('(hover: none)') : { matches: false };
    var mqMobile = window.matchMedia ? window.matchMedia('(max-width: 760px)') : { matches: false };
    function isTouchOrMobile() {
      return mqTouch.matches || mqMobile.matches;
    }

    var hoverTimer = null;
    scrollEl.addEventListener('mouseover', function (e) {
      if (isTouchOrMobile()) return;
      var item = e.target.closest('.cmp-item');
      if (!item) return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () {
        scrollEl.querySelectorAll('.cmp-item.active').forEach(function (el) {
          el.classList.remove('active');
        });
        item.classList.add('active');
        preview(item.dataset.id);
      }, 70);
    });
    scrollEl.addEventListener('click', function (e) {
      if (e.target.closest('.go')) return;
      var item = e.target.closest('.cmp-item');
      if (!item) return;
      if (isTouchOrMobile()) {
        e.preventDefault();
        scrollEl.querySelectorAll('.cmp-item.active').forEach(function (el) {
          el.classList.remove('active');
        });
        item.classList.add('active');
        preview(item.dataset.id);
      } else {
        var go = item.querySelector('.go');
        if (go) window.open(go.href, '_blank', 'noopener');
      }
    });
    map.on('popupopen', function (e) {
      var f = e.popup._source && e.popup._source._f;
      if (!f) return;
      var id = f.id;
      scrollEl.querySelectorAll('.cmp-item.active').forEach(function (el) {
        el.classList.remove('active');
      });
      var row = scrollEl.querySelector('.cmp-item[data-id="' + id + '"]');
      if (row) {
        row.classList.add('active');
        row.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    });

    filtersEl.querySelectorAll('.cmp-chip').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var off = btn.classList.toggle('off');
        if (btn.dataset.layer === 'unesco') {
          if (off) map.removeLayer(clusterUnesco);
          else map.addLayer(clusterUnesco);
          scrollEl.querySelectorAll('.cmp-item.unesco').forEach(function (el) {
            el.style.display = off ? 'none' : '';
          });
          var gh = scrollEl.querySelector('.cmp-group.unesco');
          if (gh) gh.style.display = off ? 'none' : '';
        } else {
          var k = btn.dataset.kind;
          (markersByKind[k] || []).forEach(function (m) {
            if (off) clusterPicks.removeLayer(m);
            else clusterPicks.addLayer(m);
          });
          scrollEl.querySelectorAll('.cmp-item[data-kind="' + k + '"]').forEach(function (el) {
            el.style.display = off ? 'none' : '';
          });
          var gh2 = scrollEl.querySelector('.cmp-group[data-kind="' + k + '"]');
          if (gh2) gh2.style.display = off ? 'none' : '';
        }
      });
    });

    function resetView() {
      scrollEl.querySelectorAll('.cmp-item.active').forEach(function (el) {
        el.classList.remove('active');
      });
      if (activeId && markers[activeId]) {
        var oldEl = markers[activeId].getElement();
        if (oldEl) {
          var op = oldEl.querySelector('.cmp-pin');
          if (op) op.classList.remove('active');
        }
      }
      activeId = null;
      map.closePopup();
      if (kind === 'city' && picksCentroid) {
        map.flyTo(picksCentroid, CITY_ZOOM, { duration: 0.5 });
      } else {
        var pts = [];
        picks.forEach(function (f) {
          pts.push([f.la, f.lo]);
        });
        unesco.forEach(function (f) {
          pts.push([f.lat, f.lng]);
        });
        if (pts.length) map.flyToBounds(pts, { padding: [20, 20], duration: 0.5 });
      }
    }
    var headerEl = container.querySelector('.cmp-header');
    headerEl.addEventListener('click', resetView);
    headerEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        resetView();
      }
    });
  }

  function scan() {
    var els = document.querySelectorAll('[data-place-map]:not([data-place-map-ready])');
    for (var i = 0; i < els.length; i++) observeOrInit(els[i]);
  }

  function observeOrInit(container) {
    if (!container || container.getAttribute('data-place-map-ready')) return;
    if (shouldWaitForDetailData(container)) {
      queueScanAfterDetailData();
      return;
    }
    if (!('IntersectionObserver' in window)) {
      initOne(container);
      return;
    }
    if (container.getAttribute('data-place-map-observed')) return;
    if (!mapViewportObserver) {
      mapViewportObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            mapViewportObserver.unobserve(entry.target);
            entry.target.removeAttribute('data-place-map-observed');
            initOne(entry.target);
          });
        },
        { rootMargin: MAP_ROOT_MARGIN, threshold: 0 }
      );
    }
    container.setAttribute('data-place-map-observed', '1');
    mapViewportObserver.observe(container);
  }

  function shouldWaitForDetailData(container) {
    var kind = container.getAttribute('data-place-map');
    if (kind !== 'country' && kind !== 'city') return false;
    try {
      // Deferred-bundle convention: read window.DATA at entry points
      // (the preamble has no DATA alias; loadData keeps window.DATA set).
      return !window.DATA && typeof loadData === 'function';
    } catch (_) {
      return false;
    }
  }

  function queueScanAfterDetailData() {
    if (mapDataScanQueued) return;
    mapDataScanQueued = true;
    try {
      loadData().then(
        function () {
          mapDataScanQueued = false;
          scan();
        },
        function () {
          mapDataScanQueued = false;
          scan();
        }
      );
    } catch (_) {
      mapDataScanQueued = false;
    }
  }

  function start() {
    scan();
    if (typeof MutationObserver === 'undefined') return;
    var obs = new MutationObserver(scan);
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

;
/* MAXH_BUNDLER_V1_DEFERRED: src/js/spa/features/plan-configurator.js */
// ════════════════════════════════════════════════════════════════════
// src/js/spa/features/plan-configurator.js
// ────────────────────────────────────────────────────────────────────
// MAXH_PLAN_CONFIG_V1 — the shared Trip Builder configurator ("Make
// this guide yours"): taste chips with live counts re-sort a preview
// rail of a metro's actual places, and the CTA hands the tuned answers
// to /#itinerary via the plan: deep link (MAXH_TB_PLAN_LINK_V1).
//
// One implementation serves every host page. Renderers emit an EMPTY
// shell and this module fills it when the itinerary index confirms the
// place is plannable:
//
//   <section class="mxplan" data-plan-config data-plan-metro="rome-italy"
//            hidden></section>                      ← city pages (one metro)
//   <section class="mxplan" data-plan-config
//            data-plan-country="japan-maxandhailey" hidden></section>
//                                    ← country pages (metro picker, by size)
//
// The container unhides after the first payload fills in, then emits a
// bubbling `maxh:plan-ready` CustomEvent (city pages rebuild their
// section nav on it). No metro / fetch miss → the shell stays hidden
// and the static page stands alone.
//
// Ships in the deferred spa-features bundle: self-init IIFE, initial
// scan + MutationObserver (same lifecycle as place-map-preview.js).
// Reads esc/imgUrl via the bundle preamble; caches share the Trip
// Builder's window globals so a configurator visit warms the builder.
// ════════════════════════════════════════════════════════════════════

(function () {
  'use strict';

  var INTERESTS = [
    {
      key: 'fine',
      label: 'Fine dining',
      match: function (p) {
        return (
          p.kind === 'restaurant' &&
          (p.tags.has('Michelin ★★★') ||
            p.tags.has('Michelin ★★') ||
            p.tags.has('Michelin ★') ||
            p.tags.has("World's 50 Best Restaurants"))
        );
      },
    },
    {
      key: 'bars',
      label: 'Cocktail bars',
      match: function (p) {
        return p.kind === 'bar';
      },
    },
    {
      key: 'casual',
      label: 'Casual eats',
      match: function (p) {
        return (
          (p.kind === 'restaurant' || p.kind === 'food_other') &&
          (p.tags.has('Michelin Bib Gourmand') ||
            p.tags.has("World's Best Burgers") ||
            p.tags.has('Pizza Pick') ||
            (!p.tags.has('Michelin ★★★') &&
              !p.tags.has('Michelin ★★') &&
              !p.tags.has('Michelin ★')))
        );
      },
    },
    {
      key: 'cafes',
      label: 'Cafés',
      match: function (p) {
        return p.kind === 'cafe';
      },
    },
    {
      key: 'sights',
      label: 'Sights & UNESCO',
      match: function (p) {
        return p.kind === 'sight' || p.tags.has('UNESCO Site');
      },
    },
    {
      key: 'museums',
      label: 'Museums',
      match: function (p) {
        return p.kind === 'museum';
      },
    },
    {
      key: 'parks',
      label: 'Parks',
      match: function (p) {
        return p.kind === 'park';
      },
    },
    {
      key: 'shopping',
      label: 'Shopping',
      match: function (p) {
        return p.kind === 'shop';
      },
    },
    {
      key: 'wine',
      label: 'Wine',
      match: function (p) {
        return p.tags.has("World's 50 Best Vineyards");
      },
    },
  ];

  var DEFAULT_TASTES = ['fine', 'bars', 'casual', 'sights'];

  function fetchIndex() {
    if (window.__MAXH_ITIN_IDX) return Promise.resolve(window.__MAXH_ITIN_IDX);
    if (window.__MAXH_ITIN_IDX_P) return window.__MAXH_ITIN_IDX_P;
    window.__MAXH_ITIN_IDX_P = fetch(window.maxhJsonUrl('/itinerary-index.json'))
      .then(function (res) {
        if (!res.ok) throw new Error('itinerary index ' + res.status);
        return res.json();
      })
      .then(function (payload) {
        window.__MAXH_ITIN_IDX = payload;
        return payload;
      })
      .catch(function (err) {
        window.__MAXH_ITIN_IDX_P = null;
        throw err;
      });
    return window.__MAXH_ITIN_IDX_P;
  }

  function fetchMetro(slug) {
    var cache = (window.__MAXH_ITIN_PL = window.__MAXH_ITIN_PL || {});
    if (cache[slug]) return Promise.resolve(cache[slug]);
    return fetch(window.maxhJsonUrl('/itinerary-payloads/' + encodeURIComponent(slug) + '.json'))
      .then(function (res) {
        if (!res.ok) throw new Error('itinerary payload ' + res.status);
        return res.json();
      })
      .then(function (payload) {
        cache[slug] = payload;
        return payload;
      });
  }

  function decodePlaces(payload) {
    var tags = payload.tags || [];
    return (payload.places || []).map(function (row) {
      return {
        name: row.n || '',
        kind: row.k || 'other',
        tags: new Set(
          (row.t || [])
            .map(function (i) {
              return tags[i];
            })
            .filter(Boolean)
        ),
        rating: typeof row.r === 'number' ? row.r : null,
        photo: row.ph || null,
        desc: row.d || null,
        maps: row.h || '',
        ranks: Array.isArray(row.rk) ? row.rk : [],
        dayTrip: row.dt === 1,
      };
    });
  }

  function starsOf(p) {
    if (p.tags.has('Michelin ★★★')) return '★★★';
    if (p.tags.has('Michelin ★★')) return '★★';
    if (p.tags.has('Michelin ★')) return '★';
    return '';
  }

  function badgeOf(p) {
    var stars = starsOf(p);
    if (stars) return stars + ' Michelin';
    if (p.ranks.length) return p.ranks[0][0] + ' #' + p.ranks[0][2];
    if (p.tags.has('Michelin Bib Gourmand')) return 'Bib Gourmand';
    if (p.tags.has('UNESCO Site')) return 'UNESCO';
    if (p.tags.has("World's Best Burgers")) return 'Best Burgers';
    return '';
  }

  function previewScore(p) {
    var s = typeof p.rating === 'number' ? p.rating : 3.8;
    if (starsOf(p)) s += 1.4;
    if (p.ranks.length) s += 1.2;
    if (p.photo) s += 0.5;
    if (p.desc) s += 0.2;
    return s;
  }

  function previewCard(p) {
    var badge = badgeOf(p);
    var media = p.photo
      ? '<img src="' + esc(imgUrl(p.photo, 480)) + '" alt="" loading="lazy" decoding="async">'
      : '<span class="mxplan-mono" aria-hidden="true">' +
        esc((p.name || '?').trim().charAt(0).toUpperCase()) +
        '</span>';
    return (
      '<a class="mxplan-card" href="' +
      esc(p.maps) +
      '" target="_blank" rel="noopener nofollow">' +
      '<span class="mxplan-card-media">' +
      media +
      '</span>' +
      '<span class="mxplan-card-name">' +
      esc(p.name) +
      '</span>' +
      '<span class="mxplan-card-meta">' +
      esc(
        [badge, typeof p.rating === 'number' ? '★ ' + p.rating : ''].filter(Boolean).join(' · ')
      ) +
      '</span></a>'
    );
  }

  var DAY_OPTS = { 1: [3, 5, 7], 2: [6, 8, 10], 3: [9, 12, 14], 4: [10, 12, 14] };

  function dayOptsFor(count) {
    return DAY_OPTS[Math.max(1, Math.min(4, count))] || DAY_OPTS[1];
  }

  function daysRowHtml(count, current) {
    return dayOptsFor(count)
      .map(function (d) {
        var on = d === current;
        return (
          '<button type="button" data-mxplan-days="' +
          d +
          '" aria-pressed="' +
          on +
          '"' +
          (on ? ' class="is-on"' : '') +
          '>' +
          d +
          ' days</button>'
        );
      })
      .join('');
  }

  function shellHtml(pool, multi) {
    var lede = multi
      ? 'Most travel guides walk everyone down the same list. Pick a city, tell ours what ' +
        'you’re into and it re-sorts around you — then builds the day-by-day plan, ' +
        'scheduled when places are actually open.'
      : 'Most city guides walk everyone down the same list. Tell ours what you’re into ' +
        'and it re-sorts around you — then builds the day-by-day plan, scheduled when ' +
        'places are actually open.';
    var picker = multi
      ? '<div class="mxplan-metros" data-mxplan-metros role="group" aria-label="Which cities? Tap to add or remove.">' +
        pool
          .map(function (m, i) {
            return (
              '<button type="button" data-mxplan-metro="' +
              esc(m.slug) +
              '" aria-pressed="' +
              (i === 0) +
              '"' +
              (i === 0 ? ' class="is-on"' : '') +
              '>' +
              esc(m.city) +
              '<em>' +
              esc(String(m.n)) +
              ' spots</em></button>'
            );
          })
          .join('') +
        '</div>'
      : '';
    return (
      '<div class="mxplan-head">' +
      '<span class="mxplan-eyebrow">The Trip Builder</span>' +
      '<h2 class="mxplan-title">Make this guide <em>yours</em>.</h2>' +
      '<p class="mxplan-lede">' +
      lede +
      '</p></div>' +
      picker +
      '<div class="mxplan-chips" data-mxplan-tastes role="group" aria-label="What are you into?"></div>' +
      '<div class="mxplan-preview" data-mxplan-preview aria-live="polite"></div>' +
      '<div class="mxplan-foot">' +
      '<div class="mxplan-days" data-mxplan-daysrow role="group" aria-label="How many days?">' +
      daysRowHtml(1, 5) +
      '</div>' +
      '<a class="mxplan-cta" data-mxplan-cta href="#itinerary">Build my 5-day plan &rarr;</a>' +
      '<span class="mxplan-count" data-mxplan-count></span>' +
      '</div>'
    );
  }

  function initOne(box) {
    if (box.getAttribute('data-plan-ready')) return;
    box.setAttribute('data-plan-ready', '1');
    var metroSlug = box.getAttribute('data-plan-metro') || '';
    var countrySlug = box.getAttribute('data-plan-country') || '';
    if (!metroSlug && !countrySlug) return;
    fetchIndex()
      .then(function (idx) {
        if (!box.isConnected) return;
        var metros = (idx && idx.metros) || [];
        var pool = metroSlug
          ? metros.filter(function (m) {
              return m.slug === metroSlug;
            })
          : metros
              .filter(function (m) {
                return m.countrySlug === countrySlug;
              })
              .sort(function (a, b) {
                return (b.n || 0) - (a.n || 0);
              })
              .slice(0, 8);
        if (!pool.length) return; // not plannable — shell stays hidden
        mount(box, pool);
      })
      .catch(function () {
        /* the static page stands alone */
      });
  }

  function mount(box, pool) {
    var multi = pool.length > 1;
    box.innerHTML = shellHtml(pool, multi);
    // sel = ORDERED selection (tap order = travel order, ≤4 cities);
    // metro = the city whose payload feeds the live preview.
    var state = { metro: null, sel: [pool[0]], days: 5, tastes: null, places: [], counts: {} };

    var tasteWrap = box.querySelector('[data-mxplan-tastes]');
    var previewWrap = box.querySelector('[data-mxplan-preview]');
    var countEl = box.querySelector('[data-mxplan-count]');
    var cta = box.querySelector('[data-mxplan-cta]');

    function sync() {
      tasteWrap.querySelectorAll('[data-mxplan-taste]').forEach(function (btn) {
        var on = state.tastes.indexOf(btn.getAttribute('data-mxplan-taste')) >= 0;
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', String(on));
      });
      box.querySelectorAll('[data-mxplan-days]').forEach(function (btn) {
        var on = parseInt(btn.getAttribute('data-mxplan-days'), 10) === state.days;
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', String(on));
      });
      var active = INTERESTS.filter(function (it) {
        return state.tastes.indexOf(it.key) >= 0;
      });
      var matched = state.places.filter(function (p) {
        return active.some(function (it) {
          return it.match(p);
        });
      });
      var top = matched
        .slice()
        .sort(function (a, b) {
          return previewScore(b) - previewScore(a) || (a.name < b.name ? -1 : 1);
        })
        .slice(0, 8);
      previewWrap.innerHTML = top.length
        ? top.map(previewCard).join('')
        : '<p class="mxplan-empty">Pick at least one thing you love.</p>';
      var starred = matched.filter(function (p) {
        return starsOf(p);
      }).length;
      var ranked = matched.filter(function (p) {
        return p.ranks.length;
      }).length;
      countEl.textContent =
        matched.length +
        ' spots match' +
        (starred ? ' · ' + starred + ' starred' : '') +
        (ranked ? ' · ' + ranked + ' list-ranked' : '');
      // Selection state on the metro picker (tap order = travel order).
      box.querySelectorAll('[data-mxplan-metro]').forEach(function (btn) {
        var on = state.sel.some(function (m) {
          return m.slug === btn.getAttribute('data-mxplan-metro');
        });
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', String(on));
      });
      var prefs = state.tastes.join('.');
      var slugs = state.sel
        .map(function (m) {
          return m.slug;
        })
        .join('+');
      cta.setAttribute(
        'href',
        '#itinerary/plan:' + slugs + ':' + state.days + (prefs ? ':' + prefs : '')
      );
      var label =
        state.sel.length > 3
          ? state.sel.length + '-city'
          : state.sel
              .map(function (m) {
                return m.city;
              })
              .join(' + ');
      cta.innerHTML = 'Build my ' + state.days + '-day ' + esc(label) + ' plan &rarr;';
      if (state.sel.length > 1) {
        var totalN = state.sel.reduce(function (n, m) {
          return n + (m.n || 0);
        }, 0);
        countEl.textContent =
          state.sel
            .map(function (m) {
              return m.city;
            })
            .join(' → ') +
          ' · ' +
          totalN +
          ' spots across the trip';
      }
    }

    // Counts and the preview pool cover EVERY selected city — a
    // two-city Italy trip sums Rome + Florence fine dining instead of
    // silently swapping to whichever city was tapped last.
    var loadSeq = 0;
    function selectMetro(metro) {
      state.metro = metro;
      var seq = ++loadSeq;
      var sel = state.sel.slice();
      previewWrap.innerHTML =
        '<p class="mxplan-empty">Reading our ' + esc(metro.city) + ' book…</p>';
      Promise.all(
        sel.map(function (m) {
          return fetchMetro(m.slug);
        })
      )
        .then(function (payloads) {
          if (!box.isConnected || seq !== loadSeq) return;
          var all = [];
          payloads.forEach(function (payload) {
            decodePlaces(payload).forEach(function (p) {
              if (p.kind !== 'hotel' && !p.dayTrip) all.push(p);
            });
          });
          state.places = all;
          state.counts = {};
          INTERESTS.forEach(function (it) {
            state.counts[it.key] = state.places.filter(it.match).length;
          });
          var available = INTERESTS.filter(function (it) {
            return state.counts[it.key] > 0;
          });
          if (available.length < 2) {
            if (!box.hidden) return; // keep an already-open panel working
            box.setAttribute('data-plan-ready', 'thin');
            return;
          }
          // Keep the visitor's picks across a metro switch when they
          // still exist there; otherwise reset to the defaults.
          var keep = (state.tastes || DEFAULT_TASTES).filter(function (k) {
            return state.counts[k] > 0;
          });
          state.tastes = keep.length ? keep : [available[0].key];
          tasteWrap.innerHTML = available
            .map(function (it) {
              return (
                '<button type="button" data-mxplan-taste="' +
                esc(it.key) +
                '" aria-pressed="false">' +
                esc(it.label) +
                '<em>' +
                state.counts[it.key] +
                '</em></button>'
              );
            })
            .join('');
          sync();
          if (box.hidden) {
            box.hidden = false;
            try {
              box.dispatchEvent(new CustomEvent('maxh:plan-ready', { bubbles: true }));
            } catch (_e) {
              /* old browser */
            }
          }
        })
        .catch(function () {
          /* leave whatever state was on screen */
        });
    }

    box.addEventListener('click', function (e) {
      var taste = e.target.closest('[data-mxplan-taste]');
      if (taste) {
        var key = taste.getAttribute('data-mxplan-taste');
        var at = state.tastes.indexOf(key);
        if (at >= 0) {
          if (state.tastes.length > 1) state.tastes.splice(at, 1);
        } else {
          state.tastes.push(key);
        }
        sync();
        return;
      }
      var days = e.target.closest('[data-mxplan-days]');
      if (days) {
        state.days = parseInt(days.getAttribute('data-mxplan-days'), 10) || 5;
        sync();
        return;
      }
      var metroBtn = e.target.closest('[data-mxplan-metro]');
      if (metroBtn) {
        var slug = metroBtn.getAttribute('data-mxplan-metro');
        var m = pool.filter(function (x) {
          return x.slug === slug;
        })[0];
        if (!m) return;
        var at = state.sel.indexOf(m);
        var prevCount = state.sel.length;
        if (at >= 0) {
          if (state.sel.length > 1) state.sel.splice(at, 1);
        } else if (state.sel.length < 4) {
          state.sel.push(m); // tap order = travel order
        }
        if (state.sel.length !== prevCount) {
          var opts = dayOptsFor(state.sel.length);
          state.days = opts[1]; // sensible middle default per city count
          var row = box.querySelector('[data-mxplan-daysrow]');
          if (row) row.innerHTML = daysRowHtml(state.sel.length, state.days);
        }
        var focusMetro = at >= 0 ? state.sel[state.sel.length - 1] : m;
        if (state.sel.length !== prevCount || focusMetro !== state.metro) selectMetro(focusMetro);
        else sync();
      }
    });

    selectMetro(pool[0]);
  }

  function scan() {
    var els = document.querySelectorAll('[data-plan-config]:not([data-plan-ready])');
    for (var i = 0; i < els.length; i++) initOne(els[i]);
  }

  function start() {
    scan();
    if (typeof MutationObserver === 'undefined') return;
    var obs = new MutationObserver(scan);
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

;
/* MAXH_BUNDLER_V1_DEFERRED: src/js/spa/features/trip-tray.js */
// ════════════════════════════════════════════════════════════════════
// src/js/spa/features/trip-tray.js
// ────────────────────────────────────────────────────────────────────
// MAXH_TB_TRAY_V1 — the site-wide trip tray.
//
// Any page can mark a rendered place as pinnable:
//
//   data-tb-id="<place_id>"        exact lookup (payload row id — also
//                                  accepts unesco_<ref> sight ids)
//   data-tb-place="<Name>"        folded-name lookup, with optional
//     data-tb-m="rome-italy"      strict hints — a hinted name that
//     data-tb-country="<slug>"    doesn't match its own metro/country
//     data-tb-cc="IT"             stays unpinnable (no wrong-city pins)
//   data-tb-name="<Label>"        display label override (else
//                                  data-tb-place, else the element text)
//   data-tb-corner                place the + on the host's top-right
//                                  corner (photo cards) instead of inline
//
// This module resolves annotations against /itinerary-pin-map.json
// (lazy, cached, versioned via maxhJsonUrl), injects a "+" button per
// resolvable place, and keeps a localStorage-backed tray pinned to
// document.body — OUTSIDE <main>, because .page's pageFade transform
// would make a fixed child position against the page, and route swaps
// would destroy it. "Build this trip" mints a share-state link with
// pins but NO itinerary (window.maxhTB.encodeState — the Trip
// Builder's own codec); the builder reads an it-less state as a trip
// REQUEST (MAXH_TB_TRAY_HANDOFF_V1) and opens its quiz with cities,
// day count and must-dos pre-answered — the visitor still confirms
// "how long have you got?" before anything generates (multi-metro
// pins become multi-city legs).
//
// Ships in the deferred spa-features bundle: self-init IIFE, initial
// scan + MutationObserver (same lifecycle as plan-configurator.js).
// All name-bearing DOM is built with createElement/textContent — no
// innerHTML interpolation, nothing to escape.
// ════════════════════════════════════════════════════════════════════

(function () {
  'use strict';

  var STORE_KEY = 'maxh.tripbuilder.pins.v1';
  var PIN_CAP = 20; // the share codec's pin ceiling
  var pins = load();
  var tray = null; // {root, badge, route, chips, go, panel, pill}
  var cssPromise = null;
  var scanQueued = false;

  function tb() {
    return window.maxhTB || null;
  }

  function load() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (!raw || raw.v !== 1 || !Array.isArray(raw.pins)) return [];
      return raw.pins
        .filter(function (p) {
          // m may be '' — a metro-less pin (place outside every shipped
          // metro) rides the tray but never forms a leg.
          return (
            p &&
            typeof p.sid === 'string' &&
            /^[a-z0-9]{4,8}$/.test(p.sid) &&
            typeof p.m === 'string' &&
            /^[a-z0-9-]{0,80}$/.test(p.m)
          );
        })
        .slice(0, PIN_CAP)
        .map(function (p) {
          return {
            sid: p.sid,
            m: p.m,
            n: String(p.n || '').slice(0, 80),
            mc: String(p.mc || '').slice(0, 40),
            c: p.c ? 1 : undefined,
            cu: p.cu ? 1 : undefined,
          };
        });
    } catch (_e) {
      return [];
    }
  }

  function save() {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify({ v: 1, pins: pins }));
    } catch (_e) {
      /* private mode — the tray still works for this page view */
    }
  }

  function ensureCss() {
    if (!cssPromise) {
      cssPromise =
        typeof window.loadRouteCSS === 'function'
          ? window.loadRouteCSS('trip-tray')
          : Promise.resolve();
    }
    return cssPromise;
  }

  function fetchPinMap() {
    if (window.__MAXH_TB_PINMAP) return Promise.resolve(window.__MAXH_TB_PINMAP);
    if (window.__MAXH_TB_PINMAP_P) return window.__MAXH_TB_PINMAP_P;
    var url =
      typeof window.maxhJsonUrl === 'function'
        ? window.maxhJsonUrl('/itinerary-pin-map.json')
        : '/itinerary-pin-map.json';
    window.__MAXH_TB_PINMAP_P = fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('pin map ' + res.status);
        return res.json();
      })
      .then(function (map) {
        window.__MAXH_TB_PINMAP = map;
        return map;
      })
      .catch(function (err) {
        window.__MAXH_TB_PINMAP_P = null;
        throw err;
      });
    return window.__MAXH_TB_PINMAP_P;
  }

  // ── resolution ─────────────────────────────────────────────────────

  function resolveHost(map, el) {
    var lib = tb();
    if (!lib) return null;
    var metros = map.metros || [];
    var hints = {
      m: el.getAttribute('data-tb-m') || undefined,
      country: el.getAttribute('data-tb-country') || undefined,
      cc: el.getAttribute('data-tb-cc') || undefined,
    };
    // A place that resolves into no metro payload rides as a CUSTOM
    // stop (wire cu — the builder seats it by name), with an optional
    // data-tb-city metro hint so it lands on the right leg. Synthetic
    // 'z' sid space; no payload row is ever mislabeled, so every place
    // host gets a button (MAXH_TB_CUSTOM_PIN_V1).
    function customRef(label) {
      if (!label || typeof lib.customSid !== 'function') return null;
      var cityHint = el.getAttribute('data-tb-city') || '';
      var seat = cityHint ? lib.resolveMetro(map, cityHint, hints) : null;
      return {
        sid: lib.customSid(label, hints.country || hints.cc || cityHint),
        m: seat ? seat.m : '',
        mc: seat ? seat.mc : '',
        cu: true,
        name: label,
      };
    }
    var id = el.getAttribute('data-tb-id');
    if (id) {
      var hit = (map.ids || {})[id];
      if (hit) {
        var metro = metros[hit[1]];
        if (metro) return { sid: hit[0], m: metro[0], mc: metro[1] || metro[0] };
      }
      return customRef(labelOf(el));
    }
    // A CITY host (cities lists, festival cards): resolve against the
    // payload metro entries — the pin forms a leg, nothing to seat.
    var cityName = el.getAttribute('data-tb-metro-city');
    if (cityName) {
      var cityHit = lib.resolveMetro(map, cityName, {
        m: el.getAttribute('data-tb-m') || undefined,
        country: el.getAttribute('data-tb-country') || undefined,
        cc: el.getAttribute('data-tb-cc') || undefined,
      });
      if (cityHit) return cityHit;
      // No payload metro for this city — the chip still follows the
      // visitor (nothing seats and no leg forms; a mislabel risks
      // nothing, unlike place pins, so cities never go button-less).
      var freeKey =
        'x:' +
        lib.fold(cityName) +
        ':' +
        (el.getAttribute('data-tb-country') || el.getAttribute('data-tb-cc') || '');
      return { sid: lib.citySid(freeKey), m: '', mc: '', city: true };
    }
    var name = el.getAttribute('data-tb-place');
    if (!name) return null;
    return lib.resolvePin(map, name, hints) || customRef(labelOf(el));
  }

  function labelOf(el) {
    var label =
      el.getAttribute('data-tb-name') ||
      el.getAttribute('data-tb-place') ||
      (el.textContent || '').trim();
    return label.replace(/\s+/g, ' ').slice(0, 80);
  }

  function isPinned(sid) {
    return pins.some(function (p) {
      return p.sid === sid;
    });
  }

  // ── the "+" buttons ────────────────────────────────────────────────

  var SVG_NS = 'http://www.w3.org/2000/svg';

  // Crisp stroked icons (currentColor) instead of text glyphs — the
  // fullwidth "＋" character sits off-center in enough font stacks to
  // read as a stray glyph rather than a control.
  function icon(cls, d) {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('class', cls);
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', d);
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '2.6');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    return svg;
  }

  function makeButton(host, ref, label) {
    // A real <button> nested inside a link is invalid HTML and lets the
    // click fall through to navigation on some AT; hosts inside an <a>
    // get a span[role=button] with its own keyboard handling instead.
    var inLink = host.closest('a');
    var btn = document.createElement(inLink ? 'span' : 'button');
    if (inLink) {
      btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '0');
    } else {
      btn.type = 'button';
    }
    btn.className = 'tb-tray-add';
    btn.setAttribute('data-tb-add', ref.sid + ':' + ref.m);
    btn.setAttribute('data-tb-add-name', label);
    btn.setAttribute('data-tb-add-mc', ref.mc);
    // City pins (whole-metro legs, nothing to seat) carry the flag so
    // the wire builder can keep their synthetic sids out of pin[];
    // custom pins ride the wire as cu stops instead of payload sids.
    if (ref.city) btn.setAttribute('data-tb-add-city', '1');
    if (ref.cu) btn.setAttribute('data-tb-add-cu', '1');
    btn.appendChild(icon('tb-add-plus', 'M12 5.5v13M5.5 12h13'));
    btn.appendChild(icon('tb-add-check', 'M5.5 12.5l4.4 4.4L18.5 7.4'));
    paintButton(btn, isPinned(ref.sid), label);
    return btn;
  }

  function paintButton(btn, on, label) {
    var name = label || btn.getAttribute('data-tb-add-name') || 'this place';
    btn.classList.toggle('is-on', !!on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute(
      'aria-label',
      on ? 'In your trip plan — remove ' + name : 'Add ' + name + ' to your trip plan'
    );
    btn.title = on ? 'In your trip plan' : 'Add to trip plan';
  }

  function syncButtons(sid) {
    var sel = sid ? '[data-tb-add^="' + sid + ':"]' : '[data-tb-add]';
    var btns = document.querySelectorAll(sel);
    for (var i = 0; i < btns.length; i++) {
      var ref = btns[i].getAttribute('data-tb-add').split(':')[0];
      paintButton(btns[i], isPinned(ref));
    }
  }

  // ── the tray ───────────────────────────────────────────────────────

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function mountTray() {
    if (tray) return tray;
    var root = el('div', 'tb-tray is-empty');
    root.setAttribute('data-tb-tray', '');
    root.setAttribute('role', 'region');
    root.setAttribute('aria-label', 'Your trip plan');

    var pill = el('button', 'tb-tray-pill');
    pill.type = 'button';
    pill.setAttribute('data-tb-toggle', '');
    pill.setAttribute('aria-expanded', 'false');
    var badge = el('span', 'tb-tray-badge', '0');
    var route = el('span', 'tb-tray-route', '');
    var caret = el('span', 'tb-tray-caret', '▴');
    caret.setAttribute('aria-hidden', 'true');
    pill.appendChild(badge);
    pill.appendChild(el('span', 'tb-tray-k', 'Trip plan'));
    pill.appendChild(route);
    pill.appendChild(caret);

    var panel = el('div', 'tb-tray-panel');
    panel.hidden = true;
    var chips = el('div', 'tb-tray-chips');
    chips.setAttribute('aria-live', 'polite');
    var actions = el('div', 'tb-tray-actions');
    var go = el('a', 'tb-tray-go');
    go.href = '#itinerary';
    go.appendChild(el('span', null, 'Build this trip'));
    go.appendChild(el('span', 'tb-tray-go-arrow', ' →'));
    var clear = el('button', 'tb-tray-clear', 'Clear all');
    clear.type = 'button';
    clear.setAttribute('data-tb-clear', '');
    actions.appendChild(go);
    actions.appendChild(clear);
    panel.appendChild(chips);
    panel.appendChild(actions);

    root.appendChild(pill);
    root.appendChild(panel);
    document.body.appendChild(root);
    tray = {
      root: root,
      pill: pill,
      badge: badge,
      route: route,
      chips: chips,
      go: go,
      panel: panel,
    };
    syncRouteVisibility();
    return tray;
  }

  function routeName() {
    return (window.location.hash || '').replace(/^#\/?/, '').split('?')[0].split('/')[0];
  }

  function syncRouteVisibility() {
    // The builder manages pins itself once you're inside it — the tray
    // would just double the UI there.
    if (tray) tray.root.classList.toggle('is-offroute', routeName() === 'itinerary');
  }

  function renderTray() {
    if (!pins.length && !tray) return; // never mount an empty tray
    var t = mountTray();
    t.root.classList.toggle('is-empty', !pins.length);
    if (!pins.length) {
      t.panel.hidden = true;
      t.pill.setAttribute('aria-expanded', 'false');
      return;
    }
    t.badge.textContent = String(pins.length);
    var lib = tb();
    var legs = lib ? lib.planLegs(pins) : [];
    var names = [];
    for (var i = 0; i < legs.length; i++) {
      var slug = legs[i][0];
      var mc = '';
      for (var j = 0; j < pins.length; j++) {
        if (pins[j].m === slug) {
          mc = pins[j].mc || slug;
          break;
        }
      }
      names.push(mc);
    }
    t.route.textContent = names.join(' → ');
    var wire = lib ? lib.buildWire(pins) : null;
    t.go.href = wire && lib ? '#itinerary/' + lib.encodeState(wire) : '#itinerary';

    t.chips.textContent = '';
    for (var k = 0; k < pins.length; k++) {
      var chip = el('button', 'tb-tray-chip');
      chip.type = 'button';
      chip.setAttribute('data-tb-remove', pins[k].sid);
      var nm = el(
        'span',
        'tb-tray-chip-n',
        (pins[k].cu ? '✦ ' : '') + (pins[k].n || 'Pinned place')
      );
      var where = el('span', 'tb-tray-chip-m', pins[k].mc || (pins[k].cu ? 'custom' : ''));
      var x = el('span', 'tb-tray-chip-x', '✕');
      x.setAttribute('aria-hidden', 'true');
      chip.setAttribute('aria-label', 'Remove ' + (pins[k].n || 'place') + ' from your trip plan');
      chip.appendChild(nm);
      chip.appendChild(where);
      chip.appendChild(x);
      t.chips.appendChild(chip);
    }
  }

  function bump() {
    if (!tray) return;
    tray.root.classList.remove('is-bump');
    void tray.root.offsetWidth; // restart the animation
    tray.root.classList.add('is-bump');
  }

  function nudgeFull() {
    if (!tray) return;
    tray.root.classList.remove('is-full');
    void tray.root.offsetWidth;
    tray.root.classList.add('is-full');
  }

  // ── pin mutations ──────────────────────────────────────────────────

  function addPin(pin) {
    if (isPinned(pin.sid)) return true;
    if (pins.length >= PIN_CAP) {
      nudgeFull();
      return false;
    }
    pins.push(pin);
    save();
    ensureCss().then(function () {
      renderTray();
      bump();
    });
    syncButtons(pin.sid);
    return true;
  }

  function removePin(sid) {
    var before = pins.length;
    pins = pins.filter(function (p) {
      return p.sid !== sid;
    });
    if (pins.length === before) return;
    save();
    renderTray();
    syncButtons(sid);
  }

  function clearPins() {
    if (!pins.length) return;
    var had = pins.map(function (p) {
      return p.sid;
    });
    pins = [];
    save();
    renderTray();
    for (var i = 0; i < had.length; i++) syncButtons(had[i]);
  }

  // ── scan + annotate ────────────────────────────────────────────────

  function scan() {
    var hosts = document.querySelectorAll(
      '[data-tb-id]:not([data-tb-ready]), [data-tb-place]:not([data-tb-ready]), [data-tb-metro-city]:not([data-tb-ready])'
    );
    if (!hosts.length) return;
    // Mark synchronously so a mutation storm doesn't queue the same
    // host twice while the map is in flight.
    var batch = [];
    for (var i = 0; i < hosts.length; i++) {
      hosts[i].setAttribute('data-tb-ready', 'pending');
      batch.push(hosts[i]);
    }
    Promise.all([fetchPinMap(), ensureCss()])
      .then(function (r) {
        var map = r[0];
        for (var j = 0; j < batch.length; j++) {
          var host = batch[j];
          if (!host.isConnected) {
            host.removeAttribute('data-tb-ready');
            continue;
          }
          var ref = resolveHost(map, host);
          if (!ref) {
            host.setAttribute('data-tb-ready', '0');
            continue;
          }
          host.setAttribute('data-tb-ready', '1');
          host.classList.add('tb-host');
          if (host.hasAttribute('data-tb-corner')) host.classList.add('tb-host--corner');
          host.appendChild(makeButton(host, ref, labelOf(host)));
        }
      })
      .catch(function () {
        // Map fetch failed — release the batch so a later scan retries.
        for (var j = 0; j < batch.length; j++) {
          if (batch[j].getAttribute('data-tb-ready') === 'pending') {
            batch[j].removeAttribute('data-tb-ready');
          }
        }
      });
  }

  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    // setTimeout, not requestAnimationFrame: rAF suspends in background
    // tabs, and a route rendered while backgrounded (preview tabs,
    // restored sessions) would never get its buttons until user input.
    setTimeout(function () {
      scanQueued = false;
      scan();
    }, 60);
  }

  // ── wiring ─────────────────────────────────────────────────────────

  function onActivate(target, e) {
    var add = target.closest('[data-tb-add]');
    if (add) {
      e.preventDefault();
      e.stopPropagation();
      var parts = add.getAttribute('data-tb-add').split(':');
      var sid = parts[0];
      if (isPinned(sid)) {
        removePin(sid);
      } else {
        addPin({
          sid: sid,
          m: parts.slice(1).join(':'),
          n: add.getAttribute('data-tb-add-name') || '',
          mc: add.getAttribute('data-tb-add-mc') || '',
          c: add.getAttribute('data-tb-add-city') ? 1 : undefined,
          cu: add.getAttribute('data-tb-add-cu') ? 1 : undefined,
        });
      }
      return true;
    }
    if (!tray || !tray.root.contains(target)) return false;
    var remove = target.closest('[data-tb-remove]');
    if (remove) {
      removePin(remove.getAttribute('data-tb-remove'));
      return true;
    }
    if (target.closest('[data-tb-clear]')) {
      clearPins();
      return true;
    }
    var toggle = target.closest('[data-tb-toggle]');
    if (toggle) {
      var open = tray.panel.hidden;
      tray.panel.hidden = !open;
      tray.pill.setAttribute('aria-expanded', open ? 'true' : 'false');
      tray.root.classList.toggle('is-open', open);
      return true;
    }
    return false;
  }

  // Capture phase: the SPA router's own delegated click handler was
  // registered before this bundle loaded, so a bubble-phase listener
  // here would run AFTER the router already navigated a [data-nav]
  // card the + button sits inside. Capturing intercepts first;
  // stopPropagation keeps the click from ever reaching the router.
  document.addEventListener(
    'click',
    function (e) {
      if (e.target && e.target.closest) onActivate(e.target, e);
    },
    true
  );
  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var t = e.target;
      if (t && t.closest && t.matches && t.matches('.tb-tray-add[role="button"]')) onActivate(t, e);
    },
    true
  );
  window.addEventListener('hashchange', function () {
    syncRouteVisibility();
    queueScan();
  });
  // Another tab edited the plan — mirror it.
  window.addEventListener('storage', function (e) {
    if (e.key !== STORE_KEY) return;
    pins = load();
    renderTray();
    syncButtons();
  });

  function start() {
    if (pins.length) {
      ensureCss().then(function () {
        renderTray();
      });
    }
    scan();
    if (typeof MutationObserver === 'undefined') return;
    var obs = new MutationObserver(queueScan);
    obs.observe(document.body, { childList: true, subtree: true });
  }

  // e2e hook — behavior only, never UI copy.
  window.__maxhTBTray = {
    pins: function () {
      return pins.slice();
    },
    add: addPin,
    remove: removePin,
    clear: clearPins,
    scan: scan,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

;
/* MAXH_BUNDLER_V1_DEFERRED: src/js/spa/features/np-countdown.js */
// ════════════════════════════════════════════════════════════════════
// src/js/spa/features/np-countdown.js
// ────────────────────────────────────────────────────────────────────
// MAXH_NP_COUNTDOWN_V1 — marathon gun-time countdown on the stories
// page's "90° North" card. A polar-night plate with an aurora sheen
// sits on the card photo and ticks down to race.startISO from
// /north_pole.json (the same one-file payload the crew edits
// mid-voyage, so a published gun-time change reaches this card too).
//
// States (data-state on .np-cd):
//   pre  — DD:HH:MM:SS to the gun, blinking separators
//   live — gun fired, pulsing red dot + race elapsed (+H:MM:SS)
//   gone — 12h after the gun the plate unmounts for good; the module
//          is self-retiring and renders nothing on later visits.
//
// Lazy: nothing fetches until the stories route is actually shown
// (hash check at boot + hashchange), so the payload never rides the
// home-page boot. The plate is pointer-events:none garnish inside the
// existing card link and is aria-hidden (the story page carries the
// accessible race copy).
//
// Time source mirrors north-pole-story.js: window.__NP_NOW_ISO or
// sessionStorage 'npNow' pins "now" for tests via the shared
// window.__NP_NOW_BASE anchor, and the clock keeps advancing from the
// pinned instant.
//
// IMPORTANT — this file ships in DEFERRED_JS_BUNDLE (spa-features.js),
// its own IIFE running after DOM parse; the stories grid is already
// rendered by the main inline IIFE by then. window.maxhJsonUrl is
// defined upstream in template.html. No token substitution.
//
// Header comments avoid the literal close-tag forms of s-c-r-i-p-t /
// s-t-y-l-e wrapped in angle brackets. See CLAUDE.md §15.4.
// ════════════════════════════════════════════════════════════════════
(function initNpCountdown() {
  const SLUG = 'north-pole-maxandhailey';
  const LIVE_WINDOW_MS = 12 * 3600e3; // gun + 12h → plate retires
  const page = document.getElementById('page-stories');
  if (!page) return;

  // Simulated-now hook — same contract (and same shared anchor) as
  // npNowMs() in renderers/north-pole-story.js: pin to an ISO instant
  // but keep advancing, so the countdown still ticks under test.
  function nowMs() {
    if (!window.__NP_NOW_BASE) {
      let iso = window.__NP_NOW_ISO || null;
      if (!iso) {
        try {
          iso = sessionStorage.getItem('npNow');
        } catch (_e) {
          /* private mode — real clock */
        }
      }
      const sim = iso ? Date.parse(iso) : NaN;
      window.__NP_NOW_BASE = isNaN(sim)
        ? { real0: 0, sim: 0, live: true }
        : { real0: Date.now(), sim, live: false };
    }
    const b = window.__NP_NOW_BASE;
    return b.live ? Date.now() : b.sim + (Date.now() - b.real0);
  }

  function pad2(n) {
    return (n < 10 ? '0' : '') + n;
  }

  let armed = false;
  function onRoute() {
    const route = (location.hash || '').replace(/^#\/?/, '').split('/')[0];
    if (route !== 'stories' || armed) return;
    armed = true;
    fetch(window.maxhJsonUrl('/north_pole.json'))
      .then((r) => (r.ok ? r.json() : null))
      .then((np) => {
        if (np) mount(np);
      })
      .catch(() => {
        /* offline / payload missing — card just stays plain */
      });
  }
  window.addEventListener('hashchange', onRoute);
  onRoute();

  function mount(np) {
    const race = np.race || {};
    const startMs = Date.parse(race.startISO || '');
    if (!isFinite(startMs)) return;
    // MAXH_NP_ARCHIVE_V1 — once the post-trip archive carries finish
    // times, the plate stops retiring and becomes the results garnish
    // instead (a fourth, terminal state: data-state="done").
    const arc = np.archive && np.archive.enabled === true ? np.archive : null;
    const results = ((arc && arc.raceStory && arc.raceStory.results) || []).filter(
      (r) => r && r.time && r.name
    );
    const done = results.length > 0;
    if (!done && nowMs() >= startMs + LIVE_WINDOW_MS) return; // long over — stay retired

    // Grid card first; hero slot too if the admin ever features it.
    const box =
      page.querySelector('.story-card[data-slug="' + SLUG + '"] .story-img') ||
      page.querySelector('#storiesHeroCard[data-slug="' + SLUG + '"] .stories-hero-img-wrap');
    if (!box || box.querySelector('.np-cd')) return;

    if (done) {
      const root = document.createElement('div');
      root.className = 'np-cd';
      root.setAttribute('aria-hidden', 'true');
      root.dataset.state = 'done';
      root.innerHTML =
        '<span class="np-cd-aurora"></span>' +
        '<span class="np-cd-head">' +
        '<span class="np-cd-dot"></span>' +
        '<span class="np-cd-kicker">North Pole Marathon · finished</span>' +
        '</span>' +
        '<span class="np-cd-res"></span>' +
        '<span class="np-cd-foot"><span class="np-cd-gun">JUL 17 · 90°N</span>' +
        '<span class="np-cd-bibs"></span></span>';
      const resEl = root.querySelector('.np-cd-res');
      results.slice(0, 2).forEach((r) => {
        const row = document.createElement('b');
        row.className = 'np-cd-res-row';
        row.textContent = r.name + ' ' + r.time;
        resEl.appendChild(row);
      });
      const bibsEl = root.querySelector('.np-cd-bibs');
      const bibs = results.map((r) => r.bib).filter((b) => b != null);
      if (bibs.length) bibsEl.textContent = 'BIB ' + bibs.join(' · ');
      box.appendChild(root);
      return;
    }

    const root = document.createElement('div');
    root.className = 'np-cd';
    root.setAttribute('aria-hidden', 'true');
    root.dataset.state = 'pre';
    // Static skeleton only — every dynamic value lands via textContent.
    root.innerHTML =
      '<span class="np-cd-aurora"></span>' +
      '<span class="np-cd-head">' +
      '<span class="np-cd-dot"></span>' +
      '<span class="np-cd-kicker">North Pole Marathon</span>' +
      '</span>' +
      '<span class="np-cd-clock">' +
      '<span class="np-cd-cell"><b>00</b><i>days</i></span>' +
      '<span class="np-cd-sep">:</span>' +
      '<span class="np-cd-cell"><b>00</b><i>hrs</i></span>' +
      '<span class="np-cd-sep">:</span>' +
      '<span class="np-cd-cell"><b>00</b><i>min</i></span>' +
      '<span class="np-cd-sep">:</span>' +
      '<span class="np-cd-cell"><b>00</b><i>sec</i></span>' +
      '</span>' +
      '<span class="np-cd-live"><span class="np-cd-live-lab">Race in progress</span>' +
      '<b class="np-cd-live-t">+0:00:00</b></span>' +
      '<span class="np-cd-foot"><span class="np-cd-gun"></span><span class="np-cd-bibs"></span></span>';

    const digits = root.querySelectorAll('.np-cd-cell b');
    const liveT = root.querySelector('.np-cd-live-t');
    const gunEl = root.querySelector('.np-cd-gun');
    const bibsEl = root.querySelector('.np-cd-bibs');

    // "GUN · JUL 17 · 09:00 CEST" — wall time straight from the
    // ISO string (it carries the race-local offset), label from the
    // payload's own tzLabel. No viewer-timezone math on purpose.
    const MONTHS = [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC',
    ];
    const wall = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(String(race.startISO));
    if (wall) {
      gunEl.textContent =
        'GUN · ' +
        MONTHS[+wall[2] - 1] +
        ' ' +
        +wall[3] +
        ' · ' +
        wall[4] +
        ':' +
        wall[5] +
        (np.tzLabel ? ' ' + np.tzLabel : '') +
        (race.startTbc ? ' · TBC' : '');
    }
    const bibs = (np.runners || []).map((r) => r && r.bib).filter((b) => b != null);
    if (bibs.length) bibsEl.textContent = 'BIB ' + bibs.join(' · ');

    box.appendChild(root);

    function setDigit(el, str) {
      if (el.textContent === str) return;
      el.textContent = str;
      // Retrigger the tick nudge (CSS no-ops it under reduced motion).
      el.classList.remove('is-tick');
      void el.offsetWidth;
      el.classList.add('is-tick');
    }

    let timer = null;
    function render() {
      const now = nowMs();
      const dt = startMs - now;
      if (dt <= -LIVE_WINDOW_MS) {
        // Race is done — retire the plate for good.
        stop();
        root.remove();
        return;
      }
      if (dt <= 0) {
        root.dataset.state = 'live';
        const el = Math.floor(-dt / 1000);
        liveT.textContent =
          '+' +
          Math.floor(el / 3600) +
          ':' +
          pad2(Math.floor((el % 3600) / 60)) +
          ':' +
          pad2(el % 60);
        return;
      }
      const s = Math.floor(dt / 1000);
      setDigit(digits[0], pad2(Math.floor(s / 86400)));
      setDigit(digits[1], pad2(Math.floor((s % 86400) / 3600)));
      setDigit(digits[2], pad2(Math.floor((s % 3600) / 60)));
      setDigit(digits[3], pad2(s % 60));
    }
    function start() {
      if (!timer) timer = setInterval(render, 1000);
      render();
    }
    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    document.addEventListener('visibilitychange', () => {
      document.hidden ? stop() : root.isConnected && start();
    });
    start();
  }
})();
